<template>
  <div class="admin-panel">
    <!-- Modern Header -->
    <div class="panel-header">
      <div class="header-content">
        <div class="logo-section">
          <img src="@/assets/images/logo.png" alt="Modern Kurs Logo" class="header-logo" />
        </div>
        <div class="header-title-section">
      <h1>Yönetici Paneli</h1>
      </div>
      </div>
      <div class="header-actions">
        <a href="/kilavuzlar/admin-kilavuz.pdf" target="_blank" rel="noopener" class="guide-link" title="Yönetici Paneli Kullanım Kılavuzu">
          📖 Kullanım Kılavuzu
        </a>
        <div class="profile-info" @click="openProfileModal">
          <div class="profile-avatar">
            {{ getInitials(currentUser?.ad, currentUser?.soyad) }}
          </div>
          <div class="profile-details">
            <span class="profile-name">{{ currentUser?.ad }} {{ currentUser?.soyad }}</span>
            <span class="profile-role">Yönetici</span>
          </div>
          <div class="profile-arrow">▼</div>
        </div>
      </div>
    </div>

    <!-- Modern Tab Navigation -->
    <div class="tab-navigation">
      <div class="tab-container">
        <button 
          @click="activeTab = 'statistics'" 
          :class="{ active: activeTab === 'statistics' }"
          class="tab-button"
        >
          📊 İstatistikler
        </button>
        <button 
          @click="activeTab = 'appointments'" 
          :class="{ active: activeTab === 'appointments' }"
          class="tab-button"
        >
          📅 Randevular
        </button>
        <button 
          @click="activeTab = 'admin-appointments'" 
          :class="{ active: activeTab === 'admin-appointments' }"
          class="tab-button"
        >
          🎯 Admin Randevu Alma
        </button>
        <button 
          @click="activeTab = 'users'" 
          :class="{ active: activeTab === 'users' }"
          class="tab-button"
        >
          👨‍🎓👩‍🎓 Öğrenciler
        </button>
        <button 
          @click="activeTab = 'teachers'" 
          :class="{ active: activeTab === 'teachers' }"
          class="tab-button"
        >
          👨‍🏫👩‍🏫 Öğretmenler
        </button>
        <button 
          @click="activeTab = 'lessons'" 
          :class="{ active: activeTab === 'lessons' }"
          class="tab-button"
        >
          📚 Dersler
        </button>
        <button 
          @click="activeTab = 'admins'" 
          :class="{ active: activeTab === 'admins' }"
          class="tab-button"
        >
          👑 Yöneticiler
        </button>
        <button
          @click="activeTab = 'system'"
          :class="{ active: activeTab === 'system' }"
          class="tab-button"
        >
          ⚙️ Sistem Yönetimi
        </button>
        <button
          @click="activeTab = 'blogs'"
          :class="{ active: activeTab === 'blogs' }"
          class="tab-button"
        >
          📝 Blog Yönetimi
        </button>
      </div>
      </div>

    <!-- Main Content -->
    <main class="main-content">
      <!-- Dersler Sekmesi -->
      <div v-if="activeTab === 'lessons'" class="tab-content">
        <div class="section-header">
          <h2>📚 Ders Yönetimi</h2>
          <p>Sistemdeki dersleri yönetin ve yeni dersler ekleyin</p>
        </div>
        
        <!-- Modern Ders Ekleme Kartı -->
        <div class="action-card">
          <div class="card-header">
            <h3>➕ Yeni Ders Ekle</h3>
            <p>Yeni bir ders tanımlayarak sisteme ekleyin</p>
          </div>
          
          <div class="form-single-column">
          <div class="form-group">
            <label for="lessonName">Ders Adı</label>
            <input 
              type="text" 
              id="lessonName" 
              v-model="newLesson.name" 
                placeholder="Örn: Matematik, Fizik, Kimya..."
                class="modern-input"
            >
          </div>
            
          <div class="form-group">
            <label for="lessonDescription">Açıklama</label>
            <textarea 
              id="lessonDescription" 
              v-model="newLesson.description" 
                placeholder="Ders hakkında kısa açıklama..."
                class="modern-textarea"
                rows="3"
            ></textarea>
          </div>
          </div>
          
          <div class="form-actions">
          <button 
            @click="createLesson" 
            :disabled="isSubmitting"
              class="btn-primary"
          >
              <span v-if="isSubmitting" class="loading-spinner"></span>
              {{ isSubmitting ? 'Ekleniyor...' : '➕ Ders Ekle' }}
          </button>
          </div>
        </div>

        <!-- Modern Ders Listesi -->
        <div class="data-section">
          <div class="section-header">
            <h3>📋 Mevcut Dersler</h3>
            <div class="section-stats">
              <span class="stat-badge">{{ lessons.length }} Ders</span>
          </div>
        </div>
          
          <div v-if="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Dersler yükleniyor...</p>
      </div>

          <div v-else-if="lessons.length === 0" class="empty-state">
            <div class="empty-icon">📚</div>
            <h4>Henüz ders bulunmamaktadır</h4>
            <p>İlk dersi ekleyerek başlayın</p>
          </div>
          
          <div v-else class="modern-table lessons-table">
            <div class="table-header">
              <div class="table-cell header-cell">Ders Adı</div>
              <div class="table-cell header-cell">Açıklama</div>
              <div class="table-cell header-cell">İşlemler</div>
            </div>

            <div class="table-row" v-for="lesson in lessons" :key="lesson.id">
              <div class="table-cell lesson-name">{{ lesson.name }}</div>
              <div class="table-cell lesson-description">{{ lesson.description || 'Açıklama yok' }}</div>
              <div class="table-cell actions">
                <button @click="editLesson(lesson)" class="btn-edit" title="Düzenle">
                  ✏️
                </button>
                <button @click="deleteLesson(lesson.id)" class="btn-delete" title="Sil">
                  🗑️
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

              <!-- Öğretmenler Sekmesi -->
      <div v-if="activeTab === 'teachers'" class="tab-content">
        <div class="section-header">
                  <h2>👨‍🏫👩‍🏫 Öğretmen Yönetimi</h2>
        <p>Sistemdeki öğretmenleri yönetin ve yeni öğretmenler ekleyin</p>
        </div>
        
        <!-- Modern Öğretmen Ekleme Kartı -->
        <div class="action-card">
          <div class="card-header">
            <h3>➕ Yeni Öğretmen Ekle</h3>
            <p>Yeni bir öğretmen hesabı oluşturun ve ders atayın</p>
          </div>
          
          <div class="form-single-column">
          <div class="form-group">
            <label for="teacherAd">Ad</label>
            <input 
              type="text" 
              id="teacherAd" 
              v-model="newTeacher.ad" 
                placeholder="Örn: Mehmet, Ayşe..."
                class="modern-input"
            >
          </div>
            
          <div class="form-group">
            <label for="teacherSoyad">Soyad</label>
            <input 
              type="text" 
              id="teacherSoyad" 
              v-model="newTeacher.soyad" 
                placeholder="Örn: Yılmaz, Demir..."
                class="modern-input"
            >
          </div>
            
          <div class="form-group">
            <label for="teacherName">Kullanıcı Adı</label>
            <input 
              type="text" 
              id="teacherName" 
              v-model="newTeacher.username" 
                placeholder="h_ ile başlayan kullanıcı adı (örn: h_mehmet)"
                pattern="h_[a-zA-Z0-9]+"
                title="Kullanıcı adı 'h_' ile başlamalı ve sadece İngilizce harf ve rakam içermelidir"
                class="modern-input"
                @input="validateUsername"
            >
            <small class="form-help">Format: h_mehmet, h_ahmet123 (Türkçe karakter kullanmayın)</small>
          </div>
            
          <div class="form-group">
            <label for="teacherPassword">Şifre</label>
            <input 
              type="password" 
              id="teacherPassword" 
              v-model="newTeacher.password" 
                placeholder="Güçlü bir şifre girin"
                class="modern-input"
            >
          </div>
            
          <div class="form-group">
              <label for="teacherLesson">Ders</label>
              <select 
                id="teacherLesson" 
                v-model="newTeacher.lesson_id" 
                required
                class="modern-select"
              >
                <option value="">Ders seçiniz</option>
                <option 
                  v-for="lesson in lessons" 
                  :key="lesson.id" 
                  :value="lesson.id" 
                >
                  {{ lesson.name }}
                </option>
              </select>
              <small>Tek ders seçiniz</small>
          </div>

          <!-- Müsaitlik Takvimi -->
            <div class="form-group availability-section">
            <label>Müsaitlik Takvimi</label>
              <div class="availability-container">
            <TeacherAvailability 
              v-model="newTeacher.availability"
              @update:modelValue="updateTeacherAvailability"
            />
          </div>
            </div>
          </div>
          
          <div class="form-actions">
          <button 
            @click="createTeacher" 
            :disabled="isSubmitting"
              class="btn-primary"
          >
              <span v-if="isSubmitting" class="loading-spinner"></span>
              {{ isSubmitting ? 'Ekleniyor...' : '➕ Öğretmen Ekle' }}
          </button>
          </div>
        </div>

        <!-- Modern Öğretmen Listesi -->
        <div class="data-section">
          <div class="section-header">
            <h3>📋 Mevcut Öğretmenler</h3>
            <div class="section-stats">
              <span class="stat-badge">{{ teachers.length }} Öğretmen</span>
            </div>
          </div>
          
          <div v-if="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Öğretmenler yükleniyor...</p>
          </div>
          
          <div v-else-if="teachers.length === 0" class="empty-state">
            <div class="empty-icon">👨‍🏫👩‍🏫</div>
            <h4>Henüz öğretmen bulunmamaktadır</h4>
            <p>İlk öğretmeni ekleyerek başlayın</p>
          </div>
          <div v-else class="modern-table teachers-table">
            <div class="table-header">
              <div class="table-cell header-cell">Ad Soyad</div>
              <div class="table-cell header-cell">Kullanıcı Adı</div>
              <div class="table-cell header-cell">Ders</div>
              <div class="table-cell header-cell">Müsaitlik</div>
              <div class="table-cell header-cell">İşlemler</div>
            </div>

            <div class="table-row" v-for="teacher in teachers" :key="teacher.id">
              <div class="table-cell teacher-name">{{ teacher.ad || '-' }} {{ teacher.soyad || '-' }}</div>
              <div class="table-cell">{{ teacher.username }}</div>
              <div class="table-cell">
                    <div v-if="teacher.lessons && teacher.lessons.length > 0">
                      <span v-for="lesson in teacher.lessons" :key="lesson.id" class="lesson-tag">
                        {{ lesson.name }}
                      </span>
                    </div>
                    <span v-else class="no-lesson">Ders yok</span>
                    </div>
              <div class="table-cell">
                <div class="availability-buttons">
                  <button 
                    @click="openAvailabilityModal(teacher)"
                    class="btn-view"
                    v-if="teacher.id"
                    title="Müsaitlikleri İncele"
                  >
                    👁️ İncele
                  </button>
                  <button 
                    @click="openEditAvailabilityModal(teacher)"
                    class="btn-edit"
                    v-if="teacher.id"
                    title="Müsaitlikleri Düzenle"
                  >
                    ✏️ Düzenle
                  </button>
                </div>
              </div>
              <div class="table-cell actions">
                <button @click="editTeacher(teacher)" class="btn-edit" title="Düzenle">
                  ✏️
                </button>
                <button 
                  @click="toggleTeacherBlock(teacher)" 
                  :class="teacher.is_blocked ? 'btn-unblock' : 'btn-block'" 
                  :title="teacher.is_blocked ? 'Bloku Kaldır' : 'Blokla'"
                >
                  {{ teacher.is_blocked ? '🔓' : '🔒' }}
                </button>
                <button @click="deleteTeacher(teacher.id)" class="btn-delete" title="Sil">
                  🗑️
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Randevular Sekmesi -->
      <div v-if="activeTab === 'appointments'" class="tab-content">
        <h2>Randevu Yönetimi</h2>
        
        <!-- Randevu Listesi -->
        <div class="list-container">
          <h3>Tüm Randevular</h3>
          <div v-if="isLoading" class="loading">Randevular yükleniyor...</div>
          <div v-else-if="appointments.length === 0" class="no-data">Henüz randevu bulunmamaktadır.</div>
          <div v-else class="weekly-accordion">
            <div 
              v-for="week in weeklyAppointments" 
              :key="`${week.year}-${week.weekNumber}`"
              class="week-accordion-item"
            >
              <!-- Hafta Başlığı -->
              <div 
                class="week-header"
                @click="toggleWeek(week.year, week.weekNumber)"
                :class="{ 'expanded': expandedWeeks[`${week.year}-${week.weekNumber}`] }"
              >
                <div class="week-info">
                  <span class="week-title">
                    {{ formatWeekTitle(week.weekStartDate, week.weekNumber, week.year) }}
                  </span>
                  <span class="appointment-count">
                    {{ week.appointments.length }} randevu
                  </span>
                </div>
                <div class="week-toggle">
                  <i class="fas fa-chevron-down" :class="{ 'rotated': expandedWeeks[`${week.year}-${week.weekNumber}`] }"></i>
                </div>
              </div>

              <!-- Hafta İçeriği (Randevular) -->
              <div 
                v-if="expandedWeeks[`${week.year}-${week.weekNumber}`]"
                class="week-content"
              >
                <div class="data-table">
            <table>
              <thead>
                <tr>
                  <th>Kullanıcı</th>
                  <th>Ders</th>
                        <th>Öğretmen Adı Soyadı</th>
                  <th>Tarih/Saat</th>
                  <th>Durum</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                      <tr v-for="appointment in week.appointments" :key="appointment.id">
                  <td>{{ appointment.user?.username || '-' }}</td>
                  <td>{{ appointment.lesson?.name || getLessonName(appointment.lesson_id) }}</td>
                        <td>{{ getTeacherFullName(appointment.teacher_user_id) }}</td>
                  <td>{{ formatDateTime(appointment.appointment_time) }}</td>
                  <td>
                <span :class="'status-' + appointment.status">{{ getStatusText(appointment.status, appointment.cancelled_by) }}</span>
                  </td>
                  <td>
                    <button 
                      v-if="appointment.status !== 'iptal edildi' && appointment.status !== 'öğrenci katılmadı' && canCancelAppointment(appointment.appointment_time)"
                      @click="cancelAppointment(appointment.id)"
                      class="cancel-button"
                    >
                      İptal Et
                    </button>
                    <button 
                      v-else-if="appointment.status !== 'iptal edildi' && appointment.status !== 'öğrenci katılmadı' && !canCancelAppointment(appointment.appointment_time)"
                      class="cancel-button disabled"
                      disabled
                      title="Randevu saati geçtiği için iptal edilemez"
                    >
                      ⏰ İptal Edilemez
                    </button>
                    <span v-else-if="appointment.status === 'iptal edildi'" class="cancelled-text">İptal Edildi</span>
                    <span v-else-if="appointment.status === 'öğrenci katılmadı'" class="cancelled-text">Öğrenci Katılmadı</span>
                  </td>
                </tr>
              </tbody>
            </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Admin Randevu Alma Sekmesi -->
      <div v-if="activeTab === 'admin-appointments'" class="tab-content">
        <div class="section-header">
          <h2>🎯 Admin Randevu Alma</h2>
          <p>Kısıtlara takılmadan randevu oluşturun</p>
        </div>
        
        <!-- Admin Randevu Alma Formu -->
        <div class="admin-appointment-form">
          <div class="form-header">
            <h3>📝 Randevu Bilgileri</h3>
            <p>Öğrenci, ders, öğretmen ve zaman seçimi yapın</p>
          </div>
          
          <div class="form-grid">
            <!-- Öğrenci Seçimi -->
            <div class="form-group">
              <label for="studentUsername">Öğrenci Numarası *</label>
              <input 
                type="text" 
                id="studentUsername" 
                v-model="adminAppointment.studentUsername" 
                placeholder="4 haneli numara (örn: 1234)"
                class="modern-input"
                @input="searchStudent"
              >
              <div v-if="foundStudent" class="student-info">
                <span class="student-name">{{ foundStudent.ad }} {{ foundStudent.soyad }}</span>
                <span class="student-class">{{ foundStudent.class_code }}</span>
              </div>
            </div>
            
            <!-- Ders Seçimi -->
            <div class="form-group">
              <label for="lessonSelect">Ders *</label>
              <select 
                id="lessonSelect" 
                v-model="adminAppointment.lessonId" 
                class="modern-select"
                @change="onLessonChange"
              >
                <option value="">Ders seçin</option>
                <option v-for="lesson in lessons" :key="lesson.id" :value="lesson.id">
                  {{ lesson.name }}
                </option>
              </select>
            </div>
            
            <!-- Öğretmen Seçimi -->
            <div class="form-group">
              <label for="teacherSelect">Öğretmen *</label>
              <select 
                id="teacherSelect" 
                v-model="adminAppointment.teacherId" 
                class="modern-select"
                :disabled="!adminAppointment.lessonId"
                @change="onTeacherChange"
              >
                <option value="">Önce ders seçin</option>
                <option v-for="teacher in availableTeachers" :key="teacher.id" :value="teacher.id">
                  {{ teacher.ad }} {{ teacher.soyad }}
                </option>
              </select>
            </div>
            
            <!-- Tarih Seçimi -->
            <div class="form-group">
              <label for="appointmentDate">Tarih *</label>
              <input 
                type="date" 
                id="appointmentDate" 
                v-model="adminAppointment.date" 
                class="modern-input"
                @change="onDateChange"
              >
            </div>
            
            <!-- Saat Seçimi -->
            <div class="form-group">
              <label for="timeSlot">Saat *</label>
              <select 
                id="timeSlot" 
                v-model="adminAppointment.timeSlot" 
                class="modern-select"
                :disabled="!adminAppointment.teacherId || !adminAppointment.date"
              >
                <option value="">Önce öğretmen ve tarih seçin</option>
                <option v-for="slot in availableTimeSlots" :key="slot" :value="slot">
                  {{ slot }}
                </option>
              </select>
            </div>
          </div>
          
          <!-- Randevu Özeti -->
          <div v-if="showAppointmentSummary" class="appointment-summary">
            <h4>📋 Randevu Özeti</h4>
            <div class="summary-grid">
              <div class="summary-item">
                <span class="summary-label">Öğrenci:</span>
                <span class="summary-value">{{ foundStudent?.ad }} {{ foundStudent?.soyad }} ({{ adminAppointment.studentUsername }})</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Ders:</span>
                <span class="summary-value">{{ getLessonName(adminAppointment.lessonId) }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Öğretmen:</span>
                <span class="summary-value">{{ getTeacherFullName(adminAppointment.teacherId) }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Tarih & Saat:</span>
                <span class="summary-value">{{ formatAppointmentDateTime(adminAppointment.date, adminAppointment.timeSlot) }}</span>
              </div>
            </div>
          </div>
          
          <!-- Form Actions -->
          <div class="form-actions">
            <button 
              @click="createAdminAppointment" 
              :disabled="!canCreateAppointment || isCreatingAppointment"
              class="btn-primary"
            >
              <span v-if="isCreatingAppointment">Oluşturuluyor...</span>
              <span v-else>🎯 Randevu Oluştur</span>
            </button>
            <button @click="resetAdminAppointmentForm" class="btn-secondary">
              🔄 Formu Temizle
            </button>
          </div>
        </div>
      </div>

      <!-- Öğrenciler Sekmesi -->
      <div v-if="activeTab === 'users'" class="tab-content">
        <h2>Öğrenci Yönetimi</h2>
        
        <!-- Toplu Öğrenci Yükleme -->
        <div class="bulk-upload-container">
          <h3>📁 Toplu Öğrenci Yükleme</h3>
          <div class="bulk-upload-info">
            <p>Excel dosyası ile toplu öğrenci kaydı yapabilirsiniz.</p>
            <div class="excel-template-info">
              <h4>Excel Dosya Formatı:</h4>
              <ul>
                <li><strong>ÖĞRENCİ NO:</strong> 4 haneli sayı (örn: 1234)</li>
                <li><strong>AD:</strong> Öğrenci adı</li>
                <li><strong>SOYAD:</strong> Öğrenci soyadı</li>
                <li><strong>SINIF KODU:</strong> Sınıf kodu (örn: 9A, 10B)</li>
                <li><strong>EV TEL:</strong> Telefon numarası (5xxxxxxxxx)</li>
              </ul>
            </div>
            <div class="file-upload-section">
              <input 
                type="file" 
                ref="excelFileInput"
                @change="handleFileSelect"
                accept=".xlsx,.xls"
                class="file-input"
              >
              <button 
                @click="uploadExcelFile" 
                :disabled="!selectedFile || isUploading"
                class="upload-button"
              >
                {{ isUploading ? 'Yükleniyor...' : 'Excel Dosyasını Yükle' }}
              </button>
            </div>
            <div v-if="selectedFile" class="selected-file">
              <span>📎 Seçilen dosya: {{ selectedFile.name }}</span>
              <button @click="clearFileSelection" class="clear-file-btn">❌</button>
            </div>
          </div>
        </div>
        
        <!-- Yeni Öğrenci Ekleme Formu -->
        <div class="form-container">
          <h3>Yeni Öğrenci Ekle</h3>
          <div class="form-group">
            <label for="userAd">Ad</label>
            <input 
              type="text" 
              id="userAd" 
              v-model="newUser.ad" 
              placeholder="Ad girin"
            >
          </div>
          <div class="form-group">
            <label for="userSoyad">Soyad</label>
            <input 
              type="text" 
              id="userSoyad" 
              v-model="newUser.soyad" 
              placeholder="Soyad girin"
            >
          </div>
          <div class="form-group">
            <label for="userName">Kullanıcı Adı (Öğrenci numarası)</label>
            <input 
              type="text" 
              id="userName" 
              v-model="newUser.username" 
              placeholder="4 haneli sayı girin (örn: 1234)"
              @input="validateStudentUsername"
            >
            <small class="form-help">Sadece rakam kullanın</small>
          </div>
          <div class="form-group">
            <label for="userPassword">Şifre</label>
            <input 
              type="password" 
              id="userPassword" 
              v-model="newUser.password" 
              placeholder="Şifre girin"
            >
          </div>
          <div class="form-group">
            <label for="userPhone">Telefon Numarası *</label>
            <input 
              type="tel" 
              id="userPhone" 
              v-model="newUser.phone" 
              placeholder="5xxxxxxxxx (10 haneli)"
              pattern="5[0-9]{9}"
              required
            >
          </div>
          <div class="form-group">
            <label for="userClassCode">Sınıf Kodu *</label>
            <input 
              type="text" 
              id="userClassCode" 
              v-model="newUser.class_code" 
              placeholder="Sınıf kodunu girin (örn: 9A, 10B)"
              required
            >
          </div>
          <button 
            @click="createUser" 
            :disabled="isSubmitting"
            class="submit-button"
          >
            {{ isSubmitting ? 'Ekleniyor...' : 'Öğrenci Ekle' }}
          </button>
        </div>

        <!-- Öğrenci Listesi -->
        <div class="list-container">
          <div class="list-header">
          <h3>Mevcut Öğrenciler</h3>
            <div class="header-buttons">
              <button 
                @click="exportStudentsToExcel" 
                :disabled="isExporting || users.length === 0"
                class="export-button"
              >
                <span class="export-icon">📊</span>
                <span v-if="!isExporting">Excel Olarak Dışa Aktar</span>
                <span v-else>Dışa Aktarılıyor...</span>
              </button>
              <button 
                @click="showDeleteAllStudentsConfirmPopup" 
                :disabled="users.length === 0"
                class="delete-all-button"
              >
                <span class="delete-icon">🗑️</span>
                Tüm Öğrencileri Sil
              </button>
            </div>
          </div>
          <div v-if="isLoading" class="loading">Öğrenciler yükleniyor...</div>
          <div v-else-if="users.length === 0" class="no-data">Henüz öğrenci bulunmamaktadır.</div>
          <div v-else class="data-table">
            <table>
              <thead>
                <tr>
                  <th>Ad</th>
                  <th>Soyad</th>
                  <th>Kullanıcı Adı</th>
                  <th>Telefon</th>
                  <th>Sınıf Kodu</th>
                  <th>Kayıt Tarihi</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in users" :key="user.id">
                  <td>{{ user.ad || '-' }}</td>
                  <td>{{ user.soyad || '-' }}</td>
                  <td>{{ user.username }}</td>
                  <td>{{ user.phone || '-' }}</td>
                  <td>{{ user.class_code || '-' }}</td>
                  <td>{{ formatDate(user.created_at) }}</td>
                  <td>
                    <button @click="editUser(user)" class="edit-button">Düzenle</button>
                    <button @click="deleteUser(user.id)" class="delete-button">Sil</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <!-- Yukarı Çık Butonu -->
          <button 
            v-show="showScrollToTop"
            @click="scrollToTop"
            class="scroll-to-top-button"
            title="Yukarı Çık"
          >
            <svg class="scroll-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
            </svg>
          </button>
        </div>
      </div>



      <!-- Sistem Yönetimi Sekmesi -->
      <div v-if="activeTab === 'system'" class="tab-content">
        <h2>🔄 Sistem Yönetimi</h2>
        
        <div class="system-management-grid">
          <div class="info-card">
            <h3>📊 Sistem Durumu</h3>
            <div v-if="systemStatus" class="status-info">
              <div class="status-row">
                <span class="status-label">Sistem Durumu:</span>
                <span :class="['status-value', 'status-' + systemStatus.status]">
                  {{ getSystemStatusText(systemStatus.status) }}
                </span>
              </div>
              <div class="status-row" v-if="systemStatus.status === 'preparing'">
                <span class="status-label">Açılışa Kalan:</span>
                <span class="status-value countdown">
                  {{ formatTimeUntilOpen(systemStatus.time_until_open) }}
                </span>
              </div>
              <div class="status-row">
                <span class="status-label">Sonraki Açılış:</span>
                <span class="status-value">{{ formatDateTime(systemStatus.next_opening_time) }}</span>
              </div>
              <div class="status-row">
                <span class="status-label">Son Reset:</span>
                <span class="status-value">{{ formatDateTime(systemStatus.last_reset_time) }}</span>
              </div>
              <div class="status-row">
                <span class="status-label">Mesaj:</span>
                <span class="status-value">{{ systemStatus.message }}</span>
              </div>
            </div>
            <div v-else class="loading">Sistem durumu yükleniyor...</div>
          </div>

          <div class="reset-info">
            <h3>📋 Reset Bilgileri</h3>
            <div class="info-grid">
              <div class="info-item">
                <h4>🕐 Otomatik Reset</h4>
                					<p>Her Pazar günü saat 19:00'da otomatik olarak çalışır</p>
                <ul>
                  <li>Alınan randevular müsait duruma döner</li>
                  <li>Müsaitlik takvimi temizlenir</li>
                  <li>Yeni hafta için hazır hale gelir</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Slot Ayarları alt bölümü (aynı tab-content'in devamı) -->
        <h2 class="subsection-title">⏱️ Slot Ayarları</h2>
        <p class="subsection-desc">Randevu slot süresi, blok araları ve öğle arası (hafta içi + hafta sonu ayrı).</p>

        <div class="settings-info">
          <strong>💡 Öneri:</strong> Slot ayarlarını <strong>Pazar 19:00'dan sonra</strong> (haftalık reset saati, yeni haftaya geçiş) yapmanız daha güvenli. O saatte randevu alımı kapalıdır, hocalar yeni ayarlarla müsaitliklerini rahatça girebilir.
        </div>

        <div v-if="!slotSettingsForm" class="loading">Ayarlar yükleniyor...</div>

        <form v-else @submit.prevent="submitSlotSettings" class="slot-settings-form">
          <div class="slot-settings-grid">
            <!-- Hafta İçi -->
            <div class="settings-card">
              <h3>📅 Hafta İçi</h3>
              <div class="form-group">
                <label>Slot Süresi (dk)</label>
                <input type="number" min="5" max="120" v-model.number="slotSettingsForm.slot_duration_weekday" required />
              </div>
              <div class="form-group">
                <label>Blok Arası Mola (dk)</label>
                <input type="number" min="0" max="60" v-model.number="slotSettingsForm.break_duration_weekday" required />
              </div>
              <div class="form-group">
                <label>Gün Başlangıç</label>
                <input type="time" v-model="slotSettingsForm.day_start_weekday" required />
              </div>
              <div class="form-group">
                <label>Gün Bitiş</label>
                <input type="time" v-model="slotSettingsForm.day_end_weekday" required />
              </div>
              <div class="form-group">
                <label>Öğle Arası Başlangıç</label>
                <input type="time" v-model="slotSettingsForm.lunch_start_weekday" required />
              </div>
              <div class="form-group">
                <label>Öğle Arası Bitiş</label>
                <input type="time" v-model="slotSettingsForm.lunch_end_weekday" required />
              </div>
            </div>

            <!-- Hafta Sonu -->
            <div class="settings-card">
              <h3>🌅 Hafta Sonu</h3>
              <div class="form-group">
                <label>Slot Süresi (dk)</label>
                <input type="number" min="5" max="120" v-model.number="slotSettingsForm.slot_duration_weekend" required />
              </div>
              <div class="form-group">
                <label>Blok Arası Mola (dk)</label>
                <input type="number" min="0" max="60" v-model.number="slotSettingsForm.break_duration_weekend" required />
              </div>
              <div class="form-group">
                <label>Gün Başlangıç</label>
                <input type="time" v-model="slotSettingsForm.day_start_weekend" required />
              </div>
              <div class="form-group">
                <label>Gün Bitiş</label>
                <input type="time" v-model="slotSettingsForm.day_end_weekend" required />
              </div>
              <div class="form-group">
                <label>Öğle Arası Başlangıç</label>
                <input type="time" v-model="slotSettingsForm.lunch_start_weekend" required />
              </div>
              <div class="form-group">
                <label>Öğle Arası Bitiş</label>
                <input type="time" v-model="slotSettingsForm.lunch_end_weekend" required />
              </div>
            </div>
          </div>

          <div class="settings-warning">
            <strong>⚠️ Uyarı:</strong> Kaydettiğinde tüm öğretmenlerin müsaitlikleri silinecek. Öğretmenlerin müsaitliklerinin yeniden girilmesi gerekir.
          </div>

          <div class="form-actions">
            <button type="submit" class="btn-primary" :disabled="slotSettingsSaving">
              {{ slotSettingsSaving ? 'Kaydediliyor...' : 'Kaydet' }}
            </button>
          </div>
        </form>

        <!-- Onay Dialog -->
        <div v-if="showSlotConfirmDialog" class="modal-overlay" @click.self="showSlotConfirmDialog = false">
          <div class="modal-content">
            <h3>Değişikliği Onayla</h3>
            <p>Slot ayarlarını değiştirmek üzeresiniz. Bu işlem <strong>TÜM öğretmenlerin müsaitliklerini silecek</strong>. Onaylıyor musunuz?</p>
            <div class="modal-actions">
              <button @click="showSlotConfirmDialog = false" class="btn-secondary">İptal</button>
              <button @click="confirmSlotSettingsSave" class="btn-danger">Evet, Kaydet ve Sil</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Blog Yönetimi Sekmesi -->
      <div v-if="activeTab === 'blogs'" class="tab-content">
        <AdminBlog />
      </div>

      <!-- İstatistikler Sekmesi -->
      <div v-if="activeTab === 'statistics'" class="tab-content">
        <div class="section-header">
          <h2>📊 Sistem İstatistikleri</h2>
          <p>Genel sistem performansı ve kullanım istatistikleri</p>
        </div>
        
        <!-- Loading State -->
        <div v-if="isLoadingStatistics" class="loading-state">
          <div class="loading-spinner"></div>
          <p>İstatistikler yükleniyor...</p>
        </div>

        <!-- Error State -->
        <div v-else-if="statisticsError" class="error-state">
          <div class="error-icon">⚠️</div>
          <h3>Hata Oluştu</h3>
          <p>{{ statisticsError }}</p>
          <button @click="fetchAdminStatistics" class="btn-retry">🔄 Tekrar Dene</button>
        </div>

        <!-- Statistics Content -->
        <div v-else-if="adminStatistics" class="statistics-content">
          <!-- Overview Cards -->
          <div class="overview-cards">
            <div class="stat-card total-students">
              <div class="stat-icon">👥</div>
              <div class="stat-content">
                <span class="stat-number">{{ adminStatistics.overview.total_students }}</span>
                <span class="stat-label">Toplam Öğrenci</span>
              </div>
            </div>
            
            <div class="stat-card total-teachers">
              <div class="stat-icon">👨‍🏫👩‍🏫</div>
              <div class="stat-content">
                <span class="stat-number">{{ adminStatistics.overview.total_teachers }}</span>
                <span class="stat-label">Toplam Öğretmen</span>
              </div>
            </div>
            
            <div class="stat-card total-appointments">
              <div class="stat-icon">📅</div>
              <div class="stat-content">
                <span class="stat-number">{{ adminStatistics.overview.total_appointments }}</span>
                <span class="stat-label">Toplam Randevu</span>
              </div>
            </div>
            
            <div class="stat-card current-week">
              <div class="stat-icon">📊</div>
              <div class="stat-content">
                <span class="stat-number">{{ adminStatistics.overview.current_week_appointments }}</span>
                <span class="stat-label">Bu Hafta</span>
              </div>
            </div>
          </div>

          <!-- All Time Champions Section -->
          <div class="champions-section">
            <h2>👑 Tüm Zamanların Şampiyonları</h2>
            <div class="champions-grid">
              <div class="champion-card student-champion">
                <div class="champion-crown">👑</div>
                <div class="champion-icon">👥</div>
                <div class="champion-info">
                  <h3>En Aktif Öğrenci</h3>
                  <div class="champion-name">{{ getTopStudent?.student_name || 'Veri Yok' }}</div>
                  <div class="champion-stats">
                    <span class="total-appointments">{{ getTopStudent?.appointment_count || 0 }} randevu</span>
                  </div>
                </div>
              </div>
              
              <div class="champion-card teacher-champion">
                <div class="champion-crown">👑</div>
                <div class="champion-icon">👨‍🏫👩‍🏫</div>
                <div class="champion-info">
                                          <h3>En Aktif Öğretmen</h3>
                  <div class="champion-name">{{ getTopTeacher?.teacher_name || 'Veri Yok' }}</div>
                  <div class="champion-stats">
                    <span class="total-appointments">{{ getTopTeacher?.appointment_count || 0 }} randevu</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Top Performers Section -->
          <div class="top-performers">
            <div class="top-students">
              <h2>🏆 En Aktif Öğrenciler</h2>
              <div class="performer-list">
                <div v-for="(student, index) in adminStatistics.top_students" :key="student.student_id" class="performer-item">
                  <div class="rank">{{ index + 1 }}</div>
                  <div class="performer-info">
                    <span class="name">{{ student.student_name }}</span>
                    <span class="count">{{ student.appointment_count }} randevu</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="top-teachers">
                                      <h2>🏆 En Aktif Öğretmenler</h2>
              <div class="performer-list">
                <div v-for="(teacher, index) in adminStatistics.top_teachers" :key="teacher.teacher_id" class="performer-item">
                  <div class="rank">{{ index + 1 }}</div>
                  <div class="performer-info">
                    <span class="name">{{ teacher.teacher_name }}</span>
                    <span class="count">{{ teacher.appointment_count }} randevu</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Weekly Statistics Chart -->
          <div class="chart-section">
            <h2>📈 Tüm Haftalar - Randevu Sayıları</h2>
            <div class="weekly-chart">
              <div v-for="week in weeklyStats" :key="week.week_start" class="week-bar">
                <div class="bar-container">
                  <div 
                    class="bar" 
                    :style="{ height: getBarHeight(week.appointment_count) }"
                    :title="`${week.appointment_count} randevu`"
                  >
                    <!-- Randevu sayısı bar'ın üzerinde -->
                    <div class="bar-count">{{ week.appointment_count }}</div>
                  </div>
                </div>
                <div class="week-label">
                  <span class="week-number">{{ week.week_number }}. Hafta</span>
                  <span class="week-date">{{ formatWeekDate(week.week_start) }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Weekly Statistics Table -->
          <div class="table-section">
            <h2>📋 Haftalık Detaylar</h2>
            <div class="weekly-accordion">
              <div v-for="week in weeklyStats" :key="week.week_start" class="week-accordion-item">
                <div class="accordion-header" @click="toggleWeekAccordion(week.week_start)">
                  <div class="week-info">
                    <span class="week-number">{{ week.week_number }}. Hafta</span>
                    <span class="week-date">{{ formatWeekDate(week.week_start) }}</span>
                  </div>
                  <div class="week-summary">
                    <span class="total-count">{{ week.appointment_count }} randevu</span>
                    <div class="accordion-arrow" :class="{ 'expanded': expandedWeeks[week.week_start] }">
                      ▼
                    </div>
                  </div>
                </div>
                
                <div v-if="expandedWeeks[week.week_start]" class="accordion-content">
                  <div class="week-details">
                    <!-- Öğrenci İstatistikleri -->
                    <div class="student-stats">
                      <h4>👥 Öğrenci İstatistikleri</h4>
                      <div class="stats-grid">
                        <div v-for="student in week.student_stats" :key="student.student_id" class="stat-item">
                          <div class="stat-rank">{{ student.rank }}</div>
                          <div class="stat-details">
                            <span class="stat-name">{{ student.student_name }}</span>
                            <span class="stat-count">{{ student.appointment_count }} randevu</span>
                          </div>
                        </div>
                        <div v-if="!week.student_stats || week.student_stats.length === 0" class="no-data">
                          Bu hafta öğrenci randevusu bulunamadı
                        </div>
                      </div>
                    </div>
                    
                    <!-- Öğretmen İstatistikleri -->
                    <div class="teacher-stats">
                                              <h4>👨‍🏫👩‍🏫 Öğretmen İstatistikleri</h4>
                      <div class="stats-grid">
                        <div v-for="teacher in week.teacher_stats" :key="teacher.teacher_id" class="stat-item">
                          <div class="stat-rank">{{ teacher.rank }}</div>
                          <div class="stat-details">
                            <span class="stat-name">{{ teacher.teacher_name }}</span>
                            <span class="stat-count">{{ teacher.appointment_count }} randevu</span>
                          </div>
                        </div>
                        <div v-if="!week.teacher_stats || week.teacher_stats.length === 0" class="no-data">
                          Bu hafta öğretmen randevusu bulunamadı
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Gelişmiş İstatistikler ve Filtreleme -->
          <div class="advanced-statistics-section">
            <h2>🔍 Gelişmiş İstatistikler ve Filtreleme</h2>
            <p>Tüm istatistikler için gelişmiş filtreleme, arama ve sıralama özellikleri</p>
            
            <!-- Filtreleme ve Arama Kontrolleri -->
            <div class="filter-controls">
              <div class="filter-row">
                <!-- Tarih Aralığı Filtresi -->
                <div class="filter-group">
                  <label>📅 Başlangıç Tarihi: (Dahil)</label>
                  <input 
                    type="date" 
                    v-model="filterStartDate" 
                    class="filter-input"
                  />
                </div>
                
                <div class="filter-group">
                  <label>📅 Bitiş Tarihi: (Dahil Değil)</label>
                  <input 
                    type="date" 
                    v-model="filterEndDate" 
                    class="filter-input"
                  />
                </div>
                
                <!-- Kullanıcı Tipi Filtresi -->
                <div class="filter-group">
                  <label>👤 Kullanıcı Tipi:</label>
                  <select v-model="filterUserType" class="filter-select">
                    <option value="">Tümü</option>
                    <option value="student">Öğrenci</option>
                    <option value="teacher">Öğretmen</option>
                  </select>
                </div>
              </div>
              
              <div class="filter-row">
                <!-- İsim Soyisim Arama -->
                <div class="filter-group">
                  <label>🔍 İsim Soyisim:</label>
                  <input 
                    type="text" 
                    v-model="filterName" 
                    placeholder="İsim veya soyisim girin..."
                    class="filter-input"
                  />
                </div>
                
                <!-- Kullanıcı Adı Arama -->
                <div class="filter-group">
                  <label>🔍 Kullanıcı Adı:</label>
                  <input 
                    type="text" 
                    v-model="filterUsername" 
                    placeholder="Kullanıcı adı girin..."
                    class="filter-input"
                  />
                </div>
                
                <!-- Sıralama -->
                <div class="filter-group">
                  <label>📊 Sıralama:</label>
                  <select v-model="sortBy" class="filter-select">
                    <option value="appointment_count_desc">Randevu Sayısı (Azalan)</option>
                    <option value="appointment_count_asc">Randevu Sayısı (Artan)</option>
                    <option value="name_asc">İsim (A-Z)</option>
                    <option value="name_desc">İsim (Z-A)</option>
                    <option value="username_asc">Kullanıcı Adı (A-Z)</option>
                    <option value="username_desc">Kullanıcı Adı (Z-A)</option>
                    <option value="absent_count_desc">Katılmadı (Azalan)</option>
                    <option value="absent_count_asc">Katılmadı (Artan)</option>
                  </select>
                </div>
              </div>
              
              <!-- Filtreleri Temizle ve Export Butonları -->
              <div class="filter-actions">
                <button @click="clearFilters" class="btn-clear-filters">
                  🗑️ Filtreleri Temizle
                </button>
                
                <button @click="applyFilters" class="btn-apply-filters">
                  🔍 Filtrele
                </button>
                
                <div class="export-buttons">
                  <button @click="exportToExcel" class="btn-export-excel" :disabled="isExporting">
                    📊 Excel'e Aktar
                  </button>
                </div>
              </div>
            </div>
            
            <!-- Filtrelenmiş Sonuçlar Tablosu -->
            <div class="filtered-results">
              <div class="results-header">
                <h3>📋 Filtrelenmiş Sonuçlar</h3>
                <span class="results-count">{{ filteredStatistics?.length || 0 }} sonuç bulundu</span>
              </div>
              
              <!-- Loading State -->
              <div v-if="isLoadingFiltered" class="loading-state">
                <div class="loading-spinner"></div>
                <p>Sonuçlar yükleniyor...</p>
              </div>
              
              <!-- Results Table -->
              <div v-else-if="filteredStatistics?.length > 0" class="results-table-container">
                <table class="results-table">
                  <thead>
                    <tr>
                      <th>👤 Kullanıcı Tipi</th>
                      <th>👤 İsim Soyisim</th>
                      <th>🔑 Kullanıcı Adı</th>
                      <th>📅 Toplam Randevu</th>
                      <th>❌ Katılmadı</th>
                      <th>📈 En Aktif Hafta</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="stat in paginatedStatistics" :key="`${stat.user_type}_${stat.user_id}`" class="result-row">
                      <td>
                        <span class="user-type-badge" :class="stat.user_type">
                          {{ stat.user_type === 'student' ? '👥 Öğrenci' : '👨‍🏫👩‍🏫 Öğretmen' }}
                        </span>
                      </td>
                      <td>{{ stat.full_name }}</td>
                      <td>{{ stat.username }}</td>
                      <td>
                        <span class="appointment-count">{{ stat.total_appointments }}</span>
                      </td>
                      <td>
                        <span v-if="stat.user_type === 'student' && stat.absent_count !== null" class="absent-count">
                          {{ stat.absent_count }}
                        </span>
                        <span v-else class="absent-count-na">-</span>
                      </td>
                      <td>{{ formatWeekDate(stat.most_active_week) }}</td>
                    </tr>
                  </tbody>
                </table>
                
                <!-- Pagination -->
                <div class="pagination">
                  <button 
                    @click="goToFirstPage" 
                    :disabled="currentPage === 1"
                    class="btn-pagination btn-first-page"
                    title="İlk Sayfa"
                  >
                    ⏮️ İlk
                  </button>
                  
                  <button 
                    @click="previousPage" 
                    :disabled="currentPage === 1"
                    class="btn-pagination"
                  >
                    ← Önceki
                  </button>
                  
                  <span class="page-info">
                    Sayfa {{ currentPage }} / {{ totalPages }}
                  </span>
                  
                  <button 
                    @click="nextPage" 
                    :disabled="currentPage === totalPages"
                    class="btn-pagination"
                  >
                    Sonraki →
                  </button>
                  
                  <button 
                    @click="goToLastPage" 
                    :disabled="currentPage === totalPages"
                    class="btn-pagination btn-last-page"
                    title="Son Sayfa"
                  >
                    Son ⏭️
                  </button>
                </div>
              </div>
              
              <!-- No Results -->
              <div v-else class="no-results">
                <div class="no-results-icon">🔍</div>
                <h4>Sonuç Bulunamadı</h4>
                <p>Seçilen filtrelerle eşleşen sonuç bulunamadı. Filtreleri değiştirmeyi deneyin.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- No Data State -->
        <div v-else class="no-data-state">
          <div class="no-data-icon">📊</div>
          <h3>Henüz İstatistik Yok</h3>
          <p>Sistemde henüz randevu bulunmuyor.</p>
        </div>
      </div>

      <!-- Yöneticiler Sekmesi -->
      <div v-if="activeTab === 'admins'" class="tab-content">
        <div class="section-header">
          <h2>👑 Yönetici Yönetimi</h2>
          <p>Sistem yöneticilerini yönetin ve yeni yöneticiler ekleyin</p>
        </div>
        
        <!-- Modern Yönetici Ekleme Kartı -->
        <div class="action-card">
          <div class="card-header">
            <h3>➕ Yeni Yönetici Ekle</h3>
            <p>Yeni bir yönetici hesabı oluşturun</p>
          </div>
          
          <form @submit.prevent="createAdmin" class="form-single-column">
            <div class="form-group">
              <label for="adminUsername">Kullanıcı Adı *</label>
              <input 
                type="text" 
                id="adminUsername" 
                v-model="newAdmin.username" 
                placeholder="a_yonetici"
                pattern="^a_[a-zA-Z0-9]+$"
                title="Kullanıcı adı 'a_' ile başlamalı ve sadece İngilizce harf, rakam içerebilir"
                required
                @input="validateAdminUsername"
              />
              <small class="form-hint">Kullanıcı adı 'a_' ile başlamalıdır (örn: a_yonetici) - Türkçe karakter kullanmayın</small>
            </div>
            
            <div class="form-group">
              <label for="adminAd">Ad *</label>
              <input 
                type="text" 
                id="adminAd" 
                v-model="newAdmin.ad" 
                placeholder="Yönetici adı"
                required
              />
            </div>
            
            <div class="form-group">
              <label for="adminSoyad">Soyad *</label>
              <input 
                type="text" 
                id="adminSoyad" 
                v-model="newAdmin.soyad" 
                placeholder="Yönetici soyadı"
                required
              />
            </div>
            
            <div class="form-group">
              <label for="adminPassword">Şifre *</label>
              <input 
                type="password" 
                id="adminPassword" 
                v-model="newAdmin.password" 
                placeholder="Güçlü şifre girin"
                minlength="6"
                required
              />
              <small class="form-hint">En az 6 karakter olmalıdır</small>
            </div>
            
            <div class="form-actions">
              <button type="submit" :disabled="isCreatingAdmin" class="btn-primary">
                <span v-if="!isCreatingAdmin">👑 Yönetici Ekle</span>
                <span v-else>⏳ Ekleniyor...</span>
              </button>
            </div>
          </form>
        </div>

        <!-- Mevcut Yöneticiler Listesi -->
        <div class="section-content">
          <div class="list-header">
            <h3>Mevcut Yöneticiler</h3>
          </div>
          
          <!-- Loading State -->
          <div v-if="isLoadingAdmins" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Yöneticiler yükleniyor...</p>
          </div>
          
          <!-- Error State -->
          <div v-else-if="adminsError" class="error-state">
            <div class="error-icon">⚠️</div>
            <h3>Hata Oluştu</h3>
            <p>{{ adminsError }}</p>
            <button @click="refreshAdmins" class="btn-retry">🔄 Tekrar Dene</button>
          </div>
          
          <!-- Empty State -->
          <div v-else-if="admins.length === 0" class="empty-state">
            <div class="empty-icon">👑</div>
            <h3>Henüz Yönetici Yok</h3>
            <p>Sistemde henüz yönetici hesabı bulunmuyor.</p>
          </div>
          
          <!-- Admins Table -->
          <div v-else class="table-container admins-list">
            <div class="table-header">
              <div class="table-cell header-cell">Kullanıcı Adı</div>
              <div class="table-cell header-cell">Ad Soyad</div>
              <div class="table-cell header-cell">Oluşturulma Tarihi</div>
              <div class="table-cell header-cell">İşlemler</div>
            </div>

            <div v-for="admin in admins" :key="admin.id" class="table-row">
              <div class="table-cell admin-username">{{ admin.username }}</div>
              <div class="table-cell admin-name">{{ admin.ad }} {{ admin.soyad }}</div>
              <div class="table-cell">{{ formatDate(admin.created_at) }}</div>
              <div class="table-cell actions-cell">
                <button 
                  @click="editAdmin(admin)" 
                  class="btn-edit"
                  title="Düzenle"
                >
                  ✏️
                </button>
                <button 
                  @click="deleteAdmin(admin)" 
                  class="btn-delete"
                  title="Sil"
                  :disabled="admin.id === currentUser?.id"
                >
                  🗑️
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- Modal Bileşenleri -->
    
    <!-- Profil Modal -->
    <div v-if="showProfileModal" class="modal-overlay" @click="showProfileModal = false">
      <div class="modal-content profile-modal" @click.stop>
        <div class="modal-header">
          <h3>👤 Profil Bilgileri</h3>
          <button @click="showProfileModal = false" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <div class="profile-section">
            <div class="profile-avatar-large">
              {{ getInitials(currentUser?.ad, currentUser?.soyad) }}
            </div>
            <div class="profile-actions">
            <button @click="logout" class="logout-button">
              🚪 Çıkış Yap
            </button>
          </div>
            <div class="profile-info-grid">
              <div class="info-item">
                <label>Ad Soyad:</label>
                <span>{{ currentUser?.ad }} {{ currentUser?.soyad }}</span>
              </div>
              <div class="info-item">
                <label>Kullanıcı Adı:</label>
                <span>{{ currentUser?.username }}</span>
              </div>
              <div class="info-item">
                <label>Rol:</label>
                <span class="role-badge">👨‍💼 Yönetici</span>
              </div>

            </div>
          </div>
          
          <div class="profile-stats">
            <div class="stat-card">
              <div class="stat-icon">📚</div>
              <div class="stat-content">
                <span class="stat-number">{{ lessons.length }}</span>
                <span class="stat-label">Toplam Ders</span>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">👨‍🏫👩‍🏫</div>
              <div class="stat-content">
                <span class="stat-number">{{ teachers.length }}</span>
                <span class="stat-label">Toplam Öğretmen</span>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">👨‍🎓👩‍🎓</div>
              <div class="stat-content">
                <span class="stat-number">{{ users.length }}</span>
                <span class="stat-label">Toplam Öğrenci</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Ders Düzenleme Modal -->
    <div v-if="showLessonModal" class="modal-overlay" @click="closeLessonModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Ders Düzenle</h3>
          <button @click="closeLessonModal" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateLesson">
            <div class="form-group">
              <label>Ders Adı:</label>
              <input v-model="editingLesson.name" type="text" required>
            </div>
            <div class="form-group">
              <label>Açıklama:</label>
              <textarea v-model="editingLesson.description"></textarea>
            </div>
            <div class="modal-actions">
              <button type="submit" :disabled="isSubmitting" class="btn-primary">Güncelle</button>
              <button type="button" @click="closeLessonModal" class="btn-secondary">İptal</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Öğretmen Düzenleme Modal -->
    <div v-if="showTeacherModal" class="modal-overlay" @click="closeTeacherModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Öğretmen Düzenle</h3>
          <button @click="closeTeacherModal" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateTeacher">
            <div class="form-group">
              <label>Ad:</label>
              <input v-model="editingTeacher.ad" type="text" required>
            </div>
            <div class="form-group">
              <label>Soyad:</label>
              <input v-model="editingTeacher.soyad" type="text" required>
            </div>
            <div class="form-group">
              <label>Kullanıcı Adı:</label>
              <input 
                v-model="editingTeacher.username" 
                type="text" 
                pattern="h_[a-zA-Z0-9]+"
                title="Kullanıcı adı 'h_' ile başlamalı ve sadece harf ve rakam içermelidir"
                required
              >
              <small class="form-help">Format: h_mehmet, h_ahmet123</small>
            </div>
            <div class="form-group">
              <label>Şifre (Boş bırakılırsa değişmez):</label>
              <input v-model="editingTeacher.password" type="password" placeholder="Yeni şifre">
            </div>
            <div class="form-group">
              <label>Ders:</label>
              <select 
                v-model="editingTeacher.lesson_id" 
                required
                class="form-select"
              >
                <option value="">Ders seçiniz</option>
                <option 
                  v-for="lesson in lessons" 
                  :key="lesson.id" 
                    :value="lesson.id" 
                >
                  {{ lesson.name }}
                </option>
              </select>
              <small>Tek ders seçiniz</small>
            </div>


            <div class="modal-actions">
              <button type="submit" :disabled="isSubmitting" class="btn-primary">Güncelle</button>
              <button type="button" @click="closeTeacherModal" class="btn-secondary">İptal</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Öğrenci Düzenleme Modal -->
    <div v-if="showUserModal" class="modal-overlay" @click="closeUserModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Öğrenci Düzenle</h3>
          <button @click="closeUserModal" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateUser">
            <div class="form-group">
              <label>Ad:</label>
              <input v-model="editingUser.ad" type="text" required>
            </div>
            <div class="form-group">
              <label>Soyad:</label>
              <input v-model="editingUser.soyad" type="text" required>
            </div>
            <div class="form-group">
              <label>Kullanıcı Adı:</label>
              <input v-model="editingUser.username" type="text" readonly disabled>
              <small>Kullanıcı adı değiştirilemez</small>
            </div>
            <div class="form-group">
              <label>Şifre (Boş bırakılırsa değişmez):</label>
              <input v-model="editingUser.password" type="password" placeholder="Yeni şifre">
            </div>
            <div class="form-group">
              <label>Telefon Numarası:</label>
              <input v-model="editingUser.phone" type="tel" placeholder="5xxxxxxxxx (10 haneli)" pattern="5[0-9]{9}" required>
            </div>
            <div class="form-group">
              <label>Sınıf Kodu:</label>
              <input v-model="editingUser.class_code" type="text" placeholder="Sınıf kodunu girin (örn: 9A, 10B)" required>
            </div>
            <div class="modal-actions">
              <button type="submit" :disabled="isSubmitting" class="btn-primary">Güncelle</button>
              <button type="button" @click="closeUserModal" class="btn-secondary">İptal</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Yönetici Düzenleme Modal -->
    <div v-if="showAdminModal" class="modal-overlay" @click="closeAdminModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Yönetici Düzenle</h3>
          <button @click="closeAdminModal" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateAdmin">
            <div class="form-group">
              <label>Ad: <span class="required">*</span></label>
              <input v-model="editingAdmin.ad" type="text" required>
            </div>
            <div class="form-group">
              <label>Soyad: <span class="required">*</span></label>
              <input v-model="editingAdmin.soyad" type="text" required>
            </div>
            <div class="form-group">
              <label>Kullanıcı Adı: <span class="required">*</span></label>
              <input 
                v-model="editingAdmin.username" 
                type="text" 
                pattern="^a_[a-zA-ZğüşıöçĞÜŞİÖÇ0-9]+$"
                title="Kullanıcı adı 'a_' ile başlamalı ve sadece harf, rakam içerebilir"
                required
              >
              <small class="form-help">Format: a_yonetici, a_admin123</small>
            </div>
            <div class="form-group">
              <label>Şifre (Boş bırakılırsa değişmez):</label>
              <input v-model="editingAdmin.password" type="password" placeholder="Yeni şifre">
            </div>
            <div class="modal-actions">
              <button type="submit" :disabled="isSubmitting" class="btn-primary">Güncelle</button>
              <button type="button" @click="closeAdminModal" class="btn-secondary">İptal</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Müsaitlik Görüntüleme Modal -->
    <div v-if="showAvailabilityModal" class="modal-overlay" @click="closeAvailabilityModal">
      <div class="modal-content availability-modal" @click.stop>
        <div class="modal-header">
          <h3>{{ selectedTeacher?.ad }} {{ selectedTeacher?.soyad }} - Müsaitlik Bilgileri</h3>
          <button @click="closeAvailabilityModal" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <TeacherAvailabilityDisplay 
            :teacherId="selectedTeacher?.id"
            :viewMode="'view'"
            :refresh="refreshAvailability"
            class="modal-view"
            v-if="selectedTeacher?.id"
          />
        </div>
        <div class="modal-actions">
          <button type="button" @click="closeAvailabilityModal" class="btn-secondary">Kapat</button>
        </div>
      </div>
    </div>

    <!-- Müsaitlik Düzenleme Modal -->
    <div v-if="showEditAvailabilityModal" class="modal-overlay" @click="closeEditAvailabilityModal">
      <div class="modal-content availability-modal" @click.stop>
        <div class="modal-header">
          <h3>{{ selectedTeacher?.ad }} {{ selectedTeacher?.soyad }} - Müsaitlik Düzenle</h3>
          <button @click="closeEditAvailabilityModal" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <TeacherAvailabilityDisplay 
            ref="editAvailabilityComponent"
            :teacherId="selectedTeacher?.id"
            :viewMode="'edit'"
            :refresh="refreshAvailability"
            class="modal-view"
            v-if="selectedTeacher?.id"
          />
        </div>
        <div class="modal-actions">
          <button type="button" @click="saveAvailabilityChanges" class="btn-primary">Kaydet</button>
          <button type="button" @click="closeEditAvailabilityModal" class="btn-secondary">Kapat</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Hata Modal -->
  <div v-if="error" class="error-modal-overlay" @click="closeErrorModal">
    <div class="error-modal-content" @click.stop>
      <div class="error-modal-header">
        <div class="error-icon">⚠️</div>
        <h3>Hata Oluştu</h3>
        <button @click="closeErrorModal" class="modal-close">&times;</button>
      </div>
      <div class="error-modal-body">
        <div class="error-content">
          <div class="error-main-message">
            <p>{{ getErrorMainMessage() }}</p>
          </div>
          <div v-if="getErrorDetails().length > 0" class="error-details">
            <h4>Detaylar:</h4>
            <div class="error-details-list">
              <div v-for="(detail, index) in getErrorDetails()" :key="index" class="error-detail-item">
                <span class="error-detail-number">{{ index + 1 }}.</span>
                <span class="error-detail-text">{{ detail }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="error-modal-actions">
        <button @click="closeErrorModal" class="btn-primary">Tamam</button>
      </div>
    </div>
  </div>

  <!-- Başarılı İşlem Popup -->
  <div v-if="showSuccessPopup" class="success-popup-overlay" @click="closeSuccessPopup">
    <div class="success-popup" @click.stop>
      <div class="success-popup-header">
        <div class="success-icon">✅</div>
        <h3>{{ successTitle }}</h3>
      </div>
      <div class="success-popup-body">
        <p>{{ successMessage }}</p>
      </div>
      <div class="success-popup-actions">
        <button @click="closeSuccessPopup" class="btn-success">
          Tamam
        </button>
      </div>
    </div>
  </div>

  <!-- Silme Onay Popup -->
  <div v-if="showDeleteConfirmPopup" class="delete-confirm-popup-overlay" @click="cancelDelete">
    <div class="delete-confirm-popup" @click.stop>
      <div class="delete-confirm-popup-header">
        <div class="delete-icon">⚠️</div>
        <h3>Silme Onayı</h3>
      </div>
      <div class="delete-confirm-popup-body">
        <p v-if="deleteConfirmType === 'lesson'">
          <strong>{{ deleteConfirmData?.name }}</strong> dersini silmek istediğinizden emin misiniz?
        </p>
        <p v-else-if="deleteConfirmType === 'teacher'">
          <strong>{{ deleteConfirmData?.name }}</strong> öğretmenini silmek istediğinizden emin misiniz?
        </p>
        <p v-else-if="deleteConfirmType === 'user'">
          <strong>{{ deleteConfirmData?.name }}</strong> öğrencisini silmek istediğinizden emin misiniz?
        </p>
        <p class="warning-text">
          Bu işlem geri alınamaz.
        </p>
      </div>
      <div class="delete-confirm-popup-actions">
        <button @click="cancelDelete" class="btn-cancel">
          İptal
        </button>
        <button @click="confirmDelete" class="btn-delete-confirm">
          Evet, Sil
        </button>
      </div>
    </div>
  </div>

  <!-- Randevu İptal Onay Popup -->
  <div v-if="showCancelAppointmentPopup" class="cancel-appointment-popup-overlay" @click="cancelCancelAppointment">
    <div class="cancel-appointment-popup" @click.stop>
      <div class="cancel-appointment-popup-header">
        <div class="cancel-icon">❌</div>
        <h3>Randevu İptal Onayı</h3>
      </div>
      <div class="cancel-appointment-popup-body">
        <div class="appointment-info">
          <p><strong>Öğrenci:</strong> {{ cancelAppointmentData?.studentName }}</p>
          <p><strong>Öğretmen:</strong> {{ cancelAppointmentData?.teacherName }}</p>
          <p><strong>Ders:</strong> {{ cancelAppointmentData?.lessonName }}</p>
          <p><strong>Tarih:</strong> {{ formatAppointmentDate(cancelAppointmentData?.date) }}</p>
        </div>
        <p class="warning-text">
          Bu randevuyu iptal etmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
        </p>
      </div>
      <div class="cancel-appointment-popup-actions">
        <button @click="cancelCancelAppointment" class="btn-cancel">
          İptal Etme
        </button>
        <button @click="confirmCancelAppointment" class="btn-cancel-confirm">
          Evet, İptal Et
        </button>
      </div>
    </div>
  </div>

  <!-- Tüm Öğrencileri Sil Onay Popup -->
  <div v-if="showDeleteAllStudentsConfirm" class="logout-confirm-popup-overlay" @click="cancelDeleteAllStudents">
    <div class="logout-confirm-popup" @click.stop>
      <div class="logout-confirm-popup-header">
        <div class="logout-icon">⚠️</div>
        <h3>Dikkat! Tüm Öğrenciler Silinecek</h3>
      </div>
      <div class="logout-confirm-popup-body">
        <p><strong>Bu işlem geri alınamaz!</strong></p>
        <p>Önce tüm öğrenci randevuları silinecek, sonra tüm öğrenci kullanıcıları silinecek.</p>
        <p>Toplam <strong>{{ users.length }}</strong> öğrenci silinecek.</p>
        <p>Devam etmek istediğinizden emin misiniz?</p>
      </div>
      <div class="logout-confirm-popup-actions">
        <button @click="cancelDeleteAllStudents" class="btn-cancel">
          İptal
        </button>
        <button @click="confirmDeleteAllStudents" class="btn-logout-confirm delete-all-confirm">
          Evet, Tümünü Sil
        </button>
      </div>
    </div>
  </div>

  <!-- Çıkış Onay Popup -->
  <div v-if="showLogoutConfirmPopup" class="logout-confirm-popup-overlay" @click="cancelLogout">
    <div class="logout-confirm-popup" @click.stop>
      <div class="logout-confirm-popup-header">
        <div class="logout-icon">🚪</div>
        <h3>Çıkış Onayı</h3>
      </div>
      <div class="logout-confirm-popup-body">
        <p>Çıkış yapmak istediğinizden emin misiniz?</p>
      </div>
      <div class="logout-confirm-popup-actions">
        <button @click="cancelLogout" class="btn-cancel">
          İptal
        </button>
        <button @click="confirmLogout" class="btn-logout-confirm">
          Evet, Çıkış Yap
        </button>
      </div>
    </div>
  </div>
  
  <!-- Modern System Ready Confirmation Modal -->
  <div v-if="showSystemReadyModal" class="modal-overlay" @click="closeSystemReadyModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <div class="modal-icon">🚀</div>
        <h3>Sistemi Hazır Moda Alma</h3>
        <button class="modal-close" @click="closeSystemReadyModal">×</button>
      </div>
      
      <div class="modal-body">
        <div class="warning-section">
          <div class="warning-icon">⚠️</div>
          <div class="warning-content">
            <h4>Dikkat!</h4>
            <p>Bu işlem öğrencilerin randevu almasına izin verecektir.</p>
          </div>
        </div>
        
        <div class="info-section">
          <div class="info-icon">ℹ️</div>
          <div class="info-content">
            <h4>Ne olacak?</h4>
            <ul>
              <li>Öğrenciler randevu almaya başlayabilecek</li>
              <li>Mevcut müsaitlik durumları korunacak</li>
              <li>Sistem otomatik olarak hazır moda geçecek</li>
            </ul>
          </div>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="btn-cancel" @click="closeSystemReadyModal">
          İptal
        </button>
        <button class="btn-confirm" @click="confirmSystemReady" :disabled="isSettingReady">
          <span v-if="isSettingReady">İşleniyor...</span>
          <span v-else>Evet, Sistemi Hazır Yap</span>
        </button>
      </div>
    </div>
  </div>
  
  <!-- Modern Manual Weekly Reset Confirmation Modal -->
  <div v-if="showManualResetModal" class="modal-overlay" @click="closeManualResetModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <div class="modal-icon">🔄</div>
        <h3>Manuel Haftalık Reset</h3>
        <button class="modal-close" @click="closeManualResetModal">×</button>
      </div>
      
      <div class="modal-body">
        <div class="danger-section">
          <div class="danger-icon">🚨</div>
          <div class="danger-content">
            <h4>Kritik Uyarı!</h4>
            <p>Bu işlem tüm alınan randevuları müsait duruma çevirecektir ve <strong>geri alınamaz!</strong></p>
          </div>
        </div>
        
        <div class="warning-section">
          <div class="warning-icon">⚠️</div>
          <div class="warning-content">
            <h4>Dikkat!</h4>
            <ul>
              <li>Tüm mevcut randevular iptal edilecek</li>
              <li>Öğrenciler tekrar randevu alabilecek</li>
              <li>Bu işlem geri alınamaz</li>
              <li>Sistem 1 saat sonra randevu almaya açılacak</li>
            </ul>
          </div>
        </div>
        
        <div class="info-section">
          <div class="info-icon">ℹ️</div>
          <div class="info-content">
            <h4>Ne zaman kullanılır?</h4>
            <ul>
              <li>Haftalık program değişikliklerinde</li>
              <li>Sistem sorunlarında</li>
              <li>Yeni dönem başlangıcında</li>
            </ul>
          </div>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="btn-cancel" @click="closeManualResetModal">
          İptal
        </button>
        <button class="btn-danger" @click="confirmManualReset" :disabled="isResetting">
          <span v-if="isResetting">İşleniyor...</span>
          <span v-else>Evet, Reset Yap</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import axios from 'axios'
import { isoWeek } from '@/utils/week'
import TeacherAvailability from '@/components/TeacherAvailability.vue'
import TeacherAvailabilityDisplay from '@/components/TeacherAvailabilityDisplay.vue'
import AdminBlog from '@/views/AdminBlog.vue'

// Axios base URL'ini ayarla
axios.defaults.baseURL = 'https://api.modernkurs.com'

// Axios interceptor tamamen kaldırıldı - güvenlik açığı
// axios.interceptors.request.use(function (config) {
//   console.log('Axios isteği:', config.method?.toUpperCase(), config.url)
//   return config
// }, function (error) {
//   return Promise.reject(error)
// })

export default {
  name: 'AdminPanelView',
  components: {
    TeacherAvailability,
    TeacherAvailabilityDisplay,
    AdminBlog
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    
    const activeTab = ref('statistics')
    const isLoading = ref(false)
    const isSubmitting = ref(false)
    const error = ref('')
    
    // Başarı popup değişkenleri
    const showSuccessPopup = ref(false)
    const successMessage = ref('')
    const successTitle = ref('')
    
    // Silme onay popup değişkenleri
    const showDeleteConfirmPopup = ref(false)
    const deleteConfirmData = ref(null)
    const deleteConfirmType = ref('')
    
    // Randevu iptal onay popup değişkenleri
    const showCancelAppointmentPopup = ref(false)
    const cancelAppointmentData = ref(null)
    
    // Çıkış onay popup değişkenleri
    const showLogoutConfirmPopup = ref(false)
    
    // Tüm öğrencileri sil onay popup değişkenleri
    const showDeleteAllStudentsConfirm = ref(false)
    const isDeletingAllStudents = ref(false)
    
    // Sistem hazır modal değişkenleri
    const showSystemReadyModal = ref(false)
    
    // Manuel reset modal değişkenleri
    const showManualResetModal = ref(false)
    
    // Toplu yükleme değişkenleri
    const selectedFile = ref(null)
    const isUploading = ref(false)
    const excelFileInput = ref(null)
    
    // Excel export değişkenleri
    const isExporting = ref(false)
    
    // İstatistik değişkenleri
    const isLoadingStatistics = ref(false)
    const statisticsError = ref('')
    const adminStatistics = ref(null)
    
    // Veri kaynakları
    const lessons = computed(() => store.getters.getLessons)
    const teachers = computed(() => store.getters.getTeachers)
    const appointments = computed(() => {
      // Admin için tüm randevuları göster
      const allAppointments = store.state.appointments['all'] || []
      
      return allAppointments
    })
    const users = computed(() => {
      const usersData = store.getters.getUsers
      
      return usersData
    }) // Yeni eklenen kullanıcılar
    const currentUser = computed(() => store.getters.getCurrentUser)

            // Yeni ders ve öğretmen formları
    const newLesson = ref({ name: '', description: '' })
    const newTeacher = ref({ ad: '', soyad: '', username: '', password: '', lesson_id: '', availability: {} })
    const newUser = ref({ ad: '', soyad: '', username: '', password: '', phone: '', class_code: '' }) // Yeni eklenen kullanıcı formu

    // Düzenleme durumu için yeni ref'ler
    const editingLesson = ref(null)
    const editingTeacher = ref(null)
    const editingUser = ref(null) // Yeni eklenen kullanıcı düzenleme durumu

    // Modal durumları
    const showLessonModal = ref(false)
    const showTeacherModal = ref(false)
    const showUserModal = ref(false)
    const showAvailabilityModal = ref(false)
    const showEditAvailabilityModal = ref(false)
    const showProfileModal = ref(false)
    const selectedTeacher = ref(null)
    const editAvailabilityComponent = ref(null)
    const refreshAvailability = ref(false)

    // Sistem yönetimi durumları
    const isResetting = ref(false)

    const systemStatus = ref(null)
    const isSettingReady = ref(false)

    // Slot ayarları form state
    const slotSettingsForm = ref(null)
    const slotSettingsSaving = ref(false)
    const showSlotConfirmDialog = ref(false)

    const loadSlotSettings = async () => {
      const result = await store.dispatch('fetchSlotSettings')
      if (result.success) {
        slotSettingsForm.value = { ...result.data }
      }
    }

    const submitSlotSettings = () => {
      const f = slotSettingsForm.value
      if (f.slot_duration_weekday <= 0 || f.slot_duration_weekend <= 0) {
        error.value = 'Slot süresi 0\'dan büyük olmalı.'
        return
      }
      // Aralık: giriş < öğle_başı < öğle_sonu < çıkış
      const ranges = [
        { label: 'hafta içi', ds: f.day_start_weekday, ls: f.lunch_start_weekday, le: f.lunch_end_weekday, de: f.day_end_weekday },
        { label: 'hafta sonu', ds: f.day_start_weekend, ls: f.lunch_start_weekend, le: f.lunch_end_weekend, de: f.day_end_weekend }
      ]
      for (const r of ranges) {
        if (!(r.ds < r.ls && r.ls < r.le && r.le < r.de)) {
          error.value = `Saatler sırayla artmalı (${r.label}): Gün Başlangıç < Öğle Başlangıç < Öğle Bitiş < Gün Bitiş.`
          return
        }
      }
      showSlotConfirmDialog.value = true
    }

    const confirmSlotSettingsSave = async () => {
      showSlotConfirmDialog.value = false
      slotSettingsSaving.value = true
      const result = await store.dispatch('updateSlotSettings', slotSettingsForm.value)
      slotSettingsSaving.value = false
      if (result.success) {
        slotSettingsForm.value = { ...result.data.settings }
        if (result.data.settings_changed === false) {
          successTitle.value = 'ℹ️ Değişiklik Yok'
          successMessage.value = 'Ayarlar zaten kayıtlı değerlerle aynıydı. Öğretmen müsaitlikleri korundu.'
        } else {
          successTitle.value = '⏱️ Slot Ayarları Güncellendi'
          successMessage.value = `Ayarlar başarıyla kaydedildi. ${result.data.cleared_availability_rows} öğretmen müsaitlik kaydı sıfırlandı. Öğretmenlerin müsaitliklerinin yeniden girilmesi gerekiyor.`
        }
        showSuccessPopup.value = true
      } else {
        error.value = result.error || 'Slot ayarları kaydedilemedi'
      }
    }

    // Yönetici yönetimi değişkenleri
    const admins = ref([])
    const isLoadingAdmins = ref(false)
    const adminsError = ref('')
    const isCreatingAdmin = ref(false)
    const showAdminModal = ref(false)
    const editingAdmin = ref(null)
    const newAdmin = ref({ username: '', ad: '', soyad: '', password: '' })

    // Admin Appointment Booking
    const adminAppointment = ref({
      studentUsername: '',
      lessonId: '',
      teacherId: '',
      date: '',
      timeSlot: ''
    })
    
    // Blog yönetimi ayrı bir bileşene taşındı (views/AdminBlog.vue)
    const foundStudent = ref(null)
    const availableTeachers = ref([])
    const availableTimeSlots = ref([])
    const showAppointmentSummary = ref(false)
    const isCreatingAppointment = ref(false)

    // Scroll-to-top değişkenleri
    const showScrollToTop = ref(false)
    
    // Gelişmiş İstatistik Filtreleme değişkenleri
    const filterStartDate = ref('')
    const filterEndDate = ref('')
    const filterUserType = ref('')
    const filterName = ref('')
    const filterUsername = ref('')
    const sortBy = ref('appointment_count_desc')
    const filteredStatistics = ref([])
    const isLoadingFiltered = ref(false)
    const currentPage = ref(1)
    const itemsPerPage = ref(20)

    // Admin bilgilerini yükle
    const loadAdminInfo = async () => {
      try {
        // Önce token geçerliliğini kontrol et
        const isTokenValid = await store.dispatch('checkTokenValidity')
        if (!isTokenValid) {
          console.error('❌ Geçersiz token')
          router.push('/login')
          return
        }
        
        // Local storage'dan admin bilgisini al
        const userStr = localStorage.getItem('user')
        if (userStr) {
          const userData = JSON.parse(userStr)
          
          // Rol kontrolü - sadece admin erişebilir (backend'den gelen 'admin' rolü)
          if (userData.role !== 'admin') {
            console.error('❌ Yetkisiz erişim: Admin olmayan kullanıcı admin paneline erişmeye çalışıyor')
            error.value = 'Bu sayfaya erişim yetkiniz bulunmamaktadır. Sadece yöneticiler erişebilir.'
            pendingRedirect.value = '/login'
            return
          }
          
          // Store'a admin bilgisini set et
          store.commit('setCurrentUser', userData)
          
        } else {
          console.error('❌ Local storage\'da admin bilgisi bulunamadı')
          // Login sayfasına yönlendir
          router.push('/login')
        }
      } catch (error) {
        console.error('❌ Admin bilgileri yüklenirken hata:', error)
        router.push('/login')
      }
    }

    // Sekme değiştiğinde ilgili verileri yükle
    watch(activeTab, (newTab) => {
      loadTabData(newTab)

      // İstatistik sekmesi seçildiğinde verileri yükle
      if (newTab === 'statistics') {
        fetchAdminStatistics()
        // İlk yüklemede tüm kayıtları getir
        applyFilters()
      }

      // Sistem yönetimi sekmesi seçildiğinde slot ayarları form'unu da yükle
      // (Slot Ayarları artık ayrı bir tab değil; Sistem Yönetimi altında.)
      if (newTab === 'system') {
        loadSlotSettings()
      }
    })

    // Öğretmen düzenleme modal'ı açıldığında müsaitlik bilgilerini yükle
    watch(showTeacherModal, async (isOpen) => {
      if (isOpen && editingTeacher.value?.id) {
        
        
        try {
          // Mevcut hafta için müsaitlik bilgilerini getir
          const currentWeekStart = getWeekStartDate(new Date())
          const weekStartStr = currentWeekStart.toISOString().split('T')[0]
          
          const availabilityResult = await store.dispatch('fetchTeacherAvailability', {
            teacherId: editingTeacher.value.id,
            weekStart: weekStartStr
          })
          
          if (availabilityResult.success) {
            // Yeni veri yapısından eski yapıya dönüştür
            const weekData = availabilityResult.data
            if (weekData.availability) {
              // Eski format: { "monday": ["08:00-08:40"], "tuesday": ["09:40-10:20"] }
              const oldFormat = {}
              Object.keys(weekData.availability).forEach(day => {
                oldFormat[day] = weekData.availability[day].map(slot => slot.time_slot)
              })
              editingTeacher.value.availability = oldFormat
              
            }
          } else {
            console.warn('Müsaitlik bilgileri yüklenemedi:', availabilityResult.error)
          }
        } catch (err) {
          console.error('Müsaitlik bilgileri yüklenirken hata:', err)
        }
      }
    })



    onMounted(async () => {
      // Sadece admin panelinde çalışsın
      if (router.currentRoute.value.path !== '/panel/admin') {
        return
      }
      
      // Admin bilgilerini yükle
      await loadAdminInfo()
      
      // Sistem durumunu yükle (eğer sistem sekmesi aktifse)
      if (activeTab.value === 'system') {
        await loadSystemStatus()
      }
      
      // İstatistik sekmesi aktifse istatistikleri yükle
      if (activeTab.value === 'statistics') {
        await fetchAdminStatistics()
        await applyFilters()
      }
      
      // İlk sekmenin verilerini yükle
      await loadTabData(activeTab.value)
      
      // Admin için tüm randevuları da yükle
      await store.dispatch('fetchAllAppointments')
      
      // Admin randevu alma için gerekli verileri de yükle
      await store.dispatch('fetchLessons')
      await store.dispatch('fetchTeachers')
      await store.dispatch('fetchUsers')
      
      // Admin appointment form için varsayılan tarihi ayarla
      const today = new Date()
      const weekStart = getWeekStartDate(today)
      const defaultDate = weekStart.toISOString().split('T')[0]
      adminAppointment.value.date = defaultDate
      
      // Sayfa focus olduğunda kullanıcı bilgilerini kontrol et
      window.addEventListener('focus', handleWindowFocus)
      
      // Scroll event listener ekle
      window.addEventListener('scroll', handleScroll)
      
      // Otomatik refresh'i başlat
      startAutoRefresh()
    })
    
    // Component unmount olduğunda event listener'ı temizle
    onUnmounted(() => {
      window.removeEventListener('focus', handleWindowFocus)
      window.removeEventListener('scroll', handleScroll)
      
      // Otomatik refresh'i durdur
      stopAutoRefresh()
      
      
    })
    
    // Sayfa focus olduğunda çalışacak fonksiyon
    const handleWindowFocus = async () => {
      // Token geçerliliğini kontrol et
      const isTokenValid = await store.dispatch('checkTokenValidity')
      if (!isTokenValid) {
        
        router.push('/login')
        return
      }
      
      // Kullanıcı rolünü tekrar kontrol et
      const currentUser = store.getters.getCurrentUser
      if (currentUser && currentUser.role !== 'admin') {
        
        error.value = 'Bu sayfaya erişim yetkiniz bulunmamaktadır.'
        pendingRedirect.value = '/login'
        return
      }
    }

    // Scroll işlemleri
    const handleScroll = () => {
      showScrollToTop.value = window.scrollY > 300
    }

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    const loadTabData = async (tab) => {
      isLoading.value = true
      error.value = ''
      
      try {
        if (tab === 'lessons') {
          await store.dispatch('fetchLessons')
        } else if (tab === 'teachers') {
          // Öğretmenler için dersleri de yükle
          await store.dispatch('fetchLessons')
          await store.dispatch('fetchTeachers')
        } else if (tab === 'appointments') {
          await store.dispatch('fetchLessons')
          await store.dispatch('fetchTeachers')
          await store.dispatch('fetchAllAppointments')
        } else if (tab === 'users') {
          await store.dispatch('fetchUsers')
      
        } else if (tab === 'system') {
          await loadSystemStatus() // Sistem durumunu yükle
          await store.dispatch('fetchUsers')

        } else if (tab === 'admin-appointments') {
          // Admin randevu alma için gerekli verileri yükle
          await store.dispatch('fetchLessons')
          await store.dispatch('fetchTeachers')
          await store.dispatch('fetchUsers')
        } else if (tab === 'admins') {
          await fetchAdmins()
        }
      } catch (err) {
        error.value = 'Veriler yüklenirken bir hata oluştu'
        console.error(err)
      } finally {
        isLoading.value = false
      }
    }

    // Ders işlemleri
    const createLesson = async () => {
      if (!newLesson.value.name) {
        error.value = 'Ders adı gereklidir'
        return
      }

      isSubmitting.value = true
      error.value = ''
      
      try {
        const result = await store.dispatch('createLesson', newLesson.value)
        
        if (result.success) {
          // Başarı popup'ını göster
          successTitle.value = 'Ders Başarıyla Eklendi!'
          successMessage.value = `${newLesson.value.name} dersi başarıyla eklendi!`
          showSuccessPopup.value = true
          
          // Formu temizle ve dersleri yeniden yükle
          newLesson.value = { name: '', description: '' }
          await store.dispatch('fetchLessons')
        } else {
          error.value = result.error
        }
      } catch (err) {
        error.value = 'Ders oluşturulurken bir hata oluştu'
        console.error(err)
      } finally {
        isSubmitting.value = false
      }
    }

    const deleteLesson = async (id) => {
      // Silme onay popup'ını göster
      const lesson = lessons.value.find(l => l.id === id)
      deleteConfirmData.value = { id, name: lesson?.name || 'Ders' }
      deleteConfirmType.value = 'lesson'
      showDeleteConfirmPopup.value = true
    }

    const confirmDelete = async () => {
      if (!deleteConfirmData.value) return
      
      try {
        let result
        let messageText
        let titleText
        let fetchAction
        
        if (deleteConfirmType.value === 'lesson') {
          result = await store.dispatch('deleteLesson', deleteConfirmData.value.id)
          titleText = 'Ders Başarıyla Silindi!'
          messageText = `${deleteConfirmData.value.name} dersi başarıyla silindi!`
          fetchAction = () => store.dispatch('fetchLessons')
        } else if (deleteConfirmType.value === 'teacher') {
          result = await store.dispatch('deleteUser', deleteConfirmData.value.id)
                  titleText = 'Öğretmen Başarıyla Silindi!'
        messageText = `${deleteConfirmData.value.name} öğretmeni başarıyla silindi!`
          fetchAction = () => store.dispatch('fetchTeachers')
        } else if (deleteConfirmType.value === 'user') {
          result = await store.dispatch('deleteUser', deleteConfirmData.value.id)
          titleText = 'Öğrenci Başarıyla Silindi!'
          messageText = `${deleteConfirmData.value.name} öğrencisi başarıyla silindi!`
          fetchAction = () => store.dispatch('fetchUsers')
        } else if (deleteConfirmType.value === 'admin') {
          result = await store.dispatch('deleteUser', deleteConfirmData.value.id)
          titleText = 'Yönetici Başarıyla Silindi!'
          messageText = `${deleteConfirmData.value.name} yöneticisi başarıyla silindi!`
          fetchAction = () => fetchAdmins()
        }
        
        if (result && result.success) {
          // Başarı popup'ını göster
          successTitle.value = titleText
          successMessage.value = messageText
          showSuccessPopup.value = true
          
          // Listeyi yenile
          await fetchAction()
          } else {
          // Hata durumu
          if (result && result.error) {
            error.value = result.error
          } else {
            error.value = 'İşlem başarısız oldu'
          }
          }
        } catch (err) {
        if (deleteConfirmType.value === 'lesson') {
          error.value = 'Ders silinirken bir hata oluştu'
        } else if (deleteConfirmType.value === 'teacher') {
          error.value = 'Öğretmen silinirken bir hata oluştu'
        } else if (deleteConfirmType.value === 'user') {
          error.value = 'Öğrenci silinirken bir hata oluştu'
        } else if (deleteConfirmType.value === 'admin') {
          error.value = 'Yönetici silinirken bir hata oluştu'
        }
          console.error(err)
      } finally {
        // Silme onay popup'ını kapat
        showDeleteConfirmPopup.value = false
        deleteConfirmData.value = null
        deleteConfirmType.value = ''
        }
      }

    const cancelDelete = () => {
      showDeleteConfirmPopup.value = false
      deleteConfirmData.value = null
      deleteConfirmType.value = ''
    }

            // Öğretmen işlemleri
    const createTeacher = async () => {
      if (!newTeacher.value.ad || !newTeacher.value.soyad || !newTeacher.value.username || !newTeacher.value.password || !newTeacher.value.lesson_id) {
        error.value = 'Ad, soyad, kullanıcı adı, şifre ve ders seçimi gereklidir'
        return
      }

      // Türkçe karakter kontrolü
      const turkishChars = /[ğüşıöçĞÜŞİÖÇ]/
      if (turkishChars.test(newTeacher.value.username)) {
        error.value = 'Kullanıcı adında Türkçe karakter kullanılamaz. Sadece İngilizce harf ve rakam kullanın.'
        return
      }

      // Müsaitlik kontrolü
      const selectedSlotsCount = Object.values(newTeacher.value.availability || {}).reduce((total, slots) => total + slots.length, 0)
      if (selectedSlotsCount === 0) {
        error.value = 'En az bir müsaitlik saati seçilmelidir'
        return
      }

      // Kullanıcı adı formatı kontrolü (h_ ile başlamalı)
      if (!/^h_/.test(newTeacher.value.username)) {
        error.value = 'Öğretmen kullanıcı adı "h_" ile başlamalıdır (örn: h_mehmet)'
        return
      }

      isSubmitting.value = true
      error.value = ''
      
      try {
        // Öğretmen için role field'ını ekle ve lesson_id'yi lesson_ids array'ine çevir
        const teacherData = {
          ...newTeacher.value,
          role: 'hoca',
          lesson_ids: newTeacher.value.lesson_id ? [newTeacher.value.lesson_id] : []
        }
        
        const result = await store.dispatch('createUser', teacherData)
        
        if (result.success) {
                        
      
          
          // Müsaitlik bilgilerini kaydet
          if (newTeacher.value.availability && Object.keys(newTeacher.value.availability).length > 0) {
            
            
            // Öğretmen ID'sini kontrol et - Backend'den gelen veri yapısı: {data: {...}, message: '...', success: true}
            const teacherId = result.data?.data?.id || result.data?.id
            
            
            if (!teacherId) {
                      console.error('Öğretmen ID bulunamadı! result.data:', result.data)
        error.value = 'Öğretmen oluşturuldu ama ID alınamadı'
              return
            }
            
            const availabilityResult = await store.dispatch('createTeacherAvailability', {
              teacher_id: teacherId,
              availability: newTeacher.value.availability
            })
            
            if (!availabilityResult.success) {
              console.warn('Müsaitlik bilgileri kaydedilemedi:', availabilityResult.error)
            } else {
              
            }
          }
          
          // Başarı popup'ını göster
          successTitle.value = 'Öğretmen Başarıyla Oluşturuldu!'
          successMessage.value = `${newTeacher.value.ad} ${newTeacher.value.soyad} öğretmeni başarıyla oluşturuldu!`
          showSuccessPopup.value = true
          
          // Formu temizle ve öğretmenleri yeniden yükle
          newTeacher.value = { ad: '', soyad: '', username: '', password: '', lesson_id: '', availability: {} }
          await store.dispatch('fetchTeachers')
        } else {
          error.value = result.error
        }
      } catch (err) {
        error.value = 'Öğretmen oluşturulurken bir hata oluştu'
        console.error(err)
      } finally {
        isSubmitting.value = false
      }
    }

    const deleteTeacher = async (id) => {
      // Silme onay popup'ını göster
      const teacher = teachers.value.find(t => t.id === id)
              deleteConfirmData.value = { id, name: `${teacher?.ad || 'Öğretmen'} ${teacher?.soyad || ''}` }
      deleteConfirmType.value = 'teacher'
      showDeleteConfirmPopup.value = true
    }

    const toggleTeacherBlock = async (teacher) => {
      try {
        const endpoint = teacher.is_blocked ? `/api/users/${teacher.id}/unblock` : `/api/users/${teacher.id}/block`
        const action = teacher.is_blocked ? 'unblock' : 'block'
        
        const response = await axios.post(endpoint, {}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        if (response.data && response.data.success) {
          // Başarı mesajı göster
          successTitle.value = teacher.is_blocked ? '🔓 Öğretmen Bloku Kaldırıldı' : '🔒 Öğretmen Bloklandı'
          let message = response.data.message
          // Blok işleminde iptal edilen gelecek randevu sayısını da ilet
          const cancelledCount = response.data.cancelled_appointments_count
          if (!teacher.is_blocked && typeof cancelledCount === 'number' && cancelledCount > 0) {
            message += `\n\nBu öğretmenin gelecek ${cancelledCount} randevusu otomatik iptal edildi ve öğrencilerin panelinde "Öğretmen tarafından iptal edildi" olarak görünecek.`
          }
          successMessage.value = message
          showSuccessPopup.value = true
          
          // Öğretmenler listesini yenile
            await store.dispatch('fetchTeachers')
          
          
          } else {
          const errorData = await response.json()
          error.value = `Öğretmen ${action} işlemi başarısız: ${errorData.error}`
          }
        } catch (err) {
        console.error(`Öğretmen ${action} işlemi hatası:`, err)
        error.value = `Öğretmen ${action} işlemi sırasında hata oluştu`
      }
    }





    // Randevu işlemleri
    const cancelAppointment = async (id) => {
      // Randevu iptal onay popup'ını göster
      const appointmentToCancel = appointments.value.find(apt => apt.id === id)
      if (!appointmentToCancel) {
        console.error('İptal edilecek randevu bulunamadı')
        return
      }
      
      // Users listesini yükle (eğer boşsa)
      if (users.value.length === 0) {
        await store.dispatch('fetchUsers')
      }
      
      // Öğrenci verilerini users listesinden bul
      const student = users.value.find(u => u.id === appointmentToCancel.user_id)
      
      // Öğretmen verilerini önce appointment objesinden dene, bulunamazsa users listesinden ara
      let teacherName = 'Öğretmen Bulunamadı'
      if (appointmentToCancel.teacher && appointmentToCancel.teacher.ad) {
        // Direkt appointment objesinden al
        teacherName = `${appointmentToCancel.teacher.ad} ${appointmentToCancel.teacher.soyad || ''}`
          } else {
        // Users listesinden ara
        const teacher = users.value.find(u => u.id === appointmentToCancel.teacher_user_id)
        if (teacher) {
          teacherName = `${teacher.ad} ${teacher.soyad}`
        }
      }
      
      cancelAppointmentData.value = {
        id,
        studentName: student ? `${student.ad} ${student.soyad}` : 'Öğrenci Bulunamadı',
        teacherName: teacherName,
        lessonName: appointmentToCancel.lesson?.name || 'Ders',
        date: appointmentToCancel.appointment_time
      }
      showCancelAppointmentPopup.value = true
    }

    const confirmCancelAppointment = async () => {
      if (!cancelAppointmentData.value) return
      
      try {
        const result = await store.dispatch('updateAppointmentStatus', { 
          appointmentId: cancelAppointmentData.value.id, 
          status: 'iptal edildi',
          cancelledBy: 'admin'
        })
        
        if (result.success) {
          // Başarı popup'ını göster
          successTitle.value = 'Randevu Başarıyla İptal Edildi!'
          successMessage.value = `${cancelAppointmentData.value.studentName} öğrencisinin ${cancelAppointmentData.value.lessonName} dersi iptal edildi.`
          showSuccessPopup.value = true
          
          // Randevuları yeniden yükle
          await store.dispatch('fetchAllAppointments')
          
          // Müsaitlik takvimini yenile
          refreshAvailability.value = true
          setTimeout(() => {
            refreshAvailability.value = false
          }, 100)
        } else {
          error.value = result.error
        }
      } catch (err) {
        error.value = 'Randevu iptal edilirken bir hata oluştu'
        console.error(err)
      } finally {
        // Randevu iptal onay popup'ını kapat
        showCancelAppointmentPopup.value = false
        cancelAppointmentData.value = null
      }
    }

    const cancelCancelAppointment = () => {
      showCancelAppointmentPopup.value = false
      cancelAppointmentData.value = null
    }

    // Randevu tarihini formatla
    const formatAppointmentDate = (dateString) => {
      if (!dateString) return 'Tarih belirtilmemiş'
      
      try {
        const date = new Date(dateString)
        return date.toLocaleDateString('tr-TR', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (error) {
        return dateString
      }
    }

    // Kullanıcı adı validation fonksiyonları
    const validateUsername = (event) => {
      const value = event.target.value
      const turkishChars = /[ğüşıöçĞÜŞİÖÇ]/
      if (turkishChars.test(value)) {
        error.value = 'Kullanıcı adında Türkçe karakter kullanılamaz. Sadece İngilizce harf ve rakam kullanın.'
        event.target.value = value.replace(/[ğüşıöçĞÜŞİÖÇ]/g, '')
        newTeacher.value.username = event.target.value
      } else {
        error.value = ''
      }
    }

    const validateStudentUsername = (event) => {
      const value = event.target.value
      const turkishChars = /[ğüşıöçĞÜŞİÖÇ]/
      if (turkishChars.test(value)) {
        error.value = 'Kullanıcı adında Türkçe karakter kullanılamaz. Sadece rakam kullanın.'
        event.target.value = value.replace(/[ğüşıöçĞÜŞİÖÇ]/g, '')
        newUser.value.username = event.target.value
      } else {
        error.value = ''
      }
    }

    const validateAdminUsername = (event) => {
      const value = event.target.value
      const turkishChars = /[ğüşıöçĞÜŞİÖÇ]/
      if (turkishChars.test(value)) {
        error.value = 'Kullanıcı adında Türkçe karakter kullanılamaz. Sadece İngilizce harf ve rakam kullanın.'
        event.target.value = value.replace(/[ğüşıöçĞÜŞİÖÇ]/g, '')
        newAdmin.value.username = event.target.value
      } else {
        error.value = ''
      }
    }

    // Öğrenci işlemleri
    const createUser = async () => {
      if (!newUser.value.ad || !newUser.value.soyad || !newUser.value.username || !newUser.value.password || !newUser.value.phone || !newUser.value.class_code) {
        error.value = 'Ad, soyad, kullanıcı adı, şifre, telefon ve sınıf kodu gereklidir'
        return
      }

      // Türkçe karakter kontrolü
      const turkishChars = /[ğüşıöçĞÜŞİÖÇ]/
      if (turkishChars.test(newUser.value.username)) {
        error.value = 'Kullanıcı adında Türkçe karakter kullanılamaz. Sadece rakam kullanın.'
        return
      }

      // Telefon numarası formatı kontrolü (5 ile başlamalı ve 10 haneli olmalı)
      if (!/^5[0-9]{9}$/.test(newUser.value.phone)) {
        error.value = 'Telefon numarası 5 ile başlamalı ve 10 haneli olmalıdır (örn: 5123456789)'
        return
      }

      // Kullanıcı adı formatı kontrolü (4 haneli sayı)
      if (!/^\d{4}$/.test(newUser.value.username)) {
        error.value = 'Kullanıcı adı 4 haneli sayı olmalıdır (örn: 1234)'
        return
      }

      // Default olarak öğrenci rolü ata
      const userData = {
        ...newUser.value,
        role: 'ogrenci'
      }

      isSubmitting.value = true
      error.value = ''
      
      try {
        const result = await store.dispatch('createUser', userData)
        
        if (result.success) {
          // Başarı popup'ını göster
          successTitle.value = 'Öğrenci Başarıyla Oluşturuldu!'
          successMessage.value = `${newUser.value.ad} ${newUser.value.soyad} öğrencisi başarıyla oluşturuldu!`
          showSuccessPopup.value = true
          
          // Formu temizle ve kullanıcıları yeniden yükle
                            newUser.value = { ad: '', soyad: '', username: '', password: '', phone: '', class_code: '' }
          await store.dispatch('fetchUsers')
        } else {
          error.value = result.error
        }
      } catch (err) {
        error.value = 'Kullanıcı oluşturulurken bir hata oluştu'
        console.error(err)
      } finally {
        isSubmitting.value = false
      }
    }

    // Yönetici işlemleri
    const fetchAdmins = async () => {
      isLoadingAdmins.value = true
      adminsError.value = ''
      
      try {
        const response = await axios.get('https://api.modernkurs.com/api/users/role?role=admin', {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        if (response.data.success) {
          admins.value = response.data.data
        } else {
          throw new Error(response.data.error || 'Yöneticiler yüklenemedi')
        }
      } catch (err) {
        adminsError.value = 'Yöneticiler yüklenirken bir hata oluştu: ' + err.message
        console.error('Yöneticiler yüklenirken hata:', err)
      } finally {
        isLoadingAdmins.value = false
      }
    }

    const createAdmin = async () => {
      if (!newAdmin.value.username || !newAdmin.value.ad || !newAdmin.value.soyad || !newAdmin.value.password) {
        error.value = 'Tüm alanlar gereklidir'
        return
      }

      // Türkçe karakter kontrolü
      const turkishChars = /[ğüşıöçĞÜŞİÖÇ]/
      if (turkishChars.test(newAdmin.value.username)) {
        error.value = 'Kullanıcı adında Türkçe karakter kullanılamaz. Sadece İngilizce harf ve rakam kullanın.'
        return
      }

      // Kullanıcı adı formatı kontrolü (a_ ile başlamalı)
      if (!/^a_[a-zA-Z0-9]+$/.test(newAdmin.value.username)) {
        error.value = 'Yönetici kullanıcı adı "a_" ile başlamalı ve sadece İngilizce harf, rakam içerebilir'
        return
      }

      // Şifre uzunluğu kontrolü
      if (newAdmin.value.password.length < 6) {
        error.value = 'Şifre en az 6 karakter olmalıdır'
        return
      }

      isCreatingAdmin.value = true
      error.value = ''
      
      try {
        const adminData = {
          ...newAdmin.value,
          role: 'admin'
        }
        
        const response = await axios.post('https://api.modernkurs.com/api/users', adminData, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        if (response.data) {
          // Başarı popup'ını göster
          successTitle.value = 'Yönetici Başarıyla Oluşturuldu!'
          successMessage.value = `${newAdmin.value.ad} ${newAdmin.value.soyad} yöneticisi başarıyla oluşturuldu!`
          showSuccessPopup.value = true
          
          // Formu temizle ve yöneticileri yeniden yükle
          newAdmin.value = { username: '', ad: '', soyad: '', password: '' }
          await fetchAdmins()
        }
      } catch (err) {
        error.value = 'Yönetici oluşturulurken bir hata oluştu: ' + err.message
        console.error('Yönetici oluştururken hata:', err)
      } finally {
        isCreatingAdmin.value = false
      }
    }

    const editAdmin = (admin) => {
      editingAdmin.value = { 
        ...admin,
        password: '' // Şifre alanını boş bırak
      }
      showAdminModal.value = true
    }

    const updateAdmin = async () => {
      if (!editingAdmin.value.ad || !editingAdmin.value.soyad || !editingAdmin.value.username) {
        error.value = 'Ad, soyad ve kullanıcı adı gereklidir'
        return
      }

      // Kullanıcı adı formatı kontrolü (a_ ile başlamalı)
      if (!/^a_[a-zA-ZğüşıöçĞÜŞİÖÇ0-9]+$/.test(editingAdmin.value.username)) {
        error.value = 'Yönetici kullanıcı adı "a_" ile başlamalı ve sadece harf, rakam içerebilir'
        return
      }

      isSubmitting.value = true
      error.value = ''
      
      try {
        const updateData = {
          ad: editingAdmin.value.ad,
          soyad: editingAdmin.value.soyad,
          username: editingAdmin.value.username
        }
        
        // Şifre varsa ekle
        if (editingAdmin.value.password) {
          updateData.password = editingAdmin.value.password
        }
        
        const response = await axios.put(`https://api.modernkurs.com/api/users/${editingAdmin.value.id}`, updateData, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        if (response.data) {
          // Başarı popup'ını göster
          successTitle.value = 'Yönetici Başarıyla Güncellendi!'
          successMessage.value = `${editingAdmin.value.ad} ${editingAdmin.value.soyad} yöneticisi başarıyla güncellendi!`
          showSuccessPopup.value = true
          
          // Modal'ı kapat ve yöneticileri yeniden yükle
          closeAdminModal()
          await fetchAdmins()
        }
      } catch (err) {
        error.value = 'Yönetici güncellenirken bir hata oluştu: ' + err.message
        console.error('Yönetici güncellenirken hata:', err)
      } finally {
        isSubmitting.value = false
      }
    }

    const deleteAdmin = (admin) => {
      // Kendini silmeye çalışıyorsa engelle
      if (admin.id === currentUser.value?.id) {
        error.value = 'Kendi hesabınızı silemezsiniz'
        return
      }
      
      // Silme onay popup'ını göster
      deleteConfirmData.value = { id: admin.id, name: `${admin.ad} ${admin.soyad}` }
      deleteConfirmType.value = 'admin'
      showDeleteConfirmPopup.value = true
    }

    const closeAdminModal = () => {
      showAdminModal.value = false
      editingAdmin.value = null
    }





    // Toplu öğrenci yükleme fonksiyonları
    const handleFileSelect = (event) => {
      const file = event.target.files[0]
      if (file) {
        // Dosya türü kontrolü
        if (!file.name.match(/\.(xlsx|xls)$/i)) {
          error.value = 'Lütfen sadece Excel dosyası (.xlsx, .xls) seçin'
          return
        }
        
        // Dosya boyutu kontrolü (5MB)
        if (file.size > 5 * 1024 * 1024) {
          error.value = 'Dosya boyutu 5MB\'dan küçük olmalıdır'
          return
        }
        
        selectedFile.value = file
        error.value = ''
      }
    }

    const clearFileSelection = () => {
      selectedFile.value = null
      if (excelFileInput.value) {
        excelFileInput.value.value = ''
      }
      error.value = ''
    }

    const uploadExcelFile = async () => {
      if (!selectedFile.value) {
        error.value = 'Lütfen bir Excel dosyası seçin'
        return
      }

      isUploading.value = true
      error.value = ''

      try {
        const formData = new FormData()
        formData.append('excel_file', selectedFile.value)

        const response = await axios.post('https://api.modernkurs.com/api/users/bulk-upload', formData, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'multipart/form-data'
          }
        })

        const result = response.data

          if (result.success) {
          // Başarı popup'ını göster
          successTitle.value = 'Toplu Yükleme Başarılı!'
          successMessage.value = result.message
          showSuccessPopup.value = true
          
          // Dosya seçimini temizle
          clearFileSelection()
          
          // Öğrenci listesini yenile
            await store.dispatch('fetchUsers')
        } else {
          if (result.details && Array.isArray(result.details)) {
            // Detaylı hata mesajları
            error.value = `${result.error}\n\nDetaylar:\n${result.details.join('\n')}`
          } else {
            error.value = result.error
          }
          }
        } catch (err) {
        const apiErr = err.response?.data
        if (apiErr && Array.isArray(apiErr.details) && apiErr.details.length > 0) {
          error.value = `${apiErr.error || 'Dosya yüklenirken bir hata oluştu'}\n\nDetaylar:\n${apiErr.details.join('\n')}`
        } else {
          error.value = 'Dosya yüklenirken bir hata oluştu: ' + (apiErr?.error || err.message)
        }
        console.error('Excel yükleme hatası:', err)
      } finally {
        isUploading.value = false
      }
    }

    // Excel export fonksiyonu
    const exportStudentsToExcel = async () => {
      if (users.value.length === 0) {
        error.value = 'Export edilecek öğrenci bulunamadı'
        return
      }

      isExporting.value = true
      error.value = ''

      try {
        const response = await axios.get('https://api.modernkurs.com/api/students/export', {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          responseType: 'blob'
        })

        // Excel dosyasını indir
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `ogrenci_listesi_${users.value.length}.xlsx`
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)

        // Başarı mesajı göster
        successTitle.value = 'Excel Export Başarılı!'
        successMessage.value = `${users.value.length} öğrenci bilgisi Excel dosyasına aktarıldı!`
        showSuccessPopup.value = true
      } catch (err) {
        error.value = 'Excel export işlemi sırasında bir hata oluştu: ' + (err.response?.data?.error || err.message)
        console.error('Excel export hatası:', err)
      } finally {
        isExporting.value = false
      }
    }

    const deleteUser = async (id) => {
      // Silme onay popup'ını göster
      const user = users.value.find(u => u.id === id)
      deleteConfirmData.value = { id, name: `${user?.ad || 'Kullanıcı'} ${user?.soyad || ''}` }
      deleteConfirmType.value = 'user'
      showDeleteConfirmPopup.value = true
    }

    // Yardımcı fonksiyonlar
    const getLessonName = (lessonId) => {
      const lesson = lessons.value.find(l => l.id === lessonId)
      return lesson ? lesson.name : 'Bilinmeyen Ders'
    }

    const getTeacherName = (teacherId) => {
      const teacher = teachers.value.find(t => t.id === teacherId)
              return teacher ? teacher.name : 'Bilinmeyen Öğretmen'
    }

    const getTeacherFullName = (teacherUserId) => {
      const teacher = teachers.value.find(t => t.id === teacherUserId)
      if (teacher) {
        return `${teacher.ad} ${teacher.soyad}`
      }
              return 'Bilinmeyen Öğretmen'
    }

    // Durum metnini Türkçe yap ve iptal eden bilgisini ekle
    const getStatusText = (status, cancelledBy) => {
      if (status === 'iptal edildi') {
        if (cancelledBy === 'admin') {
          return 'Yönetici iptal etti'
        } else if (cancelledBy === 'student') {
          return 'Öğrenci iptal etti'
        } else {
          return 'İptal Edildi'
        }
      }
      
      const statusMap = {
        'beklemede': 'Beklemede',
        'onaylandı': 'Onaylandı',
        'öğrenci katılmadı': 'Öğrenci katılmadı'
      }
      
      return statusMap[status] || status
    }

    const formatDateTime = (dateTimeStr) => {
      if (!dateTimeStr) return 'Tarih bilgisi yok'
      
      const date = new Date(dateTimeStr)
      return new Intl.DateTimeFormat('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date)
    }

    // Sistem durumu yardımcı fonksiyonları
    const getSystemStatusText = (status) => {
      const statusMap = {
        'preparing': '🔄 Hazırlanıyor',
        'ready': '✅ Hazır',
        'maintenance': '🔧 Bakım'
      }
      return statusMap[status] || status
    }

    const formatTimeUntilOpen = (timeUntilOpen) => {
      if (!timeUntilOpen) return 'Hesaplanıyor...'
      
      try {
        // Debug log
              
        
        // Backend'den gelen minutes_until_open ve seconds_until_open değerlerini kullan
        // Bu değerler zaten doğru hesaplanmış
        if (systemStatus.value && systemStatus.value.minutes_until_open !== undefined) {
          const minutes = systemStatus.value.minutes_until_open
          const totalSeconds = systemStatus.value.seconds_until_open || 0
          
          // Toplam saniyeyi dakika ve saniyeye çevir
          const actualMinutes = Math.floor(totalSeconds / 60)
          const actualSeconds = totalSeconds % 60
          
                  
          
          if (actualMinutes > 0) {
            return `${actualMinutes} dakika ${actualSeconds} saniye`
          } else {
            return `${actualSeconds} saniye`
          }
        }
        
        // Eski yöntem (fallback)
        let diffInMs = 0
        
        if (typeof timeUntilOpen === 'number') {
          diffInMs = timeUntilOpen
        } else {
          console.error('❌ Beklenmeyen timeUntilOpen tipi:', typeof timeUntilOpen)
          return 'Süre tipi hatası'
        }
        
        
        
        if (diffInMs <= 0) {
          return 'Açılış zamanı geldi!'
        }
        
        // Makul süre kontrolü (24 saat = 1440 dakika)
        if (diffInMs > 24 * 60 * 60 * 1000) {
          console.error('❌ Çok uzun süre:', diffInMs, 'ms')
          return 'Süre hesaplanamadı'
        }
        
        const minutes = Math.floor(diffInMs / 60000)
        const seconds = Math.floor((diffInMs % 60000) / 1000)
        
        
        
        if (minutes > 0) {
          return `${minutes} dakika ${seconds} saniye`
        } else {
          return `${seconds} saniye`
        }
      } catch (error) {
        console.error('❌ formatTimeUntilOpen hatası:', error)
        return 'Hesaplama hatası'
      }
    }

    const formatDate = (dateTimeStr) => {
      if (!dateTimeStr) return 'Tarih bilgisi yok'
      const date = new Date(dateTimeStr)
      return new Intl.DateTimeFormat('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date)
    }

      const goHome = () => {
    router.push('/')
  }
    
    // Profil fonksiyonları
    const openProfileModal = async () => {
      // Profil modal'ını açmadan önce gerekli verileri çek
      try {
        // Dersleri, öğretmenleri ve öğrencileri çek
        await store.dispatch('fetchLessons')
        await store.dispatch('fetchTeachers')
        await store.dispatch('fetchUsers')
        
        // Modal'ı aç
        showProfileModal.value = true
      } catch (error) {
        console.error('Profil verileri yüklenirken hata:', error)
        // Hata olsa bile modal'ı aç
        showProfileModal.value = true
      }
    }
    
    const getInitials = (ad, soyad) => {
      if (!ad || !soyad) return '?'
      return `${ad.charAt(0)}${soyad.charAt(0)}`.toUpperCase()
    }
    
    const logout = async () => {
      // Çıkış onay popup'ını göster
      showLogoutConfirmPopup.value = true
    }

    const confirmLogout = async () => {
      try {
        console.log('🚪 AdminPanel logout başlatılıyor...')
        
        // Önce auto refresh'i durdur
        stopAutoRefresh()
        
        // Store'dan logout yap
        await store.dispatch('logout')
        
        console.log('✅ Logout tamamlandı, login sayfasına yönlendiriliyor...')
        router.push('/login')
      } catch (error) {
        console.error('Çıkış yapılırken hata:', error)
        // Hata olsa bile login sayfasına yönlendir
        router.push('/login')
      } finally {
        showLogoutConfirmPopup.value = false
      }
    }

    const cancelLogout = () => {
      showLogoutConfirmPopup.value = false
    }

    // Tüm öğrencileri sil işlemleri
    const showDeleteAllStudentsConfirmPopup = () => {
      showDeleteAllStudentsConfirm.value = true
    }

    const cancelDeleteAllStudents = () => {
      showDeleteAllStudentsConfirm.value = false
    }

    const confirmDeleteAllStudents = async () => {
      if (isDeletingAllStudents.value) return
      
      isDeletingAllStudents.value = true
      error.value = ''
      
      try {
        
        const response = await axios.delete('https://api.modernkurs.com/api/users/students/all')
        
        if (response.data.success) {
          
          
          // Başarı popup'ını göster
          successTitle.value = 'Tüm Öğrenciler Başarıyla Silindi!'
          successMessage.value = `${response.data.deleted_students} öğrenci ve ${response.data.deleted_appointments} randevu silindi.`
          showSuccessPopup.value = true
          
          // Popup'ı kapat
          showDeleteAllStudentsConfirm.value = false
          
          // Kullanıcı listesini yenile
          await store.dispatch('fetchUsers')
        } else {
          error.value = 'Öğrenciler silinemedi: ' + response.data.error
        }
      } catch (err) {
        console.error('❌ Tüm öğrencileri silerken hata:', err)
        error.value = 'Tüm öğrenciler silinirken bir hata oluştu: ' + (err.response?.data?.error || err.message)
      } finally {
        isDeletingAllStudents.value = false
      }
  }

    // Ders düzenleme işlemleri
    const editLesson = (lesson) => {
      editingLesson.value = { ...lesson }
      showLessonModal.value = true
    }

    const closeLessonModal = () => {
      showLessonModal.value = false
      editingLesson.value = null
    }

    const updateLesson = async () => {
      if (!editingLesson.value.name) {
        error.value = 'Ders adı gereklidir'
        return
      }

      isSubmitting.value = true
      error.value = ''
      
      try {
        const result = await store.dispatch('updateLesson', editingLesson.value)
        
        if (result.success) {
          // Başarı popup'ını göster
          successTitle.value = 'Ders Başarıyla Güncellendi!'
          successMessage.value = `${editingLesson.value.name} dersi başarıyla güncellendi!`
          showSuccessPopup.value = true
          
          closeLessonModal() // Düzenleme modunu kapat
          await store.dispatch('fetchLessons')
        } else {
          error.value = result.error
        }
      } catch (err) {
        error.value = 'Ders güncellenirken bir hata oluştu'
        console.error(err)
      } finally {
        isSubmitting.value = false
      }
    }

    // Öğretmen düzenleme işlemleri
    const editTeacher = (teacher) => {
      // Sadece düzenleme modal'ını aç, güncelleme yapma
      editingTeacher.value = { 
        ...teacher,
        password: '', // Şifre alanını temizle
        lesson_id: teacher.lessons && teacher.lessons.length > 0 ? teacher.lessons[0].id : ''
      }
      showTeacherModal.value = true
      
    }

    const closeTeacherModal = () => {
      showTeacherModal.value = false
      editingTeacher.value = null
    }

    const updateTeacher = async () => {
      if (!editingTeacher.value.ad || !editingTeacher.value.soyad || !editingTeacher.value.username) {
        error.value = 'Ad, soyad ve kullanıcı adı gereklidir'
        return
      }

      // Kullanıcı adı formatı kontrolü (h_ ile başlamalı)
      if (!/^h_/.test(editingTeacher.value.username)) {
        error.value = 'Öğretmen kullanıcı adı "h_" ile başlamalıdır (örn: h_mehmet)'
        return
      }

      isSubmitting.value = true
      error.value = ''
      
      // Şifre alanı boşsa undefined yap (backend'e gönderilmesin)
      const teacherData = { ...editingTeacher.value }
      if (!teacherData.password) {
        delete teacherData.password
      }
      
      // Availability property'sini kaldır (müsaitlik düzenleme modalında değil)
      delete teacherData.availability
      
      try {
        // Önce öğretmen bilgilerini güncelle
        const result = await store.dispatch('updateUser', teacherData)
        
        if (result.success) {
          // Sonra ders ilişkilerini güncelle
          if (teacherData.lesson_id) {
            // Mevcut ders ilişkilerini sil
            await axios.delete(`https://api.modernkurs.com/api/teacher-lessons/teacher/${teacherData.id}`)
            
            // Yeni ders ilişkisini ekle
            await axios.post('https://api.modernkurs.com/api/teacher-lessons', {
                  teacher_id: teacherData.id,
              lesson_id: teacherData.lesson_id
              })
          }
          
          // Başarı popup'ını göster
          successTitle.value = 'Öğretmen Başarıyla Güncellendi!'
          successMessage.value = `${editingTeacher.value.ad} ${editingTeacher.value.soyad} öğretmeni başarıyla güncellendi!`
          showSuccessPopup.value = true
          
          closeTeacherModal() // Düzenleme modunu kapat
          await store.dispatch('fetchTeachers')
        } else {
          error.value = result.error
        }
      } catch (err) {
        error.value = 'Öğretmen güncellenirken bir hata oluştu'
        console.error(err)
      } finally {
        isSubmitting.value = false
      }
    }

    // Öğrenci düzenleme işlemleri
    const editUser = (user) => {
      editingUser.value = { 
        ...user,
        password: '' // Şifre alanını temizle
      }
      showUserModal.value = true
    }

    const closeUserModal = () => {
      showUserModal.value = false
      editingUser.value = null
    }

    const updateUser = async () => {
      if (!editingUser.value.ad || !editingUser.value.soyad || !editingUser.value.phone || !editingUser.value.class_code) {
        error.value = 'Ad, soyad, telefon ve sınıf kodu gereklidir'
        return
      }

      // Telefon numarası formatı kontrolü (5 ile başlamalı ve 10 haneli olmalı)
      if (!/^5[0-9]{9}$/.test(editingUser.value.phone)) {
        error.value = 'Telefon numarası 5 ile başlamalı ve 10 haneli olmalıdır (örn: 5123456789)'
        return
      }

      isSubmitting.value = true
      error.value = ''
      
      // Şifre alanı boşsa undefined yap (backend'e gönderilmesin)
      const userData = { ...editingUser.value }
      if (!userData.password) {
        delete userData.password
      }
      
      
      try {
        const result = await store.dispatch('updateUser', userData)
        
        if (result.success) {
          // Başarı popup'ını göster
          successTitle.value = 'Öğrenci Başarıyla Güncellendi!'
          successMessage.value = `${editingUser.value.ad} ${editingUser.value.soyad} öğrencisi başarıyla güncellendi!`
          showSuccessPopup.value = true
          
          closeUserModal() // Düzenleme modunu kapat
          await store.dispatch('fetchUsers')
        } else {
          error.value = result.error
        }
      } catch (err) {
        error.value = 'Kullanıcı güncellenirken bir hata oluştu'
        console.error(err)
      } finally {
        isSubmitting.value = false
      }
    }

    // Müsaitlik güncelleme fonksiyonu
    const updateTeacherAvailability = (availability) => {
      newTeacher.value.availability = availability;
    };

    // Düzenleme modal'ında müsaitlik güncelleme
    const updateEditingTeacherAvailability = (availability) => {
      editingTeacher.value.availability = availability;
    };

    // Müsaitlik modal fonksiyonları
    const openAvailabilityModal = (teacher) => {
      selectedTeacher.value = teacher
      showAvailabilityModal.value = true
    }

    const closeAvailabilityModal = () => {
      showAvailabilityModal.value = false
      selectedTeacher.value = null
    }

    const openEditAvailabilityModal = (teacher) => {
      selectedTeacher.value = teacher
      showEditAvailabilityModal.value = true
    }

    const closeEditAvailabilityModal = () => {
      showEditAvailabilityModal.value = false
      selectedTeacher.value = null
    }

    // Müsaitlik değişikliklerini kaydet
    const saveAvailabilityChanges = async () => {
      try {
        if (editAvailabilityComponent.value) {
          // TeacherAvailabilityDisplay component'inden değişiklikleri al
          const availabilityData = editAvailabilityComponent.value.availability
          
          // Müsaitlik kontrolü - en az bir saat seçilmeli
          const selectedSlotsCount = Object.values(availabilityData || {}).reduce((total, slots) => total + slots.length, 0)
          if (selectedSlotsCount === 0) {
            error.value = 'En az bir müsaitlik saati seçilmelidir'
            return
          }
          
          // Backend'e gönder
          const response = await axios.put(`/api/teacher-availability/${selectedTeacher.value.id}`, {
            availability: availabilityData,
            weekStart: editAvailabilityComponent.value.currentWeekStart.toISOString().split('T')[0]
          })
          
          if (response.data.success) {
            // Öğretmen bilgilerini sakla (modal kapatılmadan önce)
            const teacherName = `${selectedTeacher.value.ad} ${selectedTeacher.value.soyad}`
            
            // Modal'ı kapat
            closeEditAvailabilityModal()
            
            // Başarı popup'ını göster
            successTitle.value = 'Müsaitlik Başarıyla Güncellendi!'
            successMessage.value = `${teacherName} öğretmeninin müsaitlik bilgileri başarıyla güncellendi!`
            showSuccessPopup.value = true
            
            // Öğretmenler listesini yenile
            await store.dispatch('fetchTeachers')
          } else {
            error.value = 'Müsaitlik kaydedilirken bir hata oluştu: ' + response.data.error
          }
        }
        
      } catch (error) {
        console.error('Müsaitlik kaydetme hatası:', error)
        error.value = 'Müsaitlik kaydedilirken bir hata oluştu!'
      }
    }

    // Müsaitlik özeti için yardımcı fonksiyon
    const getAvailabilitySummary = (availability) => {
      const dayNames = {
        monday: 'Pzt',
        tuesday: 'Sal',
        wednesday: 'Çar',
        thursday: 'Per',
        saturday: 'Cmt',
        sunday: 'Paz'
      }
      
      const totalSlots = Object.values(availability).reduce((total, slots) => total + slots.length, 0)
      
      if (totalSlots === 0) return 'Müsaitlik belirtilmemiş'
      
      const dayCount = Object.keys(availability).length
      return `${dayCount} gün, ${totalSlots} saat`
    }







    // Sistem durumunu yükle
    const loadSystemStatus = async () => {
      try {
        const response = await axios.get('https://api.modernkurs.com/api/system/status')
        if (response.data.success) {
          systemStatus.value = response.data
        } else {
          console.error('Sistem durumu yüklenemedi:', response.data.error)
        }
      } catch (err) {
        console.error('Sistem durumu yüklenirken hata:', err)
      }
    }

    const setSystemReady = async () => {
      showSystemReadyModal.value = true
    }
    
    const closeSystemReadyModal = () => {
      showSystemReadyModal.value = false
    }
    
    const confirmSystemReady = async () => {
      
      isSettingReady.value = true
      error.value = ''
      successMessage.value = ''
      
      try {
        const response = await fetch('/api/system/status/ready', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            message: 'Sistem manuel olarak hazır moda alındı. Randevu alma sistemi aktif.'
          })
        })
        
        if (response.ok) {
          const result = await response.json()
          if (result.success) {
            successMessage.value = 'Sistem başarıyla hazır moda alındı!'
            successTitle.value = 'Başarılı!'
            showSuccessPopup.value = true
            setTimeout(() => {
              showSuccessPopup.value = false
            }, 5000)
            
            // Sistem durumunu manuel olarak güncelle
            systemStatus.value = {
              success: true,
              status: 'ready',
              message: 'Sistem hazır. Randevu alma sistemi aktif.',
              next_opening_time: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // 1 hafta sonra
              last_reset_time: new Date(),
              current_time: new Date()
            }
          } else {
            error.value = result.error || 'Sistem hazır moda alınamadı'
          }
        } else {
          const errorData = await response.json()
          error.value = errorData.error || 'Sistem hazır moda alınamadı'
        }
      } catch (err) {
        error.value = 'Sistem hazır moda alınırken bir hata oluştu'
        console.error('Sistem hazır moda alma hatası:', err)
      } finally {
        isSettingReady.value = false
        closeSystemReadyModal()
      }
    }

    const manualWeeklyReset = async () => {
      showManualResetModal.value = true
    }
    
    const closeManualResetModal = () => {
      showManualResetModal.value = false
    }
    
    const confirmManualReset = async () => {
      
      isResetting.value = true
      error.value = ''
      successMessage.value = ''
      
      try {
        const response = await fetch('/api/weekly-reset/manual', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        
        if (response.ok) {
          const result = await response.json()
          successMessage.value = 'Manuel reset başarıyla tamamlandı! ' + result.message
          successTitle.value = 'Reset Başarılı!'
          showSuccessPopup.value = true
          setTimeout(() => {
            showSuccessPopup.value = false
          }, 5000)
          
                      // Sistem durumunu manuel olarak güncelle
            const now = new Date()
            const nextOpening = new Date(now.getTime() + 60 * 60 * 1000) // 1 saat sonra
            
                  
            
            systemStatus.value = {
              success: true,
              status: 'preparing',
              message: 'Sistem manuel reset sonrası hazırlanıyor. 1 saat sonra randevu alma sistemi açılacak.',
              next_opening_time: nextOpening,
              last_reset_time: now,
              current_time: now,
              time_until_open: 60 * 60 * 1000 // 1 saat (milisaniye)
            }
        } else {
          const errorData = await response.json()
          error.value = errorData.error || 'Manuel reset hatası'
        }
      } catch (err) {
        error.value = 'Manuel reset yapılırken bir hata oluştu'
        console.error('Manuel reset hatası:', err)
      } finally {
        isResetting.value = false
        closeManualResetModal()
      }
    }

    // Yardımcı fonksiyonlar - Pazartesi haftanın başlangıcı, Pazar haftanın son günü
    const getWeekStartDate = (date) => {
      // Turkey timezone (+3) için tarihi ayarla
      const turkeyDate = new Date(date.toLocaleString("en-US", {timeZone: "Europe/Istanbul"}))
      
      // Pazar 19:00 kuralı: Pazar 19:00'dan sonra gelecek haftayı göster
      const isSundayAfter7PM = turkeyDate.getDay() === 0 && turkeyDate.getHours() >= 19
      
      if (isSundayAfter7PM) {
        // Pazar 19:00'dan sonra: Gelecek haftayı göster
        turkeyDate.setDate(turkeyDate.getDate() + 1) // Pazartesi'ye geç
      }
      
      const weekday = turkeyDate.getDay()
      // Pazar = 0, Pazartesi = 1, ..., Cumartesi = 6
      // Hafta başlangıcı Pazartesi günü olacak (Pazar haftanın son günü)
      const daysToMonday = weekday === 0 ? 6 : weekday - 1
      const monday = new Date(turkeyDate)
      monday.setDate(turkeyDate.getDate() - daysToMonday)
      
      
      return monday
    }

    // Hafta numarası hesaplama — ISO 8601 (backend utils.ISOWeek ile birebir)
    const getWeekNumber = (date) => {
      return isoWeek(date).week
    }

    const getWeekStartDateFromWeek = (year, week) => {
      // Turkey timezone (+3) için yılın başlangıcını ayarla
      const jan1 = new Date(year, 0, 1)
      const turkeyJan1 = new Date(jan1.toLocaleString("en-US", {timeZone: "Europe/Istanbul"}))
      
      const weekday = turkeyJan1.getDay()
      // Pazartesi günü haftanın başlangıcı olacak
      const daysToMonday = weekday === 0 ? 6 : weekday - 1
      const firstMonday = new Date(turkeyJan1)
      firstMonday.setDate(turkeyJan1.getDate() - daysToMonday)
      
      const targetMonday = new Date(firstMonday)
      targetMonday.setDate(firstMonday.getDate() + (week - 1) * 7)
      
      // Debug için
      
      
      return targetMonday
    }

        // Haftalık randevu gruplama fonksiyonları
    const weeklyAppointments = computed(() => {
      if (!appointments.value || appointments.value.length === 0) return []
      
      const weekGroups = {}
      
      appointments.value.forEach(appointment => {
        const appointmentDate = new Date(appointment.appointment_time)
        const weekStart = getWeekStartDate(appointmentDate)
        const weekNumber = getWeekNumber(appointmentDate)
        const year = appointmentDate.getFullYear()
        
        // Debug: Hafta hesaplama bilgilerini göster
              
        
        const weekKey = `${year}-${weekNumber}`
        
        if (!weekGroups[weekKey]) {
          weekGroups[weekKey] = {
            year,
            weekNumber,
            weekStartDate: weekStart,
            appointments: []
          }
        }
        
        weekGroups[weekKey].appointments.push(appointment)
      })
      
      // Haftaları tarihe göre sırala (en yeni önce)
      const sortedWeeks = Object.values(weekGroups).sort((a, b) => {
        if (a.year !== b.year) return b.year - a.year
        return b.weekNumber - a.weekNumber
      })
      
      
      
      
      
      return sortedWeeks
    })

    // Admin Appointment computed properties
    const canCreateAppointment = computed(() => {
      const canCreate = adminAppointment.value.studentUsername && 
                       adminAppointment.value.lessonId && 
                       adminAppointment.value.teacherId && 
                       adminAppointment.value.date && 
                       adminAppointment.value.timeSlot &&
                       foundStudent.value
      
      
      
      return canCreate
    })

    // Hafta tarih aralığı computed properties
    const currentWeekStart = computed(() => {
      const today = new Date()
      const weekStart = getWeekStartDate(today)
      return weekStart.toISOString().split('T')[0]
    })

    const currentWeekEnd = computed(() => {
      const today = new Date()
      const weekStart = getWeekStartDate(today)
      // 6 gün ekle (Pazartesi'den Pazar'a kadar, toplam 7 gün)
      const weekEnd = new Date(weekStart)
      weekEnd.setDate(weekStart.getDate() + 6)
      return weekEnd.toISOString().split('T')[0]
    })

    const expandedWeeks = ref({})
    
    // Otomatik refresh için timer
    const autoRefreshTimer = ref(null)

    const toggleWeek = (year, weekNumber) => {
      const weekKey = `${year}-${weekNumber}`
      expandedWeeks.value[weekKey] = !expandedWeeks.value[weekKey]
    }

    // Haftalık accordion toggle
    const toggleWeekAccordion = (weekStart) => {
      expandedWeeks.value[weekStart] = !expandedWeeks.value[weekStart]
    }

    // İstatistik computed properties
    const weeklyStats = computed(() => {
      if (!adminStatistics.value?.weekly_statistics) return []
      return adminStatistics.value.weekly_statistics.sort((a, b) => b.week_number - a.week_number)
    })

            // En iyi öğrenci ve öğretmen
    const getTopStudent = computed(() => {
      if (!adminStatistics.value?.top_students || adminStatistics.value.top_students.length === 0) return null
      return adminStatistics.value.top_students[0]
    })

    const getTopTeacher = computed(() => {
      if (!adminStatistics.value?.top_teachers || adminStatistics.value.top_teachers.length === 0) return null
      return adminStatistics.value.top_teachers[0]
    })
    
    // Site Settings fonksiyonları
    
    // Blog yönetimi fonksiyonları AdminBlog.vue bileşenine taşındı.



    
    // Utility fonksiyonları
    const showSuccessMessage = (message, title = 'Başarılı') => {
      successMessage.value = message
      successTitle.value = title
      showSuccessPopup.value = true
    }
    
    const showErrorMessage = (message) => {
      error.value = message
    }
    
    // Gelişmiş İstatistik Filtreleme computed'ları
    const totalPages = computed(() => {
      if (!filteredStatistics.value || !Array.isArray(filteredStatistics.value)) return 1
      return Math.ceil(filteredStatistics.value.length / itemsPerPage.value)
    })
    
    const paginatedStatistics = computed(() => {
      if (!filteredStatistics.value || !Array.isArray(filteredStatistics.value)) return []
      const start = (currentPage.value - 1) * itemsPerPage.value
      const end = start + itemsPerPage.value
      return filteredStatistics.value.slice(start, end)
    })

    const formatWeekTitle = (weekStartDate, weekNumber, year) => {
      const endDate = new Date(weekStartDate)
      endDate.setDate(weekStartDate.getDate() + 6)
      
      const startStr = weekStartDate.toLocaleDateString('tr-TR', {
        day: '2-digit',
        month: '2-digit'
      })
      
      const endStr = endDate.toLocaleDateString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
      
      // Hafta başlangıcı Pazartesi, bitişi Pazar
      return `${startStr} - ${endStr} (${weekNumber}. Hafta)`
    }

    // Hata mesajını ana mesaj ve detaylara ayır
    const getErrorMainMessage = () => {
      if (!error.value) return ''
      
      // Eğer hata mesajında "Detaylar:" varsa, ana mesajı ayır
      if (error.value.includes('Detaylar:')) {
        return error.value.split('Detaylar:')[0].trim()
      }
      
      return error.value
    }

    const getErrorDetails = () => {
      if (!error.value) return []
      
      // Eğer hata mesajında "Detaylar:" varsa, detayları ayır
      if (error.value.includes('Detaylar:')) {
        const detailsPart = error.value.split('Detaylar:')[1]
        if (detailsPart) {
          return detailsPart.trim().split('\n').filter(detail => detail.trim() !== '')
        }
      }
      
      return []
    }

    // Hata modal'ını kapat
    const pendingRedirect = ref(null)
    const closeErrorModal = () => {
      error.value = ''
      if (pendingRedirect.value) {
        const target = pendingRedirect.value
        pendingRedirect.value = null
        router.push(target)
      }
    }

    const closeSuccessPopup = () => {
      showSuccessPopup.value = false
      successMessage.value = ''
      successTitle.value = ''
    }

    // İstatistik sayfasına yönlendir
    const navigateToStatistics = () => {
      router.push('/panel/admin/statistics')
    }

    // Randevunun iptal edilebilir olup olmadığını kontrol eder
    const canCancelAppointment = (appointmentTime) => {
      if (!appointmentTime) return false
      
      const now = new Date()
      const appointmentDate = new Date(appointmentTime)
      
      // Randevu saati geçmişse veya randevu anı geldiyse iptal edilemez
      // 1 dakika tolerans veriyoruz (randevu başladıktan 1 dakika sonra iptal edilemez)
      const oneMinuteLater = new Date(appointmentDate.getTime() + 60000)
      
      return now < oneMinuteLater
    }

    // Otomatik refresh fonksiyonu - dakika başlarında randevuları yeniler
    const startAutoRefresh = () => {
      const scheduleNextRefresh = () => {
        // Eğer component unmount olduysa dur
        if (!autoRefreshTimer.value) return
        
        const now = new Date()
        const nextMinute = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() + 1, 0, 0)
        const delay = nextMinute.getTime() - now.getTime()
        
        // Dakika başında refresh yap
        autoRefreshTimer.value = setTimeout(async () => {
          // Token kontrolü - logout sonrası API istekleri durdur
          const token = localStorage.getItem('token')
          if (!token) {
            console.log('🚪 Token bulunamadı, auto refresh durduruluyor')
            return
          }
          
          // Mevcut scroll pozisyonunu kaydet
          const currentScrollPosition = window.scrollY
          
          await loadTabData('appointments')
          
          // Refresh sonrası scroll pozisyonunu geri yükle
          setTimeout(() => {
            window.scrollTo(0, currentScrollPosition)
          }, 100)
          
          // Sonraki dakika için tekrar planla
          scheduleNextRefresh()
        }, delay)
      }
      
      // İlk refresh'i planla
      scheduleNextRefresh()
    }

    // Otomatik refresh'i durdur
    const stopAutoRefresh = () => {
      if (autoRefreshTimer.value) {
        clearTimeout(autoRefreshTimer.value)
        autoRefreshTimer.value = null
        console.log('🛑 Auto refresh durduruldu')
      }
    }

    // Admin istatistiklerini yükle
    const fetchAdminStatistics = async () => {
      isLoadingStatistics.value = true
      statisticsError.value = ''
      
      try {
        const response = await axios.get('https://api.modernkurs.com/api/statistics/admin')
        
        if (response.data.success) {
          adminStatistics.value = response.data.data
                
          
          // Her hafta için öğrenci ve öğretmen verilerini kontrol et
          if (response.data.data.weekly_statistics) {
            response.data.data.weekly_statistics.forEach((week, index) => {
              
            })
          }
        } else {
          statisticsError.value = response.data.error || 'İstatistikler alınamadı'
        }
      } catch (err) {
        console.error('İstatistik yükleme hatası:', err)
        statisticsError.value = 'İstatistikler yüklenirken bir hata oluştu'
      } finally {
        isLoadingStatistics.value = false
      }
    }

    // İstatistik yardımcı fonksiyonları
    const getBarHeight = (count) => {
      if (!adminStatistics.value?.weekly_statistics) return '0%'
      const maxCount = Math.max(...adminStatistics.value.weekly_statistics.map(w => w.appointment_count))
      if (maxCount === 0) return '0%'
      return `${(count / maxCount) * 100}%`
    }
    
    const formatWeekDate = (weekStart) => {
      if (!weekStart) return ''
      const date = new Date(weekStart)
      const endDate = new Date(date)
      endDate.setDate(date.getDate() + 6)
      
      return `${date.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' })} - ${endDate.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' })}`
    }
    
    // Gelişmiş İstatistik Filtreleme fonksiyonları
    const applyFilters = async () => {
      isLoadingFiltered.value = true
      currentPage.value = 1
      
      try {
        // Backend'e filtreleme isteği gönder
        const response = await axios.get('https://api.modernkurs.com/api/statistics/filtered', {
          params: {
            start_date: filterStartDate.value,
            end_date: filterEndDate.value,
            user_type: filterUserType.value,
            name: filterName.value,
            username: filterUsername.value,
            sort_by: sortBy.value
          }
        })
        
        if (response.data.success) {
          filteredStatistics.value = response.data.data
          // Sayfa yenilendi mesajı
          
        } else {
          filteredStatistics.value = []
          console.error('Filtreleme hatası:', response.data.error)
        }
      } catch (error) {
        console.error('Filtreleme sırasında hata:', error)
        filteredStatistics.value = []
      } finally {
        isLoadingFiltered.value = false
      }
    }
    
    const clearFilters = () => {
      filterStartDate.value = ''
      filterEndDate.value = ''
      filterUserType.value = ''
      filterName.value = ''
      filterUsername.value = ''
      sortBy.value = 'appointment_count_desc'
      currentPage.value = 1
      // Filtreleri temizledikten sonra tüm kayıtları getir
      applyFilters()
    }
    
    const previousPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--
      }
    }
    
    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++
      }
    }
    
    const goToFirstPage = () => {
      currentPage.value = 1
    }
    
    const goToLastPage = () => {
      currentPage.value = totalPages.value
    }
    
    const exportToExcel = async () => {
      isExporting.value = true
      try {
        const response = await axios.get('https://api.modernkurs.com/api/statistics/export/excel', {
          params: {
            start_date: filterStartDate.value,
            end_date: filterEndDate.value,
            user_type: filterUserType.value,
            name: filterName.value,
            username: filterUsername.value,
            sort_by: sortBy.value
          },
          responseType: 'blob'
        })
        
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'istatistikler.xlsx')
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (err) {
        console.error('Excel export hatası:', err)
        error.value = 'Excel export sırasında hata oluştu.'
      } finally {
        isExporting.value = false
      }
    }

    // Admin Appointment Functions
    const searchStudent = async () => {
      
      
      if (adminAppointment.value.studentUsername.length === 4) {
        try {
          // Öğrenciyi bul
          const student = users.value.find(u => {
            
            return u.username === adminAppointment.value.studentUsername && u.role === 'ogrenci'
          })
          
          if (student) {
            foundStudent.value = student
            showAppointmentSummary.value = false
          } else {
            foundStudent.value = null
          }
        } catch (error) {
          console.error('❌ Öğrenci arama hatası:', error)
          foundStudent.value = null
        }
      } else {
        
        foundStudent.value = null
      }
    }

    const onLessonChange = () => {
      
      
      
      adminAppointment.value.teacherId = ''
      adminAppointment.value.date = ''
      adminAppointment.value.timeSlot = ''
      availableTeachers.value = []
      availableTimeSlots.value = []
      showAppointmentSummary.value = false
      
      if (adminAppointment.value.lessonId) {
        // Bu dersi verebilen öğretmenleri bul
        const teachersForLesson = teachers.value.filter(t => {
          
          
          // lesson_ids array'inde seçilen ders var mı kontrol et
          if (t.lesson_ids && Array.isArray(t.lesson_ids)) {
            return t.lesson_ids.includes(parseInt(adminAppointment.value.lessonId))
          }
          
          // Eski yöntem (lesson_id) - geriye uyumluluk için
          if (t.lesson_id !== undefined) {
            const teacherLessonId = parseInt(t.lesson_id) || t.lesson_id
            const selectedLessonId = parseInt(adminAppointment.value.lessonId)
            return teacherLessonId === selectedLessonId
          }
          
          return false
        })
        
        
        availableTeachers.value = teachersForLesson
      }
    }

    const onTeacherChange = () => {
              
      adminAppointment.value.date = ''
      adminAppointment.value.timeSlot = ''
      availableTimeSlots.value = []
      showAppointmentSummary.value = false
    }

    const onDateChange = async () => {
      adminAppointment.value.timeSlot = ''
      availableTimeSlots.value = []
      showAppointmentSummary.value = false
      
              // Tarih validasyonu - sadece mevcut hafta seçilebilir (25-31 Ağustos dahil)
        if (adminAppointment.value.date) {
          const selectedDate = new Date(adminAppointment.value.date)
          const weekStart = getWeekStartDate(new Date())
          const weekEnd = new Date(weekStart.getTime() + 6 * 24 * 60 * 60 * 1000)
          
          
          
          // Tarih karşılaştırmasında saat bilgisini sıfırla (sadece gün karşılaştırması)
          const selectedDateOnly = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate())
          const weekStartOnly = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate())
          const weekEndOnly = new Date(weekEnd.getFullYear(), weekEnd.getMonth(), weekEnd.getDate())
          
          
          
          if (selectedDateOnly < weekStartOnly || selectedDateOnly > weekEndOnly) {
            error.value = `Lütfen sadece bu hafta için tarih seçin! (${weekStart.toLocaleDateString('tr-TR')} - ${weekEnd.toLocaleDateString('tr-TR')})`
            adminAppointment.value.date = ''
            return
          }
        
                  
      }
      
      if (adminAppointment.value.teacherId && adminAppointment.value.date) {
                  
        await loadAvailableTimeSlots()
      }
    }

    const loadAvailableTimeSlots = async () => {
      try {
        const teacherId = adminAppointment.value.teacherId
        const date = adminAppointment.value.date
        
              
        
        // Öğretmenin o tarihteki müsaitliklerini backend'den çek
        const response = await axios.get(`https://api.modernkurs.com/api/teacher-availability/${teacherId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        if (!response.data.success) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`)
        }
        
        const availabilityData = response.data
                  
        
        // Backend'den gelen veri yapısını kontrol et
        if (availabilityData.success && availabilityData.data && availabilityData.data.availability) {
          const dayOfWeek = new Date(date).getDay()
          const dayNames = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi']
          const dayName = dayNames[dayOfWeek]
          
          // Backend'de İngilizce gün adları kullanılıyor, Türkçe'ye çevir
          const dayNameMapping = {
            'Pazar': 'sunday',
            'Pazartesi': 'monday', 
            'Salı': 'tuesday',
            'Çarşamba': 'wednesday',
            'Perşembe': 'thursday',
            'Cuma': 'friday',
            'Cumartesi': 'saturday'
          }
          
          const backendDayName = dayNameMapping[dayName]
          
                      
          
          // Müsaitlik verisinde bu gün var mı kontrol et
          if (availabilityData.data.availability[backendDayName] && Array.isArray(availabilityData.data.availability[backendDayName])) {
            // Sadece müsait (is_booked = false) olan slot'ları al
            const availableSlots = availabilityData.data.availability[backendDayName]
              .filter(slot => !slot.is_booked)
              .map(slot => slot.time_slot)
            
            availableTimeSlots.value = availableSlots
          } else {
            availableTimeSlots.value = []
          }
        } else {
          availableTimeSlots.value = []
        }
        
      } catch (err) {
        console.error('❌ Müsait saat yükleme hatası:', err)
        availableTimeSlots.value = []
        error.value = `Müsait saatler yüklenirken hata oluştu: ${err.message}`
      }
    }

    const formatAppointmentDateTime = (date, timeSlot) => {
      if (!date || !timeSlot) return ''
      const dateObj = new Date(date)
      const formattedDate = dateObj.toLocaleDateString('tr-TR')
      return `${formattedDate} ${timeSlot}`
    }

    const formatDateRange = (startDate, endDate) => {
      if (!startDate || !endDate) return ''
      const start = new Date(startDate)
      const end = new Date(endDate)
      return `${start.toLocaleDateString('tr-TR')} - ${end.toLocaleDateString('tr-TR')}`
    }

    const createAdminAppointment = async () => {
      if (!canCreateAppointment.value) return
      
      isCreatingAppointment.value = true
      try {
        // Tarih ve saat formatını SelectTime.vue mantığıyla düzelt
        const appointmentTime = new Date(adminAppointment.value.date)
        const [hours, minutes] = adminAppointment.value.timeSlot.split('-')[0].split(':')
        appointmentTime.setHours(parseInt(hours), parseInt(minutes), 0, 0)
        
        const appointmentTimeStr = appointmentTime.toISOString()
        
        const appointmentData = {
          student_username: adminAppointment.value.studentUsername,
          lesson_id: parseInt(adminAppointment.value.lessonId),
          teacher_id: parseInt(adminAppointment.value.teacherId),
          appointment_time: appointmentTimeStr
        }
        
        
        
        // Backend endpoint'i çağır
        const response = await axios.post('https://api.modernkurs.com/api/admin/appointments', appointmentData, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        if (!response.data.success) {
          throw new Error(response.data.error || 'Randevu oluşturulamadı')
        }
        
        const result = response.data
        
        
        // Başarı mesajı göster
        successTitle.value = '✅ Randevu Oluşturuldu'
        successMessage.value = `${foundStudent.value.ad} ${foundStudent.value.soyad} için randevu başarıyla oluşturuldu.`
        showSuccessPopup.value = true
        
        // Formu temizle
        resetAdminAppointmentForm()
        
        // Randevuları yenile
        await store.dispatch('fetchAllAppointments')
        
      } catch (error) {
        console.error('Admin randevu oluşturma hatası:', error)
        error.value = 'Randevu oluşturulurken hata oluştu: ' + error.message
      } finally {
        isCreatingAppointment.value = false
      }
    }

    const resetAdminAppointmentForm = () => {
      // Mevcut haftanın ilk gününü (Pazartesi - 25 Ağustos) varsayılan tarih olarak ayarla
      const today = new Date()
      const weekStart = getWeekStartDate(today)
      const defaultDate = weekStart.toISOString().split('T')[0]
      
      adminAppointment.value = {
        studentUsername: '',
        lessonId: '',
        teacherId: '',
        date: defaultDate, // Mevcut haftanın Pazartesi'si (25 Ağustos)
        timeSlot: ''
      }
      foundStudent.value = null
      availableTeachers.value = []
      availableTimeSlots.value = []
      showAppointmentSummary.value = false
      
              
    }

    // Watch for changes to show appointment summary
    watch(() => [adminAppointment.value.studentUsername, adminAppointment.value.lessonId, 
                   adminAppointment.value.teacherId, adminAppointment.value.date, 
                   adminAppointment.value.timeSlot], 
      ([student, lesson, teacher, date, time]) => {
        if (student && lesson && teacher && date && time && foundStudent.value) {
          showAppointmentSummary.value = true
        } else {
          showAppointmentSummary.value = false
        }
      }
    )


    return {
      activeTab,
      isLoading,
      isSubmitting,
      error,
      slotSettingsForm,
      slotSettingsSaving,
      showSlotConfirmDialog,
      submitSlotSettings,
      confirmSlotSettingsSave,
      lessons,
      teachers,
      appointments,
      users, // Yeni eklenen kullanıcılar
      currentUser,
      newLesson,
      newTeacher,
      newUser, // Yeni eklenen kullanıcı formu
      createLesson,
      deleteLesson,
      createTeacher,
      deleteTeacher,
      toggleTeacherBlock,
      createUser,
      deleteUser,
      cancelAppointment,
      getLessonName,
      getTeacherName,
      getTeacherFullName,
      getStatusText,
      formatDateTime,
      formatDate, // Yeni eklenen formatDate fonksiyonu
      getSystemStatusText, // Sistem durumu metni
      formatTimeUntilOpen, // Açılışa kalan süre
      openProfileModal,
      getInitials,
      logout,
      confirmLogout,
      cancelLogout,
      goHome,
      loadAdminInfo,
      handleWindowFocus,
      editingLesson,
      editingTeacher,
      editingUser, // Yeni eklenen kullanıcı düzenleme durumu
      editLesson,
      editTeacher,
      updateLesson,
      updateTeacher,
      editUser, // Yeni eklenen editUser fonksiyonu
      updateUser, // Yeni eklenen updateUser fonksiyonu
      showLessonModal,
      showTeacherModal,
      showUserModal,
      showAvailabilityModal,
      showProfileModal,
      selectedTeacher,
      closeLessonModal,
      closeTeacherModal,
      closeUserModal,
      closeAvailabilityModal,
      openAvailabilityModal,
      openEditAvailabilityModal,
      closeEditAvailabilityModal,
      saveAvailabilityChanges,
      showEditAvailabilityModal,
      editAvailabilityComponent,
      updateTeacherAvailability, // Yeni eklenen updateTeacherAvailability fonksiyonu
      updateEditingTeacherAvailability,
      getAvailabilitySummary, // Yeni eklenen getAvailabilitySummary fonksiyonu
      systemStatus, // Sistem durumu
      loadSystemStatus, // Sistem durumunu yükle

      manualWeeklyReset, // Manuel haftalık reset
      setSystemReady, // Sistemi hazır yap
      isResetting, // Reset durumu

      isSettingReady, // Sistem hazır yapma durumu
      closeErrorModal, // Yeni eklenen closeErrorModal fonksiyonu
      getErrorMainMessage, // Hata ana mesajını al
      getErrorDetails, // Hata detaylarını al
      
      // Sistem hazır modal
      showSystemReadyModal,
      closeSystemReadyModal,
      confirmSystemReady,
      
      // Manuel reset modal
      showManualResetModal,
      closeManualResetModal,
      confirmManualReset,
    
      
      // Haftalık randevu gruplama
      weeklyAppointments,
      expandedWeeks,
      toggleWeek,
      formatWeekTitle,
      getWeekStartDate,
      
      // İstatistik yönlendirme
      navigateToStatistics,
      
      // İstatistik değişkenleri ve fonksiyonları
      isLoadingStatistics,
      statisticsError,
      adminStatistics,
      weeklyStats,
      getTopStudent,
      getTopTeacher,
      
      // Admin Appointment Booking
      
      // Blog yönetimi AdminBlog.vue bileşenine taşındı
      showSuccessMessage,
      showErrorMessage,
      adminAppointment,
      foundStudent,
      availableTeachers,
      availableTimeSlots,
      showAppointmentSummary,
      isCreatingAppointment,
      canCreateAppointment,
      currentWeekStart,
      currentWeekEnd,
      searchStudent,
      onLessonChange,
      onTeacherChange,
      onDateChange,
      createAdminAppointment,
      resetAdminAppointmentForm,
      formatAppointmentDateTime,
      formatDateRange,
      
      // Zaman kontrolü fonksiyonu
      canCancelAppointment,
      fetchAdminStatistics,
      
      // Gelişmiş İstatistik Filtreleme değişkenleri ve fonksiyonları
      filterStartDate,
      filterEndDate,
      filterUserType,
      filterName,
      filterUsername,
      sortBy,
      filteredStatistics,
      isLoadingFiltered,
      currentPage,
      itemsPerPage,
      totalPages,
      paginatedStatistics,
      applyFilters,
      clearFilters,
      previousPage,
      nextPage,
      goToFirstPage,
      goToLastPage,
      exportToExcel,
      
      // Tüm öğrencileri sil işlemleri
      showDeleteAllStudentsConfirm,
      showDeleteAllStudentsConfirmPopup,
      cancelDeleteAllStudents,
      confirmDeleteAllStudents,
      isDeletingAllStudents,
      getBarHeight,
      formatWeekDate,
      toggleWeekAccordion,
      
      // Toplu yükleme değişkenleri ve fonksiyonları
      selectedFile,
      isUploading,
      excelFileInput,
      handleFileSelect,
      clearFileSelection,
      uploadExcelFile,
      
      // Excel export değişkenleri ve fonksiyonları
      isExporting,
      exportStudentsToExcel,
      
      // Müsaitlik yenileme
      refreshAvailability,
      
      // Başarı popup
      showSuccessPopup,
      successMessage,
      successTitle,
      closeSuccessPopup,
      
      // Silme onay popup
      showDeleteConfirmPopup,
      deleteConfirmData,
      deleteConfirmType,
      showLogoutConfirmPopup,
      confirmDelete,
      cancelDelete,
      
      // Randevu iptal onay popup
      showCancelAppointmentPopup,
      cancelAppointmentData,
      confirmCancelAppointment,
      cancelCancelAppointment,
      formatAppointmentDate,
      
      // Yönetici yönetimi değişkenleri ve fonksiyonları
      admins,
      isLoadingAdmins,
      adminsError,
      isCreatingAdmin,
      showAdminModal,
      editingAdmin,
      newAdmin,
      createAdmin,
      editAdmin,
      updateAdmin,
      deleteAdmin,
      closeAdminModal,
      
      // Scroll-to-top değişkenleri ve fonksiyonları
      showScrollToTop,
      scrollToTop,
      
      // Validation fonksiyonları
      validateUsername,
      validateStudentUsername,
      validateAdminUsername,
      
    }
  }
}
</script>

<style scoped>
/* Modern System Ready Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 1rem;
}

.modal-content {
  background: white;
  border-radius: 20px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 1.5rem 1rem;
  border-bottom: 1px solid #f1f3f4;
  position: relative;
}

.modal-icon {
  font-size: 2rem;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 15px;
  color: white;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  flex: 1;
}

.modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.modal-close:hover {
  background: #f1f3f4;
  color: #333;
}

.modal-body {
  padding: 1.5rem;
}

.warning-section,
.info-section {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  border-radius: 12px;
}

.warning-section {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
}

.info-section {
  background: #d1ecf1;
  border: 1px solid #bee5eb;
}

.warning-icon,
.info-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.warning-content h4,
.info-content h4 {
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.warning-content h4 {
  color: #856404;
}

.info-content h4 {
  color: #0c5460;
}

.warning-content p,
.info-content p {
  margin: 0;
  color: #856404;
  line-height: 1.5;
}

.info-content ul {
  margin: 0.5rem 0 0 0;
  padding-left: 1.2rem;
  color: #0c5460;
}

.info-content li {
  margin-bottom: 0.3rem;
  line-height: 1.4;
}

.modal-footer {
  display: flex;
  gap: 1rem;
  padding: 1rem 1.5rem 1.5rem;
  border-top: 1px solid #f1f3f4;
  justify-content: flex-end;
}

.btn-cancel,
.btn-confirm {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.btn-cancel {
  background: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

.btn-cancel:hover {
  background: #e9ecef;
  color: #495057;
  transform: translateY(-1px);
}

.btn-confirm {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

.btn-confirm:hover:not(:disabled) {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(40, 167, 69, 0.4);
}

.btn-confirm:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* Danger Section Styles */
.danger-section {
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  margin-bottom: 1.5rem;
}

.danger-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.danger-content h4 {
  color: #721c24;
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.danger-content p {
  margin: 0;
  color: #721c24;
  line-height: 1.5;
}

.danger-content strong {
  font-weight: 700;
}

/* Danger Button Styles */
.btn-danger {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}

.btn-danger:hover:not(:disabled) {
  background: linear-gradient(135deg, #c82333 0%, #a71e2a 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.4);
}

.btn-danger:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* Responsive Modal */
@media (max-width: 768px) {
  .modal-content {
    max-width: 95vw;
    margin: 0.5rem;
  }
  
  .modal-header {
    padding: 1rem 1rem 0.75rem;
  }
  
  .modal-body {
    padding: 1rem;
  }
  
  .modal-footer {
    padding: 0.75rem 1rem 1rem;
    flex-direction: column;
  }
  
  .btn-cancel,
  .btn-confirm,
  .btn-danger {
    width: 100%;
    min-width: auto;
  }
}
.required {
  color: #e74c3c;
  font-weight: bold;
}

.scroll-to-top-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #ffffff;
  color: #333333;
  border: 2px solid #e0e0e0;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0;
  overflow: hidden;
}

.scroll-to-top-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  background: #f8f9fa;
  border-color: #667eea;
  color: #667eea;
}

.scroll-to-top-button:active {
  transform: translateY(-1px);
}

.scroll-to-top-button .scroll-icon {
  font-size: 18px;
  transition: all 0.3s ease;
  color: inherit;
}

.scroll-to-top-button:hover .scroll-icon {
  transform: translateY(-1px);
}

/* Mobile responsive */
@media (max-width: 768px) {
  .scroll-to-top-button {
    bottom: 20px;
    right: 20px;
    width: 45px;
    height: 45px;
  }
  
  .scroll-to-top-button .scroll-icon {
    font-size: 16px;
  }
}
.admin-container {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
}

.header-content h1 {
  margin: 0 0 0.5rem 0;
  font-size: 2rem;
  font-weight: 600;
}



.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.guide-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #ffffff;
  color: #2c3e50;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 25px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.guide-link:hover {
  border-color: #4CAF50;
  color: #2e7d32;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.15);
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.profile-info:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.profile-avatar {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.2rem;
  color: white;
}

.profile-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.profile-name {
  font-weight: 600;
  font-size: 1rem;
}

.profile-role {
  font-size: 0.9rem;
  opacity: 0.8;
}

.profile-arrow {
  font-size: 0.8rem;
  opacity: 0.7;
  transition: transform 0.3s;
}

.profile-info:hover .profile-arrow {
  transform: rotate(180deg);
}

.back-button {
  padding: 0.5rem 1rem;
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.tabs {
  display: flex;
  margin-bottom: 2rem;
  border-bottom: 1px solid #ddd;
}

.tab-button {
  padding: 0.75rem 1.5rem;
  background-color: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s;
}

.tab-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.tab-button.active {
  border-bottom-color: #4CAF50;
  color: #4CAF50;
}

.tab-content {
  margin-bottom: 2rem;
  padding: 0 1rem;
}

.tab-content h2 {
  margin-bottom: 1.5rem;
  color: #ffffff;
  font-size: 1.75rem;
}

/* Tab content responsive */
@media (max-width: 768px) {
  .tab-content {
    padding: 0 0.5rem;
    margin-bottom: 1.5rem;
  }
  
  .tab-content h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
}

@media (max-width: 480px) {
  .tab-content {
    padding: 0 0.25rem;
    margin-bottom: 1rem;
  }
  
  .tab-content h2 {
    font-size: 1.25rem;
    text-align: center;
  }
}

.form-container {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Form container responsive */
@media (max-width: 768px) {
  .form-container {
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
}

@media (max-width: 480px) {
  .form-container {
    padding: 0.75rem;
    margin-bottom: 1rem;
  }
}

.form-container h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #333;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.form-group textarea {
  min-height: 100px;
  resize: vertical;
}

.submit-button {
  padding: 0.75rem 1.5rem;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: #45a049;
}

.submit-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.list-container {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* List container responsive */
@media (max-width: 768px) {
  .list-container {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .list-container {
    padding: 0.75rem;
  }
}

.list-container h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #333;
}

.data-table {
  overflow-x: auto;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: white;
}

/* Tablo responsive tasarım */
@media (max-width: 768px) {
  .data-table {
    overflow-x: auto;
    border-radius: 8px;
  }
  
  table {
    min-width: 600px; /* Minimum genişlik */
  }
  
  th, td {
    padding: 0.5rem 0.375rem;
    font-size: 0.875rem;
  }
  
  .edit-button,
  .delete-button {
    padding: 0.375rem 0.5rem;
    font-size: 0.8rem;
    margin-right: 0.25rem;
  }
}

@media (max-width: 480px) {
  .data-table {
    margin: 0 -1rem;
    border-radius: 0;
  }
  
  th, td {
    padding: 0.375rem 0.25rem;
    font-size: 0.8rem;
  }
  
  .edit-button,
  .delete-button {
    padding: 0.25rem 0.375rem;
    font-size: 0.75rem;
    margin-right: 0.125rem;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f5f5f5;
  font-weight: 600;
}

.delete-button {
  padding: 0.5rem 0.75rem;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.delete-button:hover {
  background-color: #d32f2f;
}

.edit-button {
  padding: 0.5rem 0.75rem;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 0.5rem;
}

.edit-button:hover {
  background-color: #1976D2;
}

.loading, .no-data {
  text-align: center;
  padding: 2rem;
  color: #666;
}



.status-beklemede {
  color: #ff9800;
}

.status-onaylandı {
  color: #4CAF50;
}

.status-iptal {
  color: #f44336;
}

.edit-form {
  background-color: #f5f5f5;
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.edit-form h4 {
  margin-top: 0;
  margin-bottom: 1rem;
  color: #333;
}

.form-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
}

.form-actions button {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.form-actions button[type="submit"] {
  background-color: #4CAF50;
  color: white;
}

.form-actions button[type="submit"]:hover {
  background-color: #45a049;
}

.form-actions button[type="button"] {
  background-color: #f44336;
  color: white;
}

.form-actions button[type="button"]:hover {
  background-color: #d32f2f;
}

.role-ogrenci {
  color: #4CAF50;
  font-weight: bold;
}

        .role-ogretmen {
  color: #2196F3;
  font-weight: bold;
}

.role-admin {
  color: #f44336;
  font-weight: bold;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 500px;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Müsaitlik modalları için özel genişlik */
.availability-modal.modal-content {
  max-width: 1400px;
  width: 98%;
  max-height: 98vh;
}

/* Profil modal için özel genişlik */
.profile-modal.modal-content {
  max-width: 900px;
  width: 95%;
  max-height: 90vh;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: #4CAF50;
  color: white;
  position: relative;
}

.modal-header h3 {
  margin: 0;
  color: white;
}

.modal-close {
  background-color: transparent;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: white;
  padding: 0.5rem;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
}

.modal-actions button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.modal-actions .btn-primary {
  background-color: #4CAF50;
  color: white;
}

.modal-actions .btn-primary:hover {
  background-color: #45a049;
}

.modal-actions .btn-secondary {
  background-color: #f44336;
  color: white;
}

.modal-actions .btn-secondary:hover {
  background-color: #d32f2f;
}

/* Modal responsive tasarım */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    max-width: none;
    margin: 1rem;
  }
  
  .modal-header {
    padding: 0.75rem 1rem;
  }
  
  .modal-header h3 {
    font-size: 1.125rem;
  }
  
  .modal-close {
    font-size: 1.5rem;
    padding: 0.25rem;
  }
  
  .modal-body {
    padding: 1rem;
  }
  
  .modal-actions {
    padding: 0.75rem 1rem;
    flex-direction: column;
  }
  
  .modal-actions button {
    padding: 0.625rem 1rem;
    font-size: 0.9rem;
    width: 100%;
  }
  
  .availability-modal.modal-content {
  width: 98%;
  margin: 0.5rem;
}

.lesson-modal .modal-close,
.teacher-modal .modal-close,
.user-modal .modal-close,
.admin-modal .modal-close,
.availability-modal .modal-close {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 1.5rem;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.lesson-modal .modal-close:hover,
.teacher-modal .modal-close:hover,
.user-modal .modal-close:hover,
.admin-modal .modal-close:hover,
.availability-modal .modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-50%) scale(1.1);
}
  
  .profile-modal.modal-content {
  width: 98%;
  margin: 0.5rem;
}

.profile-modal .modal-close {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 1.5rem;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.profile-modal .modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-50%) scale(1.1);
}
}

@media (max-width: 480px) {
  .modal-content {
    width: 98%;
    margin: 0.5rem;
    border-radius: 6px;
  }
  
  .modal-header {
    padding: 0.5rem 0.75rem;
  }
  
  .modal-header h3 {
    font-size: 1rem;
  }
  
  .modal-body {
    padding: 0.75rem;
  }
  
  .modal-actions {
    padding: 0.5rem 0.75rem;
  }
  
  .modal-actions button {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
  }
  
  /* Yönetici düzenleme modal'ı mobilde daha kompakt */
  .form-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  
  .form-group label {
    font-size: 0.85rem;
  }
  
  .modern-input,
  .modern-textarea,
  .modern-select {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
  }
}

/* Ders Tag Stilleri */
.lesson-tag {
  display: inline-block;
  background-color: #4CAF50;
  color: white;
  padding: 0.25rem 0.5rem;
  margin: 0.1rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
}

.no-lesson {
  color: #999;
  font-style: italic;
}

.availability-summary {
  background-color: #e8f5e8;
  color: #2e7d32;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.no-availability {
  color: #999;
  font-style: italic;
  font-size: 0.8rem;
}

/* Multiple Select Stilleri */
select[multiple] {
  min-height: 100px;
}

select[multiple] option {
  padding: 0.5rem;
}

/* Checkbox Group Styles */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0.75rem;
  background-color: #f9f9f9;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0;
}

.checkbox-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #4CAF50;
}

.checkbox-item label {
  cursor: pointer;
  font-size: 0.9rem;
  user-select: none;
  flex: 1;
}

.checkbox-item:hover {
  background-color: #f0f0f0;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  margin: 0 -0.5rem;
}

.checkbox-group::-webkit-scrollbar {
  width: 6px;
}

.checkbox-group::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.checkbox-group::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.checkbox-group::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Müsaitlik Butonları Container */
.availability-buttons {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

/* Müsaitlik İnceleme Butonu */
.view-availability-btn {
  padding: 0.5rem 1rem;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: background-color 0.3s;
}

.view-availability-btn:hover {
  background-color: #1976D2;
}

/* Müsaitlik Düzenleme Butonu */
.edit-availability-btn {
  background-color: #FF9800;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  margin-left: 0.5rem;
  transition: background-color 0.3s;
}

.edit-availability-btn:hover {
  background-color: #F57C00;
}

/* Düzenleme Modal'ında Müsaitlik Görünümü */
.edit-availability-view {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 1rem;
  background-color: #f9f9f9;
}

/* Edit Modunda Slot'lar */
.edit-availability-view :deep(.time-slot) {
  cursor: pointer !important;
  transition: all 0.2s ease;
}

.edit-availability-view :deep(.time-slot:hover) {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.edit-availability-view :deep(.time-slot.available) {
  background-color: #4CAF50;
  color: white;
}

.edit-availability-view :deep(.time-slot.booked) {
  background-color: #f44336;
  color: white;
}

.edit-availability-view :deep(.time-slot.booked-by-student) {
  background-color: #9c27b0;
  color: white;
  cursor: not-allowed !important;
}

.edit-availability-view :deep(.time-slot.not-available) {
  background-color: #9e9e9e;
  color: white;
}

/* Müsaitlik Modal Stilleri */
.availability-modal {
  max-width: 1400px; /* 1200px'den 1400px'e çıkarıldı */
  width: 98%; /* 95%'den 98%'e çıkarıldı */
  max-height: 98vh; /* 95vh'den 98vh'ye çıkarıldı */
}

.availability-modal .modal-body {
  max-height: 85vh; /* 80vh'den 85vh'ye çıkarıldı */
  overflow-y: auto;
  padding: 2.5rem; /* 2rem'den 2.5rem'e çıkarıldı */
}

.availability-modal .modal-body :deep(.teacher-availability-display) {
  margin: 0;
  min-height: 600px; /* Minimum yükseklik eklendi */
  width: 100%;
}

.availability-modal .modal-body :deep(.availability-container) {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.availability-modal .modal-body :deep(.week-selector) {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.availability-modal .modal-body :deep(.time-slots) {
  gap: 1rem; /* 0.75rem'den 1rem'e çıkarıldı */
}

.availability-modal .modal-body :deep(.time-slot) {
  min-width: 130px; /* 110px'den 130px'e çıkarıldı */
  height: 50px; /* 45px'den 50px'e çıkarıldı */
  font-size: 0.95rem; /* Font boyutu eklendi */
}

/* Responsive tasarım için */
@media (max-width: 1400px) {
  .availability-modal {
    max-width: 95%;
    width: 95%;
  }
  
  .availability-modal .modal-body :deep(.time-slot) {
    min-width: 120px;
    height: 45px;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .availability-modal {
    max-width: 98%;
    width: 98%;
    max-height: 95vh;
  }
  
  .availability-modal .modal-body {
    padding: 1.5rem;
    max-height: 80vh;
  }
  
  .availability-modal .modal-body :deep(.time-slot) {
    min-width: 100px;
    height: 40px;
    font-size: 0.85rem;
  }
}



.refresh-button:disabled {
  background: #ccc;
  cursor: not-allowed;
}



.schedule-history {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.schedule-history h3 {
  margin: 0 0 1.5rem 0;
  color: #333;
  font-size: 1.1rem;
}

.history-table {
  overflow-x: auto;
}

.history-table table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

.history-table th,
.history-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.history-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}

.history-table td {
  color: #666;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
}

.status-badge.active {
  background: #e8f5e8;
  color: #2e7d32;
}

.status-öğrenci\ katılmadı {
  background: #f8d7da;
  color: #721c24;
}

/* Haftalık Accordion Stilleri */
.weekly-accordion {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.week-accordion-item {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.week-accordion-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.week-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.week-header:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
  transform: translateY(-1px);
}

.week-header.expanded {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
}

.week-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.week-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.appointment-count {
  font-size: 0.9rem;
  opacity: 0.9;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
}

.week-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transition: all 0.3s ease;
}

.week-toggle i {
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

.week-toggle i.rotated {
  transform: rotate(180deg);
}

.week-content {
  background: white;
  border-top: 1px solid #e0e0e0;
}

.week-content .data-table {
  margin: 0;
  border-radius: 0;
  box-shadow: none;
}

.week-content table {
  margin: 0;
}

.week-content th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}

.week-content td {
  border-bottom: 1px solid #f0f0f0;
}

/* Responsive tasarım */
@media (max-width: 768px) {
  .week-header {
    padding: 1rem;
  }
  
  .week-title {
    font-size: 1rem;
  }
  
  .appointment-count {
    font-size: 0.8rem;
  }
  
  .week-toggle {
    width: 35px;
    height: 35px;
  }
}

.status-badge.inactive {
  background: #ffebee;
  color: #d32f2f;
}

/* Sistem durumu stilleri */
.status-preparing {
  background: #fff3e0;
  color: #f57c00;
  font-weight: 600;
}

.status-ready {
  background: #e8f5e8;
  color: #388e3c;
  font-weight: 600;
}

.status-maintenance {
  background: #ffebee;
  color: #d32f2f;
  font-weight: 600;
}

.countdown {
  font-family: monospace;
  font-size: 1.1em;
  font-weight: bold;
  color: #f57c00;
}

.cancel-button {
  background: #f44336;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.cancel-button:hover {
  background: #d32f2f;
  transform: translateY(-1px);
}

.cancel-button.disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.7;
}

.cancel-button.disabled:hover {
  background: #6c757d;
  transform: none;
}

.cancelled-text {
  color: #f44336;
  font-style: italic;
  font-size: 0.9rem;
}

/* Öğrenci katılmadı durumu için özel stil */
.cancelled-text:contains("Öğrenci Katılmadı") {
  color: #ff9800;
  font-weight: 500;
}

/* Form Select Stili */
.form-select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  background-color: white;
  transition: border-color 0.3s ease;
}

.form-select:focus {
  outline: none;
  border-color: #4CAF50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
}

.form-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}



/* Profil Modal Stilleri */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 16px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #f0f0f0;
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  border-radius: 16px 16px 0 0;
  position: relative;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
}

.modal-body {
  padding: 2rem;
}

.profile-section {
  text-align: center;
  margin-bottom: 2rem;
}

.profile-avatar-large {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
  margin: 0 auto 1.5rem;
  box-shadow: 0 8px 20px rgba(76, 175, 80, 0.4);
}

.profile-info-grid {
  display: grid;
  gap: 1rem;
  text-align: left;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #4CAF50;
}

.info-item label {
  font-weight: 600;
  color: #495057;
  min-width: 120px;
}

.info-item span {
  color: #212529;
  font-weight: 500;
}

.role-badge {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
}

.profile-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
  min-width: 0; /* Grid taşmasını önle */
  width: 100%;
}

/* Responsive tasarım için */
@media (max-width: 640px) {
  .profile-stats {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

.stat-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  border: 1px solid #e9ecef;
  transition: transform 0.3s, box-shadow 0.3s;
  min-width: 0; /* Taşmayı önle */
  overflow: hidden; /* İçerik taşmasını önle */
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.stat-number {
  display: block;
  font-size: 2rem;
  font-weight: bold;
  color: #4CAF50;
  margin-bottom: 0.5rem;
  line-height: 1.2;
}

.stat-label {
  font-size: 1rem;
  color: #6c757d;
  font-weight: 500;
  line-height: 1.3;
}

.profile-actions {
  text-align: center;
}

.logout-button {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
  margin-bottom: 12px; /* Alt boşluğu hafif artırıldı */
}

.logout-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
}

/* Modern Admin Panel Styles — Login ile aynı Academic Precision paleti */
.admin-panel {
  min-height: 100vh;
  background-color: #000a21;
  background-image:
    radial-gradient(circle at 20% 30%, #12213d 0%, transparent 55%),
    radial-gradient(circle at 80% 70%, #001e2b 0%, transparent 55%);
}

.panel-header {
  background: white;
  color: #333;
  padding: 1.5rem 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.header-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.header-title-section {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  pointer-events: none;
}

.header-title-section h1 {
  margin: 0;
  font-size: 2.2rem;
  font-weight: 700;
  color: #333;
  white-space: nowrap;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.header-logo {
  width: 500%;
  height: 130px;
  object-fit: contain;
}



.header-subtitle {
  margin: 0.5rem 0 0 0;
  color: #666;
  font-size: 1.1rem;
}

.header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 0;
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
}

.profile-info:hover {
  background: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.profile-avatar {
  width: 45px;
  height: 45px;
  background: #667eea;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
}

.profile-details {
  display: flex;
  flex-direction: column;
}

.profile-name {
  font-weight: 600;
  font-size: 1rem;
  color: #333;
}

.profile-role {
  font-size: 0.9rem;
  color: #666;
}

.profile-arrow {
  font-size: 1.2rem;
  transition: transform 0.3s;
}

.profile-info:hover .profile-arrow {
  transform: rotate(180deg);
}

/* Tab Navigation */
.tab-navigation {
  background: white;
  padding: 1rem 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.tab-container {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.tab-container::-webkit-scrollbar {
  height: 6px;
}

.tab-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.tab-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.tab-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.tab-button {
  background: #f8f9fa;
  border: 2px solid transparent;
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 600;
  color: #6c757d;
  transition: all 0.3s;
  white-space: nowrap;
  min-width: 120px;
  flex-shrink: 0;
}

.tab-button:hover {
  background: #e9ecef;
  transform: translateY(-2px);
}

.tab-button.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

/* Tab Content */
.tab-content {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.section-header {
  margin-bottom: 2rem;
  text-align: center;
}

.section-header h2 {
  margin: 0 0 0.5rem 0;
  font-size: 2rem;
  color: #ffffff;
  font-weight: 700;
}

.section-header p {
  margin: 0;
  color: #ffffff;
  font-size: 1.1rem;
}

/* Mobil responsive section-header */
@media (max-width: 768px) {
  .section-header {
    margin-bottom: 1.5rem;
  }
  
  .section-header h2 {
    font-size: 1.75rem;
  }
  
  .section-header p {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .section-header {
    margin-bottom: 1rem;
  }
  
  .section-header h2 {
    font-size: 1.5rem;
  }
  
  .section-header p {
    font-size: 0.9rem;
  }
}

/* Action Cards */
.action-card {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.card-header {
  text-align: center;
  margin-bottom: 2rem;
}

.card-header h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.5rem;
  color: #333;
  font-weight: 600;
}

.card-header p {
  margin: 0;
  color: #6c757d;
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

/* Yönetici ekleme formu responsive tasarım */
@media (max-width: 768px) {
  .action-card {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    border-radius: 16px;
  }
  
  .card-header h3 {
    font-size: 1.25rem;
  }
  
  .form-single-column {
    gap: 1rem;
  }
  
  .form-group label {
    font-size: 0.9rem;
  }
  
  .modern-input,
  .modern-textarea,
  .modern-select {
    padding: 0.625rem 0.875rem;
    font-size: 0.9rem;
  }
  
  .form-help {
    font-size: 0.8rem;
  }
  
  /* Yönetici ekleme formu mobilde daha kompakt */
  .form-actions {
    margin-top: 1rem;
  }
  
  .btn-primary {
    width: 100%;
    padding: 0.875rem 1rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .action-card {
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 12px;
  }
  
  .card-header h3 {
    font-size: 1.125rem;
  }
  
  .card-header p {
    font-size: 0.875rem;
  }
  
  .form-single-column {
    gap: 0.75rem;
  }
  
  .form-group label {
    font-size: 0.85rem;
  }
  
  .modern-input,
  .modern-textarea,
  .modern-select {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
  }
  
  .form-help {
    font-size: 0.75rem;
  }
}

/* Form Single Column */
.form-single-column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
  width: 100%;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #333;
}

.modern-input,
.modern-textarea,
.modern-select {
  padding: 0.75rem 1rem;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s;
  background: #f8f9fa;
}

.modern-input:focus,
.modern-textarea:focus,
.modern-select:focus {
  outline: none;
  border-color: #4CAF50;
  background: white;
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
}

.form-help {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: #666;
  font-style: italic;
}

.modern-textarea {
  resize: vertical;
  min-height: 80px;
}

.form-actions {
  text-align: center;
}

.btn-primary {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Loading Spinner */
.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Data Section */
.data-section {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.section-stats {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.stat-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
}

/* Loading State */
.loading-state {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
}

.loading-state .loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4CAF50;
  margin: 0 auto 1rem;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.empty-state h4 {
  margin: 0 0 0.5rem 0;
  color: #333;
  font-size: 1.2rem;
}

.empty-state p {
  margin: 0;
  color: #6c757d;
}

/* Modern Table */
.modern-table {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  width: 100%;
}

        /* Öğretmenler tablosu için özel düzenleme */
.modern-table .table-header,
.modern-table .table-row {
  grid-template-columns: 80px 1.5fr 1.5fr 1.5fr 1.5fr 120px;
  gap: 1.5rem;
  min-width: 800px;
}

        /* Öğretmenler tablosu için genel düzenleme (ID kolonu kaldırıldı) */
.modern-table.teachers-table .table-header,
.modern-table.teachers-table .table-row {
  grid-template-columns: 200px 150px 150px 200px 150px;
  gap: 0;
  min-width: 850px;
}

        /* Dersler tablosu için grid — ID kolonu yok */
.modern-table.lessons-table .table-header,
.modern-table.lessons-table .table-row {
  grid-template-columns: 2fr 3fr 120px;
  gap: 1.5rem;
  min-width: 500px;
}

        /* Öğretmenler tablosu için özel container */
.teachers-table {
  width: 100%;
  overflow-x: auto;
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.teachers-table .table-header,
.teachers-table .table-row {
  display: grid;
  grid-template-columns: 200px 150px 150px 200px 150px;
  gap: 0;
  min-width: 850px;
  width: 100%;
}

        /* Öğretmenler tablosu için 3. sütun (Ders) genişliği — ID kaldırıldığı için nth-child kaydı */
.teachers-table .table-header .header-cell:nth-child(3),
.teachers-table .table-row .table-cell:nth-child(3) {
  width: 150px;
  min-width: 150px;
}

.teachers-table .table-cell {
  padding: 0.75rem;
  border-right: 1px solid #f1f3f4;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.teachers-table .table-cell:last-child {
  border-right: none;
  justify-content: center;
}

/* ID kolonu kaldırıldı — sütun genişlikleri grid-template-columns'ta belirleniyor.
   nth-child width kuralları kaldırıldı çünkü eski index'ler yeni layout'a uymuyordu
   (özellikle nth-child(1) 80px Ad Soyad'ı sıkıştırıyor, isimleri kesiyordu). */

        /* Öğretmenler tablosu için müsaitlik butonları — YAN YANA */
.teachers-table .availability-buttons {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.teachers-table .btn-view {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.85rem;
  font-weight: 500;
  white-space: nowrap;
}

.teachers-table .btn-view:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.teachers-table .btn-edit {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.85rem;
  font-weight: 500;
  white-space: nowrap;
}

.teachers-table .btn-edit:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(23, 162, 184, 0.3);
}

/* Lessons Table - Wide Layout */
.lessons-table {
  max-width: 1200px;
  margin: 0 auto;
}

.lessons-table .table-header,
.lessons-table .table-row {
  grid-template-columns: 80px 2fr 4fr 120px;
  gap: 2.5rem;
  padding: 2rem;
}

.table-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  display: grid;
  grid-template-columns: 80px 1.5fr 1.5fr 1.5fr 1.5fr 120px;
  gap: 1.5rem;
  padding: 1.5rem;
  border-bottom: 2px solid #dee2e6;
}

/* Yöneticiler tablosu — 4 kolon (ID kaldırıldı: Kullanıcı Adı, Ad Soyad, Tarih, İşlemler) */
.admins-list .table-header,
.admins-list .table-row {
  grid-template-columns: 1.5fr 2fr 1.5fr 120px;
  min-width: 600px;
}

.header-cell {
  font-weight: 700;
  color: #495057;
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
}

.table-row {
  display: grid;
  grid-template-columns: 80px 1.5fr 1.5fr 1.5fr 1.5fr 120px;
  gap: 1.5rem;
  padding: 1.5rem;
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.3s;
}

.table-row:hover {
  background-color: #f8f9fa;
}

.table-cell {
  display: flex;
  align-items: center;
  color: #495057;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

        /* Öğretmenler tablosu için sütun hizalama */
.modern-table .table-cell {
  justify-content: flex-start;
  padding: 0 0.5rem;
}

.modern-table .table-cell:first-child {
  justify-content: center;
}

.modern-table .table-cell:last-child {
  justify-content: center;
}

/* Yöneticiler tablosu için responsive tasarım */
.table-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-top: 1rem;
}

/* Mobilde horizontal scroll için */
@media (max-width: 768px) {
  .table-container {
    overflow-x: auto;
    overflow-y: visible;
  }
  
  .table-header,
  .table-row {
    min-width: 600px; /* Minimum tablo genişliği */
  }
  
  /* Öğretmenler tablosu için mobil düzenleme */
  .modern-table {
    overflow-x: auto;
  }
  
  .modern-table .table-header,
  .modern-table .table-row {
    min-width: 800px;
    gap: 1rem;
    padding: 1rem;
  }
  
  /* Öğretmenler tablosu için mobil düzenleme */
  .teachers-table {
    overflow-x: auto;
    margin: 0 -1rem;
  }
  
  .teachers-table .table-header,
  .teachers-table .table-row {
    min-width: 950px;
    gap: 0;
    padding: 0.75rem;
  }
  
  .teachers-table .table-cell {
    padding: 0.5rem;
    font-size: 0.9rem;
  }
  
  /* Öğretmenler tablosu için mobil buton düzenleme */
  .teachers-table .availability-buttons {
    flex-direction: column;
    gap: 0.25rem;
  }
  
  .teachers-table .btn-view,
  .teachers-table .btn-edit {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
  }
}

.table-header {
  display: grid;
  grid-template-columns: 80px 1fr 1.5fr 1.5fr 120px;
  gap: 1rem;
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
}

.table-row {
  display: grid;
  grid-template-columns: 80px 1fr 1.5fr 1.5fr 120px;
  gap: 1rem;
  padding: 1rem;
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.3s;
}

.table-row:hover {
  background-color: #f8f9fa;
}

.header-cell {
  font-weight: 600;
  color: #333;
}

.admin-username {
  font-family: 'Courier New', monospace;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 500;
}

.admin-name {
  font-weight: 600;
  color: #333;
}

.actions-cell {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

        /* Genel buton stilleri (öğretmenler tablosu hariç) */
.btn-edit:not(.teachers-table .btn-edit),
.btn-delete:not(.teachers-table .btn-delete) {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.btn-edit:not(.teachers-table .btn-edit) {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
}

.btn-edit:not(.teachers-table .btn-edit):hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(23, 162, 184, 0.3);
}

.btn-delete {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
}

.btn-delete:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

.btn-delete:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-block {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  color: white;
  border: none;
  padding: 0.4rem 0.6rem;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
  position: relative;
  overflow: hidden;
  min-width: 50px;
  width: 50px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
}

.btn-block::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn-block:hover:not(:disabled) {
  background: linear-gradient(135deg, #ee5a52 0%, #d63031 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
}

.btn-block:hover:not(:disabled)::before {
  left: 100%;
}

.btn-block:active:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
}

.btn-unblock {
  background: linear-gradient(135deg, #00b894 0%, #00a085 100%);
  color: white;
  border: none;
  padding: 0.4rem 0.6rem;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 184, 148, 0.3);
  position: relative;
  overflow: hidden;
  min-width: 50px;
  width: 50px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
}

.btn-unblock::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn-unblock:hover:not(:disabled) {
  background: linear-gradient(135deg, #00a085 0%, #008f7a 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 184, 148, 0.4);
}

.btn-unblock:hover:not(:disabled)::before {
  left: 100%;
}

.btn-unblock:active:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(0, 184, 148, 0.3);
}

/* Yöneticiler tablosu responsive tasarım */
@media (max-width: 1024px) {
  .table-header,
  .table-row {
    grid-template-columns: 60px 1fr 1.2fr 1.2fr 100px;
    gap: 0.75rem;
    padding: 0.75rem;
  }
  
  .admin-username {
    font-size: 0.8rem;
    padding: 0.2rem 0.4rem;
  }
}

/* Öğretmenler tablosu responsive tasarım */
@media (max-width: 1024px) {
  .teachers-table .table-header,
  .teachers-table .table-row {
    grid-template-columns: 60px 150px 120px 120px 150px 120px;
    gap: 0.5rem;
    min-width: 720px;
  }
}

@media (max-width: 768px) {
  .table-container {
    margin: 0 -0.5rem;
    border-radius: 8px;
  }
  
  .table-header,
  .table-row {
    grid-template-columns: 50px 1fr 1fr 1fr 80px;
    gap: 0.5rem;
    padding: 0.5rem;
  }
  
  .table-cell {
    font-size: 0.875rem;
  }
  
  .admin-username {
    font-size: 0.75rem;
    padding: 0.15rem 0.3rem;
  }
  
  .btn-edit,
  .btn-delete {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
  
  .btn-block,
  .btn-unblock {
    padding: 0.35rem 0.5rem;
    font-size: 0.7rem;
    min-width: 45px;
    width: 45px;
    height: 32px;
  }
  
  /* Öğretmenler tablosu responsive tasarım */
  .teachers-table .table-header,
  .teachers-table .table-row {
    grid-template-columns: 50px 120px 100px 100px 120px 100px;
    gap: 0.4rem;
    min-width: 590px;
  }
}

@media (max-width: 480px) {
  .table-container {
    margin: 0 -0.25rem;
    border-radius: 0;
  }
  
  .table-header,
  .table-row {
    grid-template-columns: 40px 1fr 1fr 1fr 70px;
    gap: 0.375rem;
    padding: 0.375rem;
  }
  
  .table-cell {
    font-size: 0.8rem;
  }
  
  .admin-username {
    font-size: 0.7rem;
    padding: 0.1rem 0.25rem;
  }
  
  .btn-edit,
  .btn-delete {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }
  
  .btn-block,
  .btn-unblock {
    padding: 0.3rem 0.4rem;
    font-size: 0.65rem;
    min-width: 40px;
    width: 40px;
    height: 30px;
  }
}

/* Yöneticiler sekmesi genel responsive tasarım */
@media (max-width: 768px) {
  .section-content {
    padding: 0.5rem;
  }
  
  .list-header h3 {
    font-size: 1.125rem;
    margin-bottom: 0.75rem;
  }
  
  .loading-state,
  .error-state,
  .empty-state {
    padding: 1rem;
    text-align: center;
  }
  
  .loading-state p,
  .error-state p,
  .empty-state p {
    font-size: 0.9rem;
  }
  
  .error-state h3 {
    font-size: 1.125rem;
  }
  
  .btn-retry {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    margin-top: 0.75rem;
  }
}

@media (max-width: 480px) {
  .section-content {
    padding: 0.25rem;
  }
  
  .list-header h3 {
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
  
  .loading-state,
  .error-state,
  .empty-state {
    padding: 0.75rem;
  }
  
  .loading-state p,
  .error-state p,
  .empty-state p {
    font-size: 0.85rem;
  }
  
  .error-state h3 {
    font-size: 1rem;
  }
  
  .btn-retry {
    padding: 0.375rem 0.75rem;
    font-size: 0.85rem;
    margin-top: 0.5rem;
  }
}

.lesson-name {
  font-weight: 600;
  color: #333;
}

.lesson-description {
  color: #6c757d;
  font-style: italic;
}

.teacher-name {
  font-weight: 600;
  color: #333;
}

.lesson-tag {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
  margin-right: 0.25rem;
  display: inline-block;
}

.no-lesson {
  color: #6c757d;
  font-style: italic;
}

.availability-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.btn-view {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
  border: none;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.btn-view:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(23, 162, 184, 0.3);
}

/* Availability Section */
.availability-section {
  width: 100%;
}

.availability-container {
  width: 100%;
  min-height: 500px;
  background: #f8f9fa;
  border-radius: 15px;
  padding: 2rem;
  border: 2px solid #e9ecef;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.availability-container :deep(.teacher-availability-display) {
  width: 100%;
  min-height: 500px;
}

.availability-container :deep(.availability-container) {
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.availability-container :deep(.week-selector) {
  margin-bottom: 2rem;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  width: 100%;
}

.availability-container :deep(.time-slots) {
  gap: 2rem;
  width: 100%;
  justify-content: center;
}

.availability-container :deep(.time-slot) {
  min-width: 150px;
  height: 60px;
  font-size: 1.1rem;
}

/* Availability Grid Layout */
.availability-container :deep(.availability-grid) {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

.availability-container :deep(.day-column) {
  min-width: 200px;
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.actions {
  display: flex;
  gap: 0.5rem;
}

.btn-edit,
.btn-delete {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.2rem;
  transition: all 0.3s;
}

.btn-edit:hover {
  background: #e3f2fd;
  transform: scale(1.1);
}

.btn-delete:hover {
  background: #ffebee;
  transform: scale(1.1);
}

/* Responsive tasarım */
@media (max-width: 768px) {
  .panel-header {
    padding: 1.5rem 1rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .header-content h1 {
    font-size: 2rem;
  }
  
  .header-actions {
    margin-top: 0;
  }
  
  .tab-navigation {
    padding: 1rem;
  }
  
  .tab-container {
    gap: 0.25rem;
  }
  
  .tab-button {
    min-width: 90px;
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
    border-radius: 20px;
  }
  
  .tab-content {
    padding: 1rem;
  }
  
  .action-card,
  .data-section {
    padding: 1.5rem;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .form-single-column {
    width: 100%;
  }
  
  .modern-table {
    overflow-x: auto;
  }
  
  .lessons-table {
    max-width: 100%;
  }
  
  .lessons-table .table-header,
  .lessons-table .table-row {
    grid-template-columns: 80px 1fr 2fr 100px;
    gap: 1.5rem;
    padding: 1.5rem;
    min-width: 600px;
  }
  
  .table-header,
  .table-row {
    grid-template-columns: 80px 1fr 1fr 1fr 1fr 100px;
    min-width: 800px;
  }
  
  .availability-container {
    min-height: 400px;
    padding: 1.5rem;
  }
  
  .availability-container :deep(.teacher-availability-display) {
    min-height: 400px;
  }
  
  .availability-container :deep(.availability-grid) {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 1rem;
  }
  
  .availability-container :deep(.day-column) {
    min-width: 180px;
    padding: 1rem;
  }
  
  .profile-info {
    padding: 0.75rem 1rem;
  }
  
  .profile-avatar {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .panel-header {
    padding: 1rem 0.75rem;
    gap: 0.75rem;
  }
  
  .header-content h1 {
    font-size: 1.5rem;
  }
  
  .header-subtitle {
    font-size: 1rem;
  }
  
  .header-actions {
    margin-top: 0;
  }
  
  .tab-button {
    min-width: 75px;
    padding: 0.4rem 0.6rem;
    font-size: 0.75rem;
    border-radius: 18px;
  }
  
  .section-header h2 {
    font-size: 1.5rem;
  }
  
  .action-card,
  .data-section {
    padding: 1rem;
  }
  
  .availability-container {
    min-height: 350px;
    padding: 1rem;
  }
  
  .availability-container :deep(.teacher-availability-display) {
    min-height: 350px;
  }
  
  .availability-container :deep(.availability-grid) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  
  .availability-container :deep(.day-column) {
    min-width: auto;
    padding: 0.75rem;
  }
}

/* Çok küçük ekranlar için ek responsive ayarlar */
@media (max-width: 360px) {
  .tab-navigation {
    padding: 0.5rem;
  }
  
  .tab-container {
    gap: 0.2rem;
  }
  
  .tab-button {
    min-width: 70px;
    padding: 0.35rem 0.5rem;
    font-size: 0.7rem;
    border-radius: 16px;
  }
}

/* İstatistik Stilleri */
.statistics-content {
  margin-top: 2rem;
}

/* Statistics content responsive tasarım */
@media (max-width: 768px) {
  .statistics-content {
    margin-top: 1.5rem;
  }
}

@media (max-width: 480px) {
  .statistics-content {
    margin-top: 1rem;
  }
}

.overview-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-bottom: 3rem;
}

/* Responsive grid için ek ayarlar */
@media (max-width: 1024px) {
  .overview-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
    margin-bottom: 2.5rem;
  }
}

@media (max-width: 768px) {
  .overview-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    margin-bottom: 2rem;
  }
}

@media (max-width: 480px) {
  .overview-cards {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

/* Mobil responsive stat-card */
@media (max-width: 768px) {
  .stat-card {
    padding: 1.5rem;
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .stat-card {
    padding: 1rem;
    gap: 0.75rem;
    flex-direction: column;
    text-align: center;
  }
}

.stat-icon {
  font-size: 3rem;
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: bold;
  color: #333;
}

/* Mobil responsive stat-icon ve stat-number */
@media (max-width: 768px) {
  .stat-icon {
    font-size: 2.5rem;
  }
  
  .stat-number {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .stat-icon {
    font-size: 2rem;
  }
  
  .stat-number {
    font-size: 1.8rem;
  }
}

.stat-label {
  font-size: 1rem;
  color: #666;
  margin-top: 0.25rem;
}

.total-students {
  border-left: 4px solid #2196F3;
}

.total-teachers {
  border-left: 4px solid #FF9800;
}

.total-appointments {
  border-left: 4px solid #4CAF50;
}

.current-week {
  border-left: 4px solid #9C27B0;
}

/* Chart Section */
.chart-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 3rem;
}

.chart-section h2 {
  margin-bottom: 2rem;
  color: #333;
  text-align: center;
}

.weekly-chart {
  display: flex;
  justify-content: space-around;
  align-items: end;
  gap: 1rem;
  min-height: 300px;
  padding: 2rem 0;
}

/* Mobil responsive weekly-chart */
@media (max-width: 768px) {
  .weekly-chart {
    min-height: 250px;
    padding: 1.5rem 0;
    gap: 0.75rem;
  }
  
  .chart-section {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .weekly-chart {
    min-height: 200px;
    padding: 1rem 0;
    gap: 0.5rem;
    flex-direction: column;
    align-items: center;
  }
  
  .chart-section {
    padding: 1rem;
  }
  
  .week-bar {
    width: 100%;
    max-width: 200px;
  }
}

.week-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  flex: 1;
}

.bar-container {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: end;
  justify-content: center;
}

/* Mobil responsive bar-container */
@media (max-width: 768px) {
  .bar-container {
    height: 150px;
  }
}

@media (max-width: 480px) {
  .bar-container {
    height: 120px;
  }
}

.bar {
  width: 80%;
  background: linear-gradient(135deg, #4CAF50, #45a049);
  border-radius: 8px 8px 0 0;
  min-height: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.bar-count {
  position: absolute;
  top: -25px;
  background: #333;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: bold;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Mobil responsive bar-count */
@media (max-width: 480px) {
  .bar-count {
    top: -20px;
    font-size: 0.7rem;
    padding: 1px 4px;
  }
}

.bar:hover {
  transform: scaleY(1.05);
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.week-label {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.week-number {
  font-weight: bold;
  color: #333;
  font-size: 0.9rem;
}

.week-date {
  font-size: 0.8rem;
  color: #666;
}

/* Mobil responsive week-label */
@media (max-width: 768px) {
  .week-number {
    font-size: 0.8rem;
  }
  
  .week-date {
    font-size: 0.7rem;
  }
}

@media (max-width: 480px) {
  .week-number {
    font-size: 0.75rem;
  }
  
  .week-date {
    font-size: 0.65rem;
  }
}

/* Top Performers Section */
.top-performers {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 3rem;
}

/* Mobil responsive top-performers */
@media (max-width: 768px) {
  .top-performers {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-bottom: 2rem;
  }
  
  .top-students,
  .top-teachers {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .top-performers {
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .top-students,
  .top-teachers {
    padding: 1rem;
  }
}

.top-students,
.top-teachers {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.top-students h2,
.top-teachers h2 {
  margin-bottom: 1.5rem;
  color: #333;
  text-align: center;
}

.performer-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.performer-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

/* Mobil responsive performer-item */
@media (max-width: 768px) {
  .performer-item {
    padding: 0.75rem;
    gap: 0.75rem;
  }
}

@media (max-width: 480px) {
  .performer-item {
    padding: 0.5rem;
    gap: 0.5rem;
    flex-direction: column;
    text-align: center;
  }
}

.performer-item:hover {
  background: #e9ecef;
  transform: translateX(5px);
}

.rank {
  width: 30px;
  height: 30px;
  background: #4CAF50;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.9rem;
}

/* Mobil responsive rank */
@media (max-width: 480px) {
  .rank {
    width: 25px;
    height: 25px;
    font-size: 0.8rem;
  }
}

.performer-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
}

.name {
  font-weight: bold;
  color: #333;
}

.count {
  font-size: 0.9rem;
  color: #666;
}

/* Champions Section */
.champions-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 3rem;
}

.champions-section h2 {
  margin-bottom: 2rem;
  color: #333;
  text-align: center;
}

.champions-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

/* Mobil responsive champions-grid */
@media (max-width: 768px) {
  .champions-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .champions-section {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .champions-grid {
    gap: 1rem;
  }
  
  .champions-section {
    padding: 1rem;
  }
  
  .champion-card {
    padding: 1.5rem;
  }
}

.champion-card {
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  color: white;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.champion-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
}

.champion-crown {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 2rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.champion-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.champion-info h3 {
  margin-bottom: 1rem;
  font-size: 1.2rem;
  opacity: 0.9;
}

.champion-name {
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.champion-stats .total-appointments {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: bold;
}

.student-champion {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.teacher-champion {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

/* Table Section - Accordion Style */
.table-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

/* Mobil responsive table-section */
@media (max-width: 768px) {
  .table-section {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .table-section {
    padding: 1rem;
  }
}

.table-section h2 {
  margin-bottom: 2rem;
  color: #333;
  text-align: center;
}

.weekly-accordion {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.week-accordion-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid #e0e0e0;
}

/* Accordion header responsive tasarım */
@media (max-width: 768px) {
  .accordion-header {
    padding: 1rem;
    flex-direction: column;
    gap: 0.75rem;
    align-items: stretch;
  }
  
  .week-info {
    text-align: center;
  }
  
  .week-summary {
    justify-content: center;
  }
  
  .week-number {
    font-size: 1rem;
  }
  
  .week-date {
    font-size: 0.85rem;
  }
  
  .total-count {
    font-size: 0.85rem;
    padding: 0.375rem 0.75rem;
  }
  
  .accordion-arrow {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .accordion-header {
    padding: 0.75rem;
    gap: 0.5rem;
  }
  
  .week-number {
    font-size: 0.95rem;
  }
  
  .week-date {
    font-size: 0.8rem;
  }
  
  .total-count {
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
  }
  
  .accordion-arrow {
    font-size: 1rem;
  }
}

.accordion-header:hover {
  background: #e9ecef;
}

.week-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.week-number {
  font-weight: bold;
  color: #333;
  font-size: 1.1rem;
}

.week-date {
  color: #666;
  font-size: 0.9rem;
}

.week-summary {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.total-count {
  background: #4CAF50;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: bold;
  font-size: 0.9rem;
}

.accordion-arrow {
  font-size: 1.2rem;
  color: #666;
  transition: transform 0.3s ease;
}

.accordion-arrow.expanded {
  transform: rotate(180deg);
}

.accordion-content {
  background: white;
  padding: 2rem;
}

/* Accordion content responsive tasarım */
@media (max-width: 768px) {
  .accordion-content {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .accordion-content {
    padding: 0.75rem;
  }
}

.week-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

/* Haftalık detaylar responsive tasarım */
@media (max-width: 1024px) {
  .week-details {
    gap: 1.5rem;
  }
  
  .student-stats,
  .teacher-stats {
    padding: 1.25rem;
  }
}

@media (max-width: 768px) {
  .week-details {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .student-stats,
  .teacher-stats {
    padding: 1rem;
  }
  
  .student-stats h4,
  .teacher-stats h4 {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }
  
  .stats-grid {
    gap: 0.5rem;
  }
  
  .stat-item {
    padding: 0.5rem;
    gap: 0.75rem;
  }
  
  .stat-rank {
    width: 22px;
    height: 22px;
    font-size: 0.75rem;
  }
  
  .stat-name {
    font-size: 0.85rem;
  }
  
  .stat-count {
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .week-details {
    gap: 0.75rem;
  }
  
  .student-stats,
  .teacher-stats {
    padding: 0.75rem;
  }
  
  .student-stats h4,
  .teacher-stats h4 {
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
  }
  
  .stats-grid {
    gap: 0.375rem;
  }
  
  .stat-item {
    padding: 0.375rem;
    gap: 0.5rem;
  }
  
  .stat-rank {
    width: 20px;
    height: 20px;
    font-size: 0.7rem;
  }
  
  .stat-name {
    font-size: 0.8rem;
  }
  
  .stat-count {
    font-size: 0.7rem;
  }
}

.student-stats,
.teacher-stats {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1.5rem;
}

.student-stats h4,
.teacher-stats h4 {
  margin-bottom: 1rem;
  color: #333;
  text-align: center;
  font-size: 1.1rem;
}

.stats-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem;
  background: white;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
}

.stat-rank {
  width: 25px;
  height: 25px;
  background: #4CAF50;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.8rem;
}

.stat-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
}

.stat-name {
  font-weight: bold;
  color: #333;
  font-size: 0.9rem;
}

.stat-count {
  font-size: 0.8rem;
  color: #666;
}

.no-data {
  text-align: center;
  color: #666;
  font-style: italic;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px dashed #ccc;
}

/* Loading ve Error States */
.loading-state {
  text-align: center;
  padding: 4rem;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4CAF50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-state {
  text-align: center;
  padding: 4rem;
  background: #fff5f5;
  border-radius: 12px;
  border: 1px solid #fed7d7;
}

.error-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.error-state h3 {
  color: #c53030;
  margin-bottom: 1rem;
}

.error-state p {
  color: #742a2a;
  margin-bottom: 1.5rem;
}

.btn-retry {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
}

.no-data-state {
  text-align: center;
  padding: 4rem;
  background: #f8f9fa;
  border-radius: 12px;
}

.no-data-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.no-data-state h3 {
  color: #333;
  margin-bottom: 1rem;
}

.no-data-state p {
  color: #666;
}

/* Hata Modal Stilleri */
.error-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease-out;
}

.error-modal-content {
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

.error-modal-header {
  background: linear-gradient(135deg, #ff6b6b, #ee5a52);
  color: white;
  padding: 1.5rem;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-icon {
  font-size: 2.5rem;
  margin-right: 1rem;
}

.error-modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  flex: 1;
}

.error-modal-header .modal-close {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 1.5rem;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.error-modal-header .modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-50%) scale(1.1);
}

.error-modal-body {
  padding: 2rem;
  text-align: left;
  max-height: 60vh;
  overflow-y: auto;
}

.error-content {
  width: 100%;
}

.error-main-message {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: linear-gradient(135deg, #fff5f5, #fed7d7);
  border-radius: 12px;
  border-left: 4px solid #f56565;
}

.error-main-message p {
  margin: 0;
  font-size: 1.1rem;
  color: #c53030;
  line-height: 1.6;
  font-weight: 500;
}

.error-details {
  margin-top: 1.5rem;
}

.error-details h4 {
  color: #2d3748;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e2e8f0;
}

.error-details-list {
  max-height: 300px;
  overflow-y: auto;
  background: #f7fafc;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #e2e8f0;
}

.error-detail-item {
  display: flex;
  align-items: flex-start;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  background: white;
  border-radius: 6px;
  border-left: 3px solid #f56565;
  transition: all 0.2s ease;
}

.error-detail-item:hover {
  background: #fff5f5;
  transform: translateX(2px);
}

.error-detail-item:last-child {
  margin-bottom: 0;
}

.error-detail-number {
  background: #f56565;
  color: white;
  font-size: 0.8rem;
  font-weight: 600;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.error-detail-text {
  color: #4a5568;
  font-size: 0.9rem;
  line-height: 1.5;
  flex: 1;
  word-break: break-word;
}

.error-modal-actions {
  padding: 1.5rem;
  text-align: center;
  border-top: 1px solid #eee;
}

.error-modal-actions .btn-primary {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.error-modal-actions .btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { 
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to { 
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Başarı İşlem Popup Stilleri */
.success-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2500;
  animation: fadeIn 0.3s ease-out;
}

.success-popup {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  max-width: 450px;
  width: 90%;
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

.success-popup-header {
  background: linear-gradient(135deg, #4CAF50, #45a049);
  color: white;
  padding: 2rem 2rem 1.5rem;
  text-align: center;
}

.success-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.success-popup-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.success-popup-body {
  padding: 2rem;
  text-align: center;
}

.success-popup-body p {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
  line-height: 1.6;
}

.success-popup-actions {
  padding: 1.5rem 2rem 2rem;
  text-align: center;
  border-top: 1px solid #eee;
}

.btn-success {
  background: linear-gradient(135deg, #4CAF50, #45a049);
  color: white;
  border: none;
  padding: 0.875rem 2.5rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(76, 175, 80, 0.4);
}

.btn-success:active {
  transform: translateY(0);
}

/* Mobil responsive */
@media (max-width: 768px) {
  .success-popup {
    max-width: 90%;
    margin: 1rem;
  }
  
  .success-popup-header {
    padding: 1.5rem 1.5rem 1rem;
  }
  
  .success-icon {
    font-size: 3rem;
  }
  
  .success-popup-header h3 {
    font-size: 1.3rem;
  }
  
  .success-popup-body {
    padding: 1.5rem;
  }
  
  .success-popup-actions {
    padding: 1rem 1.5rem 1.5rem;
  }
  
  .btn-success {
    padding: 0.75rem 2rem;
    font-size: 0.95rem;
  }
}

/* Silme Onay Popup Stilleri */
.delete-confirm-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  animation: fadeIn 0.3s ease-out;
}

.delete-confirm-popup {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  max-width: 500px;
  width: 90%;
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

.delete-confirm-popup-header {
  background: linear-gradient(135deg, #ff9800, #f57c00);
  color: white;
  padding: 2rem 2rem 1.5rem;
  text-align: center;
}

.delete-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.delete-confirm-popup-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.delete-confirm-popup-body {
  padding: 2rem;
  text-align: center;
}

.delete-confirm-popup-body p {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  color: #333;
  line-height: 1.6;
}

.delete-confirm-popup-body p:last-child {
  margin-bottom: 0;
}

.warning-text {
  color: #d32f2f !important;
  font-weight: 500;
  font-size: 1rem !important;
  background-color: #ffebee;
  padding: 1rem;
  border-radius: 8px;
  border-left: 4px solid #d32f2f;
}

.delete-confirm-popup-actions {
  padding: 1.5rem 2rem 2rem;
  text-align: center;
  border-top: 1px solid #eee;
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn-cancel {
  background: #f5f5f5;
  color: #666;
  border: 2px solid #ddd;
  padding: 0.875rem 2rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.btn-cancel:hover {
  background: #e0e0e0;
  border-color: #ccc;
  transform: translateY(-1px);
}

.btn-delete-confirm {
  background: linear-gradient(135deg, #f44336, #d32f2f);
  color: white;
  border: none;
  padding: 0.875rem 2rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.3);
  min-width: 120px;
}

.btn-delete-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(244, 67, 54, 0.4);
}

.btn-delete-confirm:active {
  transform: translateY(0);
}

/* Mobil responsive */
@media (max-width: 768px) {
  .delete-confirm-popup {
    max-width: 90%;
    margin: 1rem;
  }
  
  .delete-confirm-popup-header {
    padding: 1.5rem 1.5rem 1rem;
  }
  
  .delete-icon {
    font-size: 3rem;
  }
  
  .delete-confirm-popup-header h3 {
    font-size: 1.3rem;
  }
  
  .delete-confirm-popup-body {
    padding: 1.5rem;
  }
  
  .delete-confirm-popup-actions {
    padding: 1rem 1.5rem 1.5rem;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .btn-cancel,
  .btn-delete-confirm {
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
    min-width: auto;
  }
}

/* Randevu İptal Onay Popup Stilleri */
.cancel-appointment-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  animation: fadeIn 0.3s ease-out;
}

.cancel-appointment-popup {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  max-width: 550px;
  width: 90%;
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

.cancel-appointment-popup-header {
  background: linear-gradient(135deg, #ff5722, #e64a19);
  color: white;
  padding: 2rem 2rem 1.5rem;
  text-align: center;
}

.cancel-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.cancel-appointment-popup-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.cancel-appointment-popup-body {
  padding: 2rem;
  text-align: center;
}

.appointment-info {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: left;
}

.appointment-info p {
  margin: 0.5rem 0;
  font-size: 1rem;
  color: #333;
}

.appointment-info strong {
  color: #555;
  font-weight: 600;
}

.cancel-appointment-popup-body .warning-text {
  color: #d32f2f !important;
  font-weight: 500;
  font-size: 1rem !important;
  background-color: #ffebee;
  padding: 1rem;
  border-radius: 8px;
  border-left: 4px solid #d32f2f;
  margin: 0;
}

.cancel-appointment-popup-actions {
  padding: 1.5rem 2rem 2rem;
  text-align: center;
  border-top: 1px solid #eee;
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn-cancel-confirm {
  background: linear-gradient(135deg, #ff5722, #e64a19);
  color: white;
  border: none;
  padding: 0.875rem 2rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 87, 34, 0.3);
  min-width: 120px;
}

.btn-cancel-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(255, 87, 34, 0.4);
}

.btn-cancel-confirm:active {
  transform: translateY(0);
}

/* Mobil responsive */
@media (max-width: 768px) {
  .cancel-appointment-popup {
    max-width: 90%;
    margin: 1rem;
  }
  
  .cancel-appointment-popup-header {
    padding: 1.5rem 1.5rem 1rem;
  }
  
  .cancel-icon {
    font-size: 3rem;
  }
  
  .cancel-appointment-popup-header h3 {
    font-size: 1.3rem;
  }
  
  .cancel-appointment-popup-body {
    padding: 1.5rem;
  }
  
  .appointment-info {
    padding: 1rem;
  }
  
  .cancel-appointment-popup-actions {
    padding: 1rem 1.5rem 1.5rem;
    flex-direction: column;
    gap: 0.75rem;
  }
  
      .btn-cancel,
    .btn-cancel-confirm {
      padding: 0.75rem 1.5rem;
      font-size: 0.95rem;
      min-width: auto;
    }
  }

/* Çıkış Onay Popup Stilleri */
.logout-confirm-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  animation: fadeIn 0.3s ease-out;
}

.logout-confirm-popup {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  max-width: 500px;
  width: 90%;
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

.logout-confirm-popup-header {
  background: linear-gradient(135deg, #9c27b0, #673ab7);
  color: white;
  padding: 2rem 2rem 1.5rem;
  text-align: center;
}

.logout-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.logout-confirm-popup-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.logout-confirm-popup-body {
  padding: 2rem;
  text-align: center;
}

.logout-confirm-popup-body p {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  color: #333;
}

.logout-confirm-popup-body .warning-text {
  color: #d32f2f !important;
  font-weight: 500;
  font-size: 1rem !important;
  background-color: #ffebee;
  padding: 1rem;
  border-radius: 8px;
  border-left: 4px solid #d32f2f;
  margin: 0;
}

.logout-confirm-popup-actions {
  padding: 1.5rem 2rem 2rem;
  text-align: center;
  border-top: 1px solid #eee;
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn-logout-confirm {
  background: linear-gradient(135deg, #9c27b0, #673ab7);
  color: white;
  border: none;
  padding: 0.875rem 2rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(156, 39, 176, 0.3);
  min-width: 120px;
}

.btn-logout-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(156, 39, 176, 0.4);
}

.btn-logout-confirm:active {
  transform: translateY(0);
}

/* Mobil responsive */
@media (max-width: 768px) {
  .logout-confirm-popup {
    max-width: 90%;
    margin: 1rem;
  }
  
  .logout-confirm-popup-header {
    padding: 1.5rem 1.5rem 1rem;
  }
  
  .logout-icon {
    font-size: 3rem;
  }
  
  .logout-confirm-popup-header h3 {
    font-size: 1.3rem;
  }
  
  .logout-confirm-popup-body {
    padding: 1.5rem;
  }
  
  .logout-confirm-popup-actions {
    padding: 1rem 1.5rem 1.5rem;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .btn-logout-confirm {
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
    min-width: auto;
  }
}

/* Liste Header Stilleri */
.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.list-header h3 {
  margin: 0;
  color: #ffffff !important;
  font-size: 1.5rem;
  font-weight: 600;
}

.header-buttons {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.export-button {
  background: linear-gradient(135deg, #2196f3, #1976d2);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
  display: flex;
  align-items: center;
  gap: 0.75rem;
  white-space: nowrap;
  min-width: 200px;
  justify-content: center;
}

.export-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(33, 150, 243, 0.4);
  background: linear-gradient(135deg, #1976d2, #1565c0);
}

.export-button:active {
  transform: translateY(0);
}

.export-button:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  opacity: 0.7;
}

.export-icon {
  font-size: 1.2rem;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
}

.delete-all-button {
  background: linear-gradient(135deg, #f44336, #d32f2f);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.3);
  display: flex;
  align-items: center;
  gap: 0.75rem;
  white-space: nowrap;
  min-width: 180px;
  justify-content: center;
}

.delete-all-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(244, 67, 54, 0.4);
  background: linear-gradient(135deg, #d32f2f, #c62828);
}

.delete-all-button:active {
  transform: translateY(0);
}

.delete-all-button:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  opacity: 0.7;
}

/* Responsive Tasarım */
@media (max-width: 1024px) {
  .list-header {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
  
  .header-buttons {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .export-button,
  .delete-all-button {
    min-width: auto;
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .list-header h3 {
    font-size: 1.25rem;
    text-align: center;
  }
  
  .export-button,
  .delete-all-button {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
  }
  
  .export-button span:not(.export-icon),
  .delete-all-button span:not(.delete-icon) {
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .list-header {
    margin-bottom: 1rem;
  }
  
  .export-button,
  .delete-all-button {
    padding: 0.625rem 0.875rem;
    font-size: 0.8rem;
  }
  
  .export-icon,
  .delete-icon {
    font-size: 1rem;
  }
}

.delete-icon {
  font-size: 1.2rem;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
}

.delete-all-confirm {
  background: linear-gradient(135deg, #f44336, #d32f2f) !important;
}

.delete-all-confirm:hover {
  background: linear-gradient(135deg, #d32f2f, #c62828) !important;
}

/* Toplu Yükleme Stilleri */
.bulk-upload-container {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.bulk-upload-container h3 {
  color: #333;
  margin: 0 0 1.5rem 0;
  font-size: 1.5rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.bulk-upload-info p {
  color: #666;
  margin: 0 0 1.5rem 0;
  font-size: 1rem;
  line-height: 1.6;
}

.excel-template-info {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  border-left: 4px solid #2196f3;
}

.excel-template-info h4 {
  color: #1976d2;
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.excel-template-info ul {
  margin: 0;
  padding-left: 1.5rem;
  color: #555;
}

.excel-template-info li {
  margin-bottom: 0.5rem;
  line-height: 1.5;
}

.excel-template-info strong {
  color: #333;
  font-weight: 600;
}

.file-upload-section {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.file-input {
  flex: 1;
  min-width: 200px;
  padding: 0.75rem;
  border: 2px dashed #ddd;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
  transition: all 0.3s ease;
}

.file-input:hover {
  border-color: #2196f3;
  background: #f0f8ff;
}

.file-input:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
}

.upload-button {
  background: linear-gradient(135deg, #4caf50, #45a049);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  min-width: 120px;
  white-space: nowrap;
}

.upload-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(76, 175, 80, 0.4);
}

.upload-button:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.selected-file {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: #e8f5e8;
  border: 1px solid #4caf50;
  border-radius: 8px;
  padding: 1rem;
  color: #2e7d32;
  font-weight: 500;
}

.clear-file-btn {
  background: #f44336;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: all 0.3s ease;
}

.clear-file-btn:hover {
  background: #d32f2f;
  transform: scale(1.1);
}

/* Panel Header Responsive Tasarım */

/* Tablet (≤1024px) */
@media (max-width: 1024px) {
  .panel-header {
    padding: 1.25rem 1.5rem;
  }
  
  .header-logo {
    width: 100px;
    height: 40px;
  }
  
  .header-title-section h1 {
    font-size: 1.8rem;
  }
  
  .header-subtitle {
    font-size: 1rem;
  }
  
  .profile-info {
    padding: 0.875rem 1.25rem;
  }
  
  .profile-avatar {
    width: 40px;
    height: 40px;
    font-size: 1.1rem;
  }
  
  .profile-name {
    font-size: 0.9rem;
  }
  
  .profile-role {
    font-size: 0.8rem;
  }
}

@media (max-width: 768px) {
  .panel-header {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  
  .header-content {
    align-items: center;
    text-align: center;
  }
  
  .logo-section {
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
    justify-content: center;
  }
  
  .header-logo {
    width: 500px;
    height: 150px;
  }
  
  .header-title-section {
    position: static;
    transform: none;
    margin: 0.5rem 0;
  }
  
  .header-title-section h1 {
    font-size: 1.5rem;
  }
  
  .header-subtitle {
    font-size: 0.9rem;
    text-align: center;
  }
  
  .header-actions {
    justify-content: center;
    margin-top: 0.5rem;
  }
  
  .profile-info {
    padding: 0.75rem 1rem;
    justify-content: center;
    width: fit-content;
    margin: 0 auto;
  }
  
  .profile-avatar {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
  
  .profile-name {
    font-size: 0.85rem;
  }
  
  .profile-role {
    font-size: 0.75rem;
  }
  
  .list-header {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }
  
  .export-button {
    width: 100%;
    justify-content: center;
    min-width: auto;
  }
  
  .bulk-upload-container {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  .bulk-upload-container h3 {
    font-size: 1.3rem;
  }
  
  .file-upload-section {
    flex-direction: column;
    align-items: stretch;
  }
  
  .file-input {
    min-width: auto;
  }
  
  .upload-button {
    width: 100%;
    min-width: auto;
  }
  
  .excel-template-info {
    padding: 1rem;
  }
  
  .excel-template-info ul {
    padding-left: 1rem;
  }
}

/* Küçük Mobil (≤480px) */
@media (max-width: 480px) {
  .panel-header {
    padding: 0.75rem;
    gap: 0.75rem;
  }
  
  .header-logo {
    width: 400px;
    height: 120px;
  }
  
  .header-title-section h1 {
    font-size: 1.25rem;
  }
  
  .header-subtitle {
    font-size: 0.8rem;
  }
  
  .profile-info {
    padding: 0.5rem 0.75rem;
    gap: 0.75rem;
  }
  
  .profile-avatar {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }
  
  .profile-name {
    font-size: 0.8rem;
  }
  
  .profile-role {
    font-size: 0.7rem;
  }
}

/* Gelişmiş İstatistik Filtreleme CSS */
.advanced-statistics-section {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-top: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.advanced-statistics-section h2 {
  color: #333;
  margin: 0 0 0.5rem 0;
  font-size: 1.75rem;
  font-weight: 600;
}

.advanced-statistics-section p {
  color: #666;
  margin: 0 0 2rem 0;
  font-size: 1rem;
}

.filter-controls {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid #e9ecef;
}

.filter-row {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.filter-row:last-child {
  margin-bottom: 0;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 200px;
  flex: 1;
}

.filter-group label {
  font-weight: 600;
  color: #333;
  font-size: 0.9rem;
}

.filter-input,
.filter-select {
  padding: 0.75rem;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
}

.filter-input:focus,
.filter-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.btn-clear-filters {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-clear-filters:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

.btn-apply-filters {
  background: #667eea;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-apply-filters:hover {
  background: #5a67d8;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.export-buttons {
  display: flex;
  gap: 1rem;
}

.btn-export-excel {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
}

.btn-export-excel:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.btn-export-excel:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.filtered-results {
  margin-top: 2rem;
}

.results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.results-header h3 {
  color: #333;
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.results-count {
  background: #e3f2fd;
  color: #1976d2;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

.results-table-container {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.results-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.results-table th {
  background: #f8f9fa;
  color: #333;
  font-weight: 600;
  padding: 1rem;
  text-align: left;
  border-bottom: 2px solid #e9ecef;
}

.results-table td {
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  vertical-align: middle;
}

.results-table tr:hover {
  background: #f8f9fa;
}

.user-type-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  display: inline-block;
}

.user-type-badge.student {
  background: #e3f2fd;
  color: #1976d2;
}

.user-type-badge.teacher {
  background: #f3e5f5;
  color: #7b1fa2;
}

.appointment-count {
  font-weight: 600;
  color: #333;
  font-size: 1.1rem;
}

.absent-count {
  font-weight: 600;
  color: red;
  font-size: 1.1rem;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  display: inline-block;
}

.absent-count-na {
  color: #9e9e9e;
  font-style: italic;
  font-size: 0.9rem;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.btn-pagination {
  background: #667eea;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-pagination:hover:not(:disabled) {
  background: #5a67d8;
  transform: translateY(-1px);
}

.btn-pagination:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  transform: none;
}

.btn-first-page {
  background: linear-gradient(135deg, #17a2b8, #138496);
}

.btn-first-page:hover:not(:disabled) {
  background: linear-gradient(135deg, #138496, #117a8b);
  box-shadow: 0 4px 12px rgba(23, 162, 184, 0.3);
}

.btn-last-page {
  background: linear-gradient(135deg, #17a2b8, #138496);
}

.btn-last-page:hover:not(:disabled) {
  background: linear-gradient(135deg, #138496, #117a8b);
  box-shadow: 0 4px 12px rgba(23, 162, 184, 0.3);
}

.page-info {
  color: #666;
  font-size: 0.9rem;
  font-weight: 500;
}

.no-results {
  text-align: center;
  padding: 3rem 2rem;
  color: #666;
}

.no-results-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.no-results h4 {
  color: #333;
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
}

.no-results p {
  margin: 0;
  font-size: 1rem;
}

/* Responsive Tasarım */
@media (max-width: 1024px) {
  .filter-row {
    flex-direction: column;
    gap: 1rem;
  }
  
  .filter-group {
    min-width: auto;
  }
  
  .filter-actions {
    flex-direction: column;
    align-items: stretch;
  }
  
  .export-buttons {
    justify-content: center;
  }
  
  .results-table {
    font-size: 0.8rem;
  }
  
  .results-table th,
  .results-table td {
    padding: 0.75rem 0.5rem;
  }
}

@media (max-width: 768px) {
  .advanced-statistics-section {
    padding: 1.5rem;
  }
  
  .filter-controls {
    padding: 1rem;
  }
  
  .results-header {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }
  
  .results-table-container {
    overflow-x: auto;
  }
  
  .results-table {
    min-width: 600px;
  }
  
  .pagination {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .btn-first-page,
  .btn-last-page {
    font-size: 0.8rem;
    padding: 0.5rem 0.75rem;
  }
}

@media (max-width: 480px) {
  .advanced-statistics-section {
    padding: 1rem;
  }
  
  .filter-controls {
    padding: 0.75rem;
  }
  
  .filter-group label {
    font-size: 0.85rem;
  }
  
  .filter-input,
  .filter-select {
    padding: 0.625rem;
    font-size: 0.9rem;
  }
  
  .btn-export-excel {
    padding: 0.625rem 1rem;
    font-size: 0.85rem;
  }
}

/* Sistem Yönetimi Sekmesi Stilleri */
.system-overview {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

.info-card, .action-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #4CAF50;
}

.info-card h3, .action-card h3 {
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1.1rem;
}

.info-card p {
  color: #666;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.status-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background: #f8f9fa;
  border-radius: 4px;
}

.status-label {
  color: #666;
  font-size: 0.9rem;
}

.status-value {
  color: #4CAF50;
  font-weight: 600;
  font-size: 1rem;
}

.status-value.countdown {
  color: #ff9800;
  font-weight: 700;
}

.status-value.status-preparing {
  color: #ff9800;
}

.status-value.status-ready {
  color: #4CAF50;
}

.status-value.status-maintenance {
  color: #f44336;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
}

.reset-button, .refresh-button, .ready-button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1rem;
}



.refresh-button {
  background: #2196F3;
  color: white;
}

.refresh-button:hover:not(:disabled) {
  background: #1976D2;
  transform: translateY(-1px);
}

.refresh-button:disabled {
  background: #ccc;
  cursor: not-allowed;
}



.system-management-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
  align-items: start;
}

.reset-info {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.reset-info h3 {
  margin: 0 0 1.5rem 0;
  color: #333;
  font-size: 1.2rem;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  height: 100%;
}

.info-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1.5rem;
  border-left: 4px solid #4CAF50;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.info-item h4 {
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1.1rem;
}

.info-item p {
  color: #666;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.info-item ul {
  margin: 0;
  padding-left: 1.5rem;
  color: #666;
}

.info-item li {
  margin-bottom: 0.5rem;
  line-height: 1.4;
}

.loading {
  text-align: center;
  padding: 2rem;
  color: #666;
  font-style: italic;
}

/* Responsive Tasarım */
@media (max-width: 768px) {
  .system-overview {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .system-management-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
    height: auto;
  }
  

}

/* Admin Appointment Booking Styles */
.admin-appointment-form {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 1.5rem;
}

.form-header {
  text-align: center;
  margin-bottom: 2rem;
}

.form-header h3 {
  color: #333;
  font-size: 1.5rem;
  margin: 0 0 0.5rem 0;
}

.form-header p {
  color: #666;
  margin: 0;
  font-size: 1rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.modern-input, .modern-select {
  padding: 0.75rem;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
}

.modern-input:focus, .modern-select:focus {
  outline: none;
  border-color: #4CAF50;
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
}

.modern-input:disabled, .modern-select:disabled {
  background: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

.date-help-text {
  color: #666;
  font-size: 0.85rem;
  margin-top: 0.25rem;
  font-style: italic;
}

.student-info {
  margin-top: 0.5rem;
  padding: 0.75rem;
  background: #f0f8ff;
  border-radius: 6px;
  border-left: 4px solid #2196F3;
}

.student-name {
  display: block;
  font-weight: 600;
  color: #1976D2;
  font-size: 1rem;
}

.student-class {
  display: block;
  color: #666;
  font-size: 0.9rem;
  margin-top: 0.25rem;
}

.appointment-summary {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 2rem 0;
  border-left: 4px solid #4CAF50;
}

.appointment-summary h4 {
  color: #333;
  margin: 0 0 1rem 0;
  font-size: 1.2rem;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.summary-label {
  font-weight: 600;
  color: #666;
  font-size: 0.9rem;
}

.summary-value {
  color: #333;
  font-size: 1rem;
}

.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
}

.btn-primary, .btn-secondary {
  padding: 0.875rem 2rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;
}

.btn-primary {
  background: #4CAF50;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #45a049;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

/* Responsive Admin Appointment */
@media (max-width: 768px) {
  .admin-appointment-form {
    padding: 1.5rem;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .form-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .btn-primary, .btn-secondary {
    width: 100%;
    max-width: 300px;
  }
}

/* ─── Slot Ayarları Sekmesi ─────────────────────────────────── */
.slot-settings-form {
  /* max-width kaldırıldı: Sistem Yönetimi grid'iyle aynı genişlikte
     (parent .tab-content) render edilsin, kartlar hizalansın. */
  width: 100%;
}

.slot-settings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
  align-items: start;
}

.subsection-title {
  margin-top: 2.5rem;
  color: #ffffff;
  font-size: 1.75rem;
}

.subsection-desc {
  margin: -0.75rem 0 1.5rem;
  color: rgba(255, 255, 255, 0.85);
  font-size: 1rem;
}

@media (max-width: 768px) {
  .slot-settings-grid {
    grid-template-columns: 1fr;
  }
}

.settings-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.settings-card h3 {
  margin: 0 0 16px 0;
  color: #2c3e50;
  font-size: 1.1rem;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 8px;
}

.settings-card .form-group {
  margin-bottom: 12px;
}

.settings-card .form-group label {
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
  color: #4a4a4a;
  font-size: 0.9rem;
}

.settings-card .form-group input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.95rem;
}

.settings-card .form-group input:focus {
  outline: none;
  border-color: #4caf50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
}

.settings-info {
  background: #e3f2fd;
  border: 1px solid #64b5f6;
  border-left: 4px solid #1976d2;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 20px;
  color: #0d47a1;
  line-height: 1.5;
}

.settings-warning {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 20px;
  color: #856404;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.form-actions .btn-primary {
  background: #4caf50;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}

.form-actions .btn-primary:hover:not(:disabled) {
  background: #45a049;
}

.form-actions .btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* Slot Ayarları modal — İptal / Kaydet dialog */
.slot-settings-form + .modal-overlay,
.tab-content > .modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
}

.tab-content > .modal-overlay .modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 28px 32px;
  max-width: 480px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.2s ease-out;
}

@keyframes modalSlideIn {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

.tab-content > .modal-overlay .modal-content h3 {
  margin: 0 0 12px 0;
  color: #2c3e50;
  font-size: 1.25rem;
  font-weight: 600;
}

.tab-content > .modal-overlay .modal-content p {
  margin: 0 0 24px 0;
  color: #555;
  line-height: 1.5;
}

.tab-content > .modal-overlay .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.tab-content > .modal-overlay .btn-secondary {
  background: #f0f0f0;
  color: #555;
  border: 1px solid #d0d0d0;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 0.2s;
}

.tab-content > .modal-overlay .btn-secondary:hover {
  background: #e0e0e0;
}

.tab-content > .modal-overlay .btn-danger {
  background: #dc3545;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.tab-content > .modal-overlay .btn-danger:hover {
  background: #c82333;
}
</style> 